var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobApplied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 573.301,
    height: 395.335,
    viewBox: "0 0 573.301 395.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jobApplied",
    transform: "translate(-74.62 -245.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55058",
    "data-name": "Path 55058",
    d: "M1652.871,958.412l-1.2-42.625a3.135,3.135,0,0,1-1.692-2.733,3.177,3.177,0,0,1,3.161-3.194,3.271,3.271,0,0,1,.834.112l58.808-60.13a3.16,3.16,0,0,1-.3-1.293,3.092,3.092,0,0,1,.579-1.836l-85.61-112.559c.884-.459,1.768-.913,2.657-1.386l85.643,112.6a3.155,3.155,0,0,1-.038,6.309,3.469,3.469,0,0,1-.539-.05l-59,60.329a3.078,3.078,0,0,1-1.549,3.864l1.2,42.564.077,2.718.084,2.957a1.479,1.479,0,0,1-1.439,1.518h-.023a1.479,1.479,0,0,1-1.495-1.434l-.085-3.018Z",
    transform: "translate(-1070.959 -336.241)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55059",
    "data-name": "Path 55059",
    d: "M1654.986,1468.559c14.124,0,25.307,1.881,25.333,4.333.029,2.555-12.082,4.762-27.046,4.929s-27.125-1.772-27.154-4.327c-.028-2.49,11.475-4.649,25.909-4.912l.085,3.018a1.479,1.479,0,0,0,1.495,1.434h.023a1.479,1.479,0,0,0,1.439-1.518Z",
    transform: "translate(-1070.04 -843.704)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55060",
    "data-name": "Path 55060",
    d: "M1466.783,696.649c7.238,11.2,8.8,23.063,3.486,26.492s-15.485-2.865-22.718-14.068-8.8-23.063-3.486-26.492S1459.55,685.446,1466.783,696.649Z",
    transform: "translate(-942.307 -300.983)",
    fill: "#297ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55061",
    "data-name": "Path 55061",
    d: "M937.363,1231.968l-2.8,13.668a4.128,4.128,0,0,1-3.965,3.287l-192.37,1.759a2.3,2.3,0,0,1-2.237-2.975,4.243,4.243,0,0,1,4.01-2.993l68.346-.759,22.243-104.917a8.354,8.354,0,0,1,7.985-6.617l113.74-2.556a4.8,4.8,0,0,1,4.809,5.773Z",
    transform: "translate(-456.063 -610.111)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55062",
    "data-name": "Path 55062",
    d: "M882.165,279.915c.494,3.6-.337,7.543-2.939,10.076a7.943,7.943,0,0,1-2.859,1.764,7.053,7.053,0,0,1-7.017-1.031l-.014-.033a9.816,9.816,0,0,0,3.7-3.224c2.316-3.433,2.552-7.89,1.847-11.968a18.883,18.883,0,0,0-.981-3.635,6.476,6.476,0,0,1,5.743,2.159A10.875,10.875,0,0,1,882.165,279.915Z",
    transform: "translate(-548.1 -18.308)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55063",
    "data-name": "Path 55063",
    d: "M817.92,325.116a22.658,22.658,0,0,0,4.182-1.4l.043.093a6.232,6.232,0,0,1-1.411,3.577,6.1,6.1,0,0,1-1.934,1.575h-.019A13.408,13.408,0,0,0,817.92,325.116Z",
    transform: "translate(-512.64 -54.124)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55064",
    "data-name": "Path 55064",
    d: "M818.857,261.347c.25,3.142.03,6.491-1.719,9.112a7.4,7.4,0,0,1-2.046,2.044,6.081,6.081,0,0,1-5.968.754,6.232,6.232,0,0,0,1.411-3.577l-.043-.093a10.536,10.536,0,0,0,2.875-1.946c1.884-1.846,2.8-4.912,1.483-7.191a3.049,3.049,0,0,0-1.931-1.537,4.481,4.481,0,0,0-2.229.315c-.858.276-1.721.548-2.579.824a25.111,25.111,0,0,0-2.932-7.371,10.436,10.436,0,0,0-4.094-3.68v0l.041-.08c2.614-2.243,5.952-4.283,9.311-3.52a8.284,8.284,0,0,1,5.09,4.057,18.4,18.4,0,0,1,1.838,4.15A35.494,35.494,0,0,1,818.857,261.347Z",
    transform: "translate(-501.03)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55065",
    "data-name": "Path 55065",
    d: "M857.962,259.2a18.89,18.89,0,0,1,.981,3.635c.705,4.078.469,8.536-1.847,11.968a9.817,9.817,0,0,1-3.7,3.224,7.807,7.807,0,0,1-7.1.228l-.076-.107a7.4,7.4,0,0,0,2.046-2.044c1.749-2.622,1.969-5.97,1.719-9.112a35.494,35.494,0,0,0-1.49-7.742,18.4,18.4,0,0,0-1.838-4.15l.4-.252c2.073-2.115,5.807-1.735,8.07.172A10.153,10.153,0,0,1,857.962,259.2Z",
    transform: "translate(-532.158 -5.641)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55066",
    "data-name": "Path 55066",
    d: "M772.521,266.8c.858-.276,1.721-.548,2.579-.824a4.481,4.481,0,0,1,2.229-.315,3.05,3.05,0,0,1,1.931,1.537c1.322,2.278.4,5.345-1.483,7.191a10.535,10.535,0,0,1-2.875,1.946,22.66,22.66,0,0,1-4.182,1.4,13.41,13.41,0,0,1,.861,3.842h.019a7.782,7.782,0,0,1,7.9-2.33l.076.107a7.807,7.807,0,0,0,7.1-.228l.014.033a7.053,7.053,0,0,0,7.017,1.031l.029.084a13.3,13.3,0,0,1-.479,6.609c-1,2.964-3.018,5.518-3.879,8.523a13.32,13.32,0,0,0-.125,6.4,86.48,86.48,0,0,1-30.335-2.073l.009-.047c-1.029-5.445-3.8-10.37-6.082-15.427s-4.1-10.624-3.066-16.069a18.42,18.42,0,0,1,5.864-10.075c1.923-1.739,4.336-3.165,6.929-3.1a7.255,7.255,0,0,1,2.924.726v0a10.436,10.436,0,0,1,4.094,3.68A25.113,25.113,0,0,1,772.521,266.8Z",
    transform: "translate(-465.439 -6.745)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55067",
    "data-name": "Path 55067",
    d: "M181.577,334.823a17.773,17.773,0,0,0-1.608,4.407,5.526,5.526,0,0,1-3.853-1.792l-.085-.046a11.98,11.98,0,0,0,.713-1.553A29.876,29.876,0,0,0,181.577,334.823Z",
    transform: "translate(-69.942 -61.787)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55068",
    "data-name": "Path 55068",
    d: "M105.98,283.329a5.133,5.133,0,0,1,1.163.666,9.6,9.6,0,0,1,2.467,3.389,53.02,53.02,0,0,1,3.783,9.837c.688,2.515,1.109,5.458-.488,7.517a.812.812,0,0,1-.06.071c-1.616,2-4.514,2.306-7.106,2.339a2.876,2.876,0,0,0,.275-.565,6.417,6.417,0,0,0,.157-3.086A26.141,26.141,0,0,0,100.84,290.8a6.744,6.744,0,0,0-2.3-2.052l.1-.2c.248-2.146.993-4.153,3.083-5.14A5.368,5.368,0,0,1,105.98,283.329Z",
    transform: "translate(-16.496 -25.996)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55069",
    "data-name": "Path 55069",
    d: "M705.394,773.043a2.529,2.529,0,1,1-2.5,2.56A2.53,2.53,0,0,1,705.394,773.043Z",
    transform: "translate(-433.309 -364.019)",
    fill: "#20140f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55070",
    "data-name": "Path 55070",
    d: "M167.331,268.755a24.158,24.158,0,0,1,6.72,10.478v0a21.991,21.991,0,0,0-2.282.147l-8.578.872c-.369.037-.748.083-1.131.139a24.224,24.224,0,0,0-3.234-7.171,15.488,15.488,0,0,0-1.718-2.185l.19-.185a8.56,8.56,0,0,1,5.791-3.588,4.716,4.716,0,0,1,2.257.143A5.939,5.939,0,0,1,167.331,268.755Z",
    transform: "translate(-56.89 -15.146)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55071",
    "data-name": "Path 55071",
    d: "M589.612,718.04a1.911,1.911,0,0,1,.726,2.187,1.953,1.953,0,0,1-1.328.993,8.282,8.282,0,0,1-1.7.155,8.279,8.279,0,0,0-4.4,1.284c-.669.461-1.242,1.057-1.949,1.454a2.232,2.232,0,0,1-2.311.068,1.954,1.954,0,0,1-.595-2.123,4.239,4.239,0,0,1,1.355-1.887,11.089,11.089,0,0,1,8.712-2.666C588.111,717.364,588.956,717.537,589.612,718.04Z",
    transform: "translate(-347.144 -325.651)",
    fill: "#323b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55072",
    "data-name": "Path 55072",
    d: "M136.985,291.915a8.368,8.368,0,0,0,2.852.207,11.98,11.98,0,0,1-.713,1.553,8.657,8.657,0,0,1-3.787,3.767,5.818,5.818,0,0,1-5.85-.478l-.1-.083a.819.819,0,0,0,.06-.071c1.6-2.058,1.175-5,.488-7.517a53.019,53.019,0,0,0-3.783-9.837,9.6,9.6,0,0,0-2.467-3.389,5.133,5.133,0,0,0-1.163-.666,8.947,8.947,0,0,1,3.442-3.539,5.838,5.838,0,0,1,5.223.447,9.16,9.16,0,0,1,2.068,1.652,15.488,15.488,0,0,1,1.718,2.185,24.225,24.225,0,0,1,3.234,7.171c-1.92.288-3.879.895-4.726,2.57C132.279,288.266,134.409,291.232,136.985,291.915Z",
    transform: "translate(-33.035 -18.068)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55073",
    "data-name": "Path 55073",
    d: "M89.243,319.407c2.592-.034,5.49-.337,7.106-2.34l.1.083a5.818,5.818,0,0,0,5.85.478,8.657,8.657,0,0,0,3.786-3.767l.085.046a5.526,5.526,0,0,0,3.853,1.792,17.772,17.772,0,0,1,1.608-4.407,29.879,29.879,0,0,1-4.832,1.018,8.368,8.368,0,0,1-2.852-.207c-2.577-.683-4.706-3.649-3.507-6.026.847-1.675,2.806-2.282,4.726-2.57.383-.056.762-.1,1.131-.139l8.578-.872a21.991,21.991,0,0,1,2.282-.147,7.222,7.222,0,0,1,2.236.317c2.912.951,4.507,4.214,4.648,7.272s-.817,6.042-1.43,9.043A39.965,39.965,0,0,0,124,339.869c-11.456,3.375-21.906,5.93-33.733,5.9-.069-.346-.143-.691-.231-1.036v-.009a23.7,23.7,0,0,0-3.808-8.255c-1.659-2.294-3.716-4.264-5.454-6.5A29.722,29.722,0,0,1,75.3,305.6a6.434,6.434,0,0,1,2.652-3.937,4.4,4.4,0,0,1,3.392-.889,3.5,3.5,0,0,1,.7.236,6.745,6.745,0,0,1,2.3,2.052,26.141,26.141,0,0,1,5.331,12.693,6.417,6.417,0,0,1-.157,3.086A2.876,2.876,0,0,1,89.243,319.407Z",
    transform: "translate(0 -38.255)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55074",
    "data-name": "Path 55074",
    d: "M642.395,830.773a7.708,7.708,0,0,1-2.649,5.4,14.766,14.766,0,0,1-8.9,4.049,15.724,15.724,0,0,1-9.53-2.276A9.255,9.255,0,0,1,618.1,834.9a5,5,0,0,1-.487-4.281c.961-2.425,3.979-3.311,6.586-3.213s5.218.845,7.777.353c2.4-.462,4.812-1.991,7.1-1.146A4.841,4.841,0,0,1,642.395,830.773Z",
    transform: "translate(-374.299 -400.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55075",
    "data-name": "Path 55075",
    d: "M331.652,1171.269c-7.89-24.351-22.236-45.606-36.8-66.836l-.1.066a23.7,23.7,0,0,0-6.277,10.038c-3.066,8.411-2.813,17.675-1.582,26.543,2.5,18,8.815,35.212,15.088,52.265q3.8,10.319,7.591,20.638l26.479.038h8.737Z",
    transform: "translate(-145.809 -592.573)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55076",
    "data-name": "Path 55076",
    d: "M601.187,774.2a2.529,2.529,0,1,1-2.5,2.559A2.529,2.529,0,0,1,601.187,774.2Z",
    transform: "translate(-361.437 -364.817)",
    fill: "#20140f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55077",
    "data-name": "Path 55077",
    d: "M702.67,720.792a1.954,1.954,0,0,1-.547,2.135,2.232,2.232,0,0,1-2.312-.016c-.72-.38-1.3-.964-1.981-1.41a8.28,8.28,0,0,0-4.431-1.186,8.279,8.279,0,0,1-1.7-.117,1.954,1.954,0,0,1-1.349-.963,1.911,1.911,0,0,1,.677-2.2c.645-.517,1.485-.709,1.482-.569a11.09,11.09,0,0,1,8.769,2.472A4.238,4.238,0,0,1,702.67,720.792Z",
    transform: "translate(-424.559 -324.91)",
    fill: "#323b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55078",
    "data-name": "Path 55078",
    d: "M529,575.842c-5.922,3.66-13.571,5.093-21,5.362-4.612.164-9.22-.071-13.823-.281a53.308,53.308,0,0,0-6.452-.265,31.31,31.31,0,0,0-21.875,14.605c-.272.424-.557.835-.824,1.264-5.053,8.166-7.2,18.439-4.662,27.7a1.222,1.222,0,0,1-.325,1.113,2.486,2.486,0,0,1-1.037.611,3.72,3.72,0,0,1-2.362.1,2.327,2.327,0,0,1-1.591-1.662,9.292,9.292,0,0,0-6.135-4.2,7.911,7.911,0,0,0-2.7.035l-.776-1.606c-5.079-12.3-7.473-26.438-1.337-37.794,4.8-8.884,14.033-14.528,23.469-18.124s19.453-5.551,28.794-9.39c5.923-3.894,12.712-7.437,20.064-7.9a26.139,26.139,0,0,1,13.331,2.73,16.185,16.185,0,0,1,4.982,3.665,13.9,13.9,0,0,1,2.841,11.79,20.363,20.363,0,0,1-6.284,10.646A24.2,24.2,0,0,1,529,575.842Z",
    transform: "translate(-252.316 -206.985)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55079",
    "data-name": "Path 55079",
    d: "M451.206,707.078a10.66,10.66,0,0,1-14.174-13.8,9.233,9.233,0,0,1,2.09-3.154,8.166,8.166,0,0,1,4.225-2.139,7.911,7.911,0,0,1,2.7-.035,9.292,9.292,0,0,1,6.135,4.2,2.327,2.327,0,0,0,1.591,1.662,3.72,3.72,0,0,0,2.362-.1,2.486,2.486,0,0,0,1.037-.611,1.222,1.222,0,0,0,.325-1.113c-2.541-9.257-.39-19.529,4.662-27.7.267-.429.552-.839.824-1.264a31.31,31.31,0,0,1,21.875-14.605,53.308,53.308,0,0,1,6.452.265c4.6.211,9.21.445,13.823.281,7.424-.27,15.074-1.7,21-5.362q2.488,9.07,4.98,18.14c6.375,23.23,7.7,41.289,3.784,53.669-2.261,7.139-6.26,12.392-12.041,15.667a50.409,50.409,0,0,1-20.933,6.279,49.873,49.873,0,0,0,1.538,5.29,12.733,12.733,0,0,0,2.8,4.99c.146.144.3.277.463.411-4.713,5.911-12.874,8.483-20.386,7.546-7.6-.955-14.532-5.09-20.052-10.405l-.46-.107a10.359,10.359,0,0,0-.642-4.71c-3.5-11.445-8.518-22.359-13.524-33.227ZM527,672.765a1.954,1.954,0,0,0,.547-2.135,4.238,4.238,0,0,0-1.4-1.856,11.09,11.09,0,0,0-8.769-2.472c0-.14-.837.052-1.482.569a1.911,1.911,0,0,0-.677,2.2,1.954,1.954,0,0,0,1.349.963,8.27,8.27,0,0,0,1.7.117,8.28,8.28,0,0,1,4.431,1.186c.679.446,1.261,1.03,1.981,1.41A2.232,2.232,0,0,0,527,672.765Zm-2.92,13.511a2.529,2.529,0,1,0-2.5,2.555A2.53,2.53,0,0,0,524.08,686.275Zm-9.2,23.853a7.708,7.708,0,0,0,2.649-5.4,4.841,4.841,0,0,0-3.313-4.156c-2.289-.845-4.7.684-7.1,1.146-2.559.492-5.174-.256-7.777-.354s-5.626.788-6.587,3.213a5,5,0,0,0,.488,4.281,9.256,9.256,0,0,0,3.207,3.044,15.725,15.725,0,0,0,9.53,2.276A14.766,14.766,0,0,0,514.882,710.128Zm-22.252-40.8a1.911,1.911,0,0,0-.726-2.187c-.656-.5-1.5-.676-1.494-.536a11.089,11.089,0,0,0-8.712,2.666,4.239,4.239,0,0,0-1.355,1.887,1.954,1.954,0,0,0,.595,2.123,2.232,2.232,0,0,0,2.311-.068c.707-.4,1.281-.992,1.949-1.453a8.279,8.279,0,0,1,4.4-1.284,8.282,8.282,0,0,0,1.7-.155A1.953,1.953,0,0,0,492.63,669.323Zm-.889,17.311a2.529,2.529,0,1,0-2.5,2.555A2.529,2.529,0,0,0,491.741,686.635Z",
    transform: "translate(-249.436 -274.748)",
    fill: "#fea77c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 10.901,
    cy: 10.901,
    r: 10.901,
    transform: "translate(513.255 387.488) rotate(-9.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55080",
    "data-name": "Path 55080",
    d: "M1505.8,653.827c-3.774,1.928-7.558,3.786-11.631,6.148a29.95,29.95,0,0,0-6.459,4.546c-4.045,4.079-5.674,10.373-10.421,13.58l-.019-.028c5.311-3.429,3.752-15.293-3.486-26.492s-17.407-17.5-22.718-14.068c3.321-3.065,8.084-3.15,12.551-3.832,11.208-1.706,20.8-8.618,30.459-14.551,2.375-1.453,4.943-2.91,7.723-2.828,2.968.079,5.595,1.9,7.779,3.906,4.284,3.935,10.3,12.736,10.406,22.6-.212,2.4-1.535,3.751-3.975,5.295-2.593,1.643-5.086,3.038-7.552,4.338C1507.573,652.914,1506.689,653.368,1505.8,653.827Zm-5.515-1.857a1.726,1.726,0,0,0-1.565-3.076l-6.152,3.124a1.726,1.726,0,0,0,1.564,3.076Zm-3.059-7.463a1.726,1.726,0,0,0-1.565-3.076l-6.147,3.124a1.722,1.722,0,1,0,1.56,3.072Zm-4.4-6.625a1.726,1.726,0,0,0-1.565-3.076l-6.152,3.124a1.726,1.726,0,0,0,1.565,3.076Zm-4.888-6.1a1.724,1.724,0,0,0-1.56-3.076l-6.152,3.124a1.724,1.724,0,0,0,1.56,3.076Z",
    transform: "translate(-949.312 -255.915)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55081",
    "data-name": "Path 55081",
    d: "M1591.192,721.683a1.724,1.724,0,0,1-.756,2.316l-6.152,3.124a1.726,1.726,0,0,1-1.564-3.076l6.152-3.124A1.726,1.726,0,0,1,1591.192,721.683Z",
    transform: "translate(-1039.458 -327.943)",
    fill: "#297ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55082",
    "data-name": "Path 55082",
    d: "M1581.333,697.628a1.728,1.728,0,0,1-.756,2.32l-6.152,3.12a1.722,1.722,0,1,1-1.56-3.072l6.147-3.124A1.727,1.727,0,0,1,1581.333,697.628Z",
    transform: "translate(-1032.659 -311.356)",
    fill: "#297ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55083",
    "data-name": "Path 55083",
    d: "M1567.161,676.285a1.724,1.724,0,0,1-.756,2.316l-6.152,3.124a1.726,1.726,0,0,1-1.565-3.076l6.152-3.124A1.726,1.726,0,0,1,1567.161,676.285Z",
    transform: "translate(-1022.884 -296.634)",
    fill: "#297ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55084",
    "data-name": "Path 55084",
    d: "M1551.419,656.608a1.72,1.72,0,0,1-.756,2.32l-6.152,3.124a1.724,1.724,0,0,1-1.56-3.076l6.152-3.124A1.724,1.724,0,0,1,1551.419,656.608Z",
    transform: "translate(-1012.031 -283.066)",
    fill: "#297ee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55085",
    "data-name": "Path 55085",
    d: "M357.172,655.687q-.957-3.984-1.9-7.986c2.122-38.1,21.341-100.541,20.881-139.463s-6.627-67.836-17.572-105.191a19.7,19.7,0,0,1-.5-1.979A86.481,86.481,0,0,1,327.737,399l-.216-.054c4.02,32.42,3.644,65.08,1.069,97.451-1.355,17.008-3.382,34.21-8.556,50.385a117.767,117.767,0,0,1-4.971,12.958c-3.952,8.688-9.737,17.41-18.711,20.584a5.041,5.041,0,0,1-4.813-1.009c-4.712,5.912-12.874,8.483-20.386,7.546-7.6-.955-14.532-5.089-20.052-10.405l-.46-.107c-.017.117-.044.234-.071.352-.407,1.675-2.024,3.177-3.708,2.84l-.177.053c-20.6-11.7-28.977-24.8-38.831-41.069s-16.931-34.04-23.517-51.882q-14.4-39.039-25.94-79.054l-.14.039c-11.456,3.375-21.906,5.93-33.733,5.9-.069-.346-.143-.691-.231-1.036.255,2.3,5.175,111.5,30.181,159.651,8.278,15.941,18.608,30.835,28.826,45.734,14.566,21.23,28.912,42.485,36.8,66.836v.052l.018.007,13.12,42.694,25.652.048,115.552.157,0-.164Q365.809,691.591,357.172,655.687Z",
    transform: "translate(-34.259 -106.008)",
    fill: "#297ee8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 11.554,
    cy: 10.381,
    rx: 11.554,
    ry: 10.381,
    transform: "translate(417.57 576.106) rotate(-43.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55086",
    "data-name": "Path 55086",
    d: "M582.758,946.06c-.426-.048-.933.2-1.29-.261-.31.447-.76.234-1.191.259l-.375-.559.287-.287a1.631,1.631,0,0,1,.635.166c.152-.054.1-.162.054-.156a2.366,2.366,0,0,0-.4.124c.173.049.346.1.348.032-.38-.245-.411-.324-.443-.4l-.193.238-.287.287h-.672a7.106,7.106,0,0,0-.563-1.073.716.716,0,0,1,.078-1.089l-.757-.991-.149,1.431h-.808a1.559,1.559,0,0,0-.316-.264c.069-.306.15-.576.235-.862h-1.534l-.39.432.14.157.794-.356a8.433,8.433,0,0,0,.756.628,1.559,1.559,0,0,1,.316.264c.186.631.76.045,1.072.4l.226.787-.339.752-.8-1.085-.36.319-.846-1.132c-.235.356,0,1.14-.9,1.107l-.1-.732-1.114-.413.28-1.013c-.612-.484-1.128.24-1.677.132a9.053,9.053,0,0,1-1.475-.555v-.94l-.394.318-1.042-.528v-.326c.553-.14,1.117-.242,1.68-.345l-.8-.6.439-.613-1.32.558v1a.732.732,0,0,1-.238.133l.238.193-.282,1.013.164-.16.259.744.286-.839,1.009.391-.789.646.214.79a2.033,2.033,0,0,1-.8-.111,1.158,1.158,0,0,0-1.406.07c-.355-.237-.377-.873-.966-.963q.152-.791.3-1.58c.1-.1.191-.191.2-.287.423-.127.766-.205,1.1-.3.043-.012.058-.123.082-.179l-.738-.351a4.72,4.72,0,0,0-.446.832c0,.1-.1.191-.2.287h-.574V940.4h-1.835l-.935-1.167-.308.281-1.434-.955.987-.348a2.41,2.41,0,0,1-.2-.478,2.73,2.73,0,0,0-.2-.831c.048-.017.184.124.405.356l.054-.67c-.229.018-.352.027-.459.314.033.354-.121.445-.369.59-.775-.864-1.974-.8-3.079-1.1l-.227.484h-.4c-.019-.252-.039-.512-.051-.674l1.367-.662.221.176.212-.4c-.621-.25-1.128-.855-1.843-.022l-.619-.813c.468-.326,1.291-.065,1.213-.993-.5-.288-1.1.787-1.582-.116l-.169.548-.843.177.139.151-.72.724.183.183H555.2l.219-.846-.744.212-.547-.958,1.081.444.7-.35.268.627.509-1.207.386.353.419-.424-1.534-.558.473-.726c.389.181.543.724,1.091.579.353.285.353.285.83.018-.322,0-.587,0-.83-.018-.376-.429-.73-.839-1.152-1.33l-.649.986H554.7l-.135-.807-.4.233c-.58-.339-.363-.9-.4-1.4l1.3-.238.315.2c.037-.08.122-.178.1-.238a3.327,3.327,0,0,0-.249-.467c.056-.033.155-.134.207-.114,1.234.485,2.458.991,3.693,1.474.577.225,1.171.4,1.755.613a11.6,11.6,0,0,0,1.657.516,30.775,30.775,0,0,1,3.206.906,7.835,7.835,0,0,0,2.23.51c.835.014,1.6.48,2.451.437.169-.009.343.117.516.124a6.239,6.239,0,0,1,1.9.259c.58.2,1.247-.01,1.9.281a4.963,4.963,0,0,0,1.787.041l-.378.472.484.13.2-.574h3.381l-.3.418.756.269.1-.407-.294-.143c.164-.235.712-.239,2-.021-.194.1-.387.2-.574.316-.021.012,0,.091,0,.271l.793.2.179.514.329-.292c1.282,4.528,2.172,6.618,3.883,8.6l-.3.582-.753-.357c-.048.2-.125.346-.1.458s.166.218.26.331a1.441,1.441,0,0,1-.281.286c-.3.175-.624.324-.957.493L584.023,944l-.547.3.811.88-.339.49.27.271-.849.59c-.017.173-.039.4-.065.657H582.6c-.035-.072-.12-.164-.1-.229.078-.3.183-.59.264-.9a.589.589,0,0,0,.041.043l.235-.2-.091-.091A1.636,1.636,0,0,0,582.758,946.06Zm-1.108-2.889-.056.056.2.235.091-.091a.454.454,0,0,0-.287-.14l.056-.056-.2-.235-.091.091A.455.455,0,0,0,581.65,943.171Zm-13.932-1.163c.2.22.252.328.293.322a2.394,2.394,0,0,0,.4-.124c-.173-.049-.346-.1.223.126l-.248.013.11.561.186-.025C568.668,942.7,568.653,942.515,567.718,942.008Zm12.551,2.353c.436.059.673-.228.791-.626-.072-.38-.737-.112-.608-.652,0-.01-.332-.1-.582-.176a8.2,8.2,0,0,0,.591,1.648l-1.142-.464c.025.219.043.375.064.565A1.478,1.478,0,0,0,580.27,944.36Zm-16.683-7.731c1.067.56,1.263.858,1.034,1.318l-.492.179c.029.3-.224.7.29.788.765-.663.5-1.493.555-2.284Zm8.632,5.207.669.5.36-.772-.39-.367Zm10.842,2.729v-.144h-.574v.144Zm-16.128-5.434-.031-.248-.467.111.022.137Zm-.888-1.961H565.9v.574h.144Zm8.974-2.513v.144h.574v-.144Zm-5.839,5.1h-.1v.287h.1Zm-.766,1.531v.1h.287v-.1Zm6.318,0v.1h.287v-.1Zm-1.149.287v.1h.287v-.1Zm5.552,1.915h.1V943.2h-.1Zm5.552,0h-.1v.287h.1Zm-28.048-13.306v-.1h-.287v.1ZM559.416,932h-.1v.287h.1Zm2.011,1.436h-.1v.287h.1Zm-.957,1.149h.1V934.3h-.1Zm18.284.383v.1h.287v-.1Zm-3.829.191h-.1v.287h.1Zm-13.88.861h.1v-.287h-.1Zm14.838-.191v.1h.287v-.1Zm7.371.766h-.1v.287h.1Zm-1.053.766v-.1h-.287v.1Z",
    transform: "translate(-330.451 -471.673)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55087",
    "data-name": "Path 55087",
    d: "M139.831,356.358h.861c0,.393.31.237.51.293a5.448,5.448,0,0,1,.616.256v-1.341a6.006,6.006,0,0,1,.735.223c.258.116.047.683.6.593.214-.035.475.209.744.34l-.657.694.257,1.087-1.462-.852-1.535.2c-.661.418-.344.921-.071,1.444l-.979.705.3.46-.673,1.666-.624-.345.787-1.548-.61-.651.713-.533-.3-.515.409-1.128-.2-.765C139.474,356.6,139.807,356.788,139.831,356.358Z",
    transform: "translate(-44.024 -76.094)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55088",
    "data-name": "Path 55088",
    d: "M861.775,337.1l-.288.9-1.479-1.162.381-.622a5.688,5.688,0,0,1-1.2-1.7l.818-.209a1.842,1.842,0,0,0,.049.458c.172.516.462.769.913.579.328-.138.519-.009.782.008a2.658,2.658,0,0,0,.884-.261l.188.4c-.067.263-.149.581-.242.947l1.2.377.261.447-.3.36h1.532c.43.331.688.641.405,1.232l-1.261-.3-.119.815h-.475v-1.083l-1.19-1.187h-.86c-.1-.1-.191-.191-.264-.273.023-.288.023-.556.023-.809l.83-.272-1.015-.1-.721.754c.31.151.584.285.883.429C861.583,336.91,861.679,337.006,861.775,337.1Z",
    transform: "translate(-541.103 -61.432)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55089",
    "data-name": "Path 55089",
    d: "M878.884,339.991l1.206-.437.6.928.288-.616.508.044-.269.693.552.376c-.231.492-.853.385-1.958-.218l-.49.49-.791-.378Z",
    transform: "translate(-554.441 -65.05)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55090",
    "data-name": "Path 55090",
    d: "M842.6,339.942c-.386-.011-.657-.011-.93-.011-.174-.607.427-.692.594-1.035l1.152.363-.383.765.318.45-.871.542.409,1.084-1.257-.493v-.869a7.527,7.527,0,0,0,.968-.8c-.127.029-.108.048-.09.067l.235-.2-.09-.09C842.591,339.8,842.524,339.875,842.6,339.942Z",
    transform: "translate(-528.996 -64.597)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55091",
    "data-name": "Path 55091",
    d: "M176.366,347.937h1.056a5.337,5.337,0,0,1-.367,3.183c-.467-.527.142-.874.145-1.372l-.834-.142Z",
    transform: "translate(-70.172 -70.831)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55092",
    "data-name": "Path 55092",
    d: "M137.159,356.314h-.483l-.154.817h-1.1l.268-.4-.282-.312.86-.567-.285-.284a1.794,1.794,0,0,0,.451-.125,2.906,2.906,0,0,0,.4-.359l.492.331.409-.33v.939C137.515,356.07,137.183,355.884,137.159,356.314Z",
    transform: "translate(-41.926 -75.762)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55093",
    "data-name": "Path 55093",
    d: "M145.86,366.632l-.229-.268.209-.251-.307-1.649,1.255,1.071-.589.2.309.447-.281.522.58.233-.363.662h-1.283Z",
    transform: "translate(-48.651 -82.23)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55094",
    "data-name": "Path 55094",
    d: "M883.633,346.6l.232-.672c.16.062.328.074.4.164.221.281.405.592.713,1.055l-1.172-.34-1.385.715.87.535-.588.438c-.886-.326.005-1.381-.837-1.895Z",
    transform: "translate(-556.741 -69.449)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55095",
    "data-name": "Path 55095",
    d: "M851.786,335.829c.235-.976.469-1.069,1.436-.574l-.579.455,1.158.523-.048.85-.818-.392C852.788,336.089,852.159,336.13,851.786,335.829Z",
    transform: "translate(-535.997 -61.883)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55096",
    "data-name": "Path 55096",
    d: "M170.738,357.192h1.273l.94.977-.363.51-1.561-.868Z",
    transform: "translate(-66.291 -77.214)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55097",
    "data-name": "Path 55097",
    d: "M165.134,358.447l.188.745c-.2.143.354.411.267.7l-1.092.727-.324-.428.219-.219-.255-.5Z",
    transform: "translate(-61.738 -78.08)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55098",
    "data-name": "Path 55098",
    d: "M863.163,347.409l-1.684.565-.324-.323v-.779l1.069.181.776-.624C863.076,346.882,863.125,347.173,863.163,347.409Z",
    transform: "translate(-542.459 -69.791)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55099",
    "data-name": "Path 55099",
    d: "M872.947,336l.785-.561.506,2.154a6.307,6.307,0,0,1-.68-.006c-.1-.013-.256-.071-.275-.139C873.165,337.022,873.077,336.584,872.947,336Z",
    transform: "translate(-550.591 -62.214)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55100",
    "data-name": "Path 55100",
    d: "M158.214,355.341l.192.7-1.524,1.189c-.045-.449-.075-.74-.1-1.032l.287-.287.452-.574Z",
    transform: "translate(-56.663 -75.938)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55101",
    "data-name": "Path 55101",
    d: "M854.117,340.536l.766,1.228c-.079.173-.176.368-.259.569-.066.161-.115.329-.176.508l-.524-.07.374-.945-.584-.249v-1Z",
    transform: "translate(-537.326 -65.727)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55102",
    "data-name": "Path 55102",
    d: "M592.111,967l-1.61.79-.4-.338c-.094-.257.245-.44.989-.531l.168-.881C591.952,966.115,591.767,966.755,592.111,967Z",
    transform: "translate(-355.505 -497.128)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55103",
    "data-name": "Path 55103",
    d: "M615.241,976.314c-.181.324-.272.47-.345.624a4.282,4.282,0,0,0-.144.412l-.895.439-.342-.315,1.144-1.16Z",
    transform: "translate(-371.666 -504.211)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55104",
    "data-name": "Path 55104",
    d: "M127.439,366.078c-.744.3-1.364-.7-2.011.078l-.534-.726a1.277,1.277,0,0,1,1.429.088l.533-.347Z",
    transform: "translate(-34.672 -82.718)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55105",
    "data-name": "Path 55105",
    d: "M878.287,353.472l-.961.325-.375-1.217.934-.417Z",
    transform: "translate(-553.353 -73.745)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55106",
    "data-name": "Path 55106",
    d: "M153.39,367.954c.717.34,1.2.676,1.062,1.508h-.592l-.832-.774Z",
    transform: "translate(-54.076 -84.637)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55107",
    "data-name": "Path 55107",
    d: "M573.206,955.029c.02-.33.042-.681.066-1.068.743.107.891.786,1.418,1.008l-.5.5Z",
    transform: "translate(-343.865 -488.795)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55108",
    "data-name": "Path 55108",
    d: "M889.627,336.849c-.841,0-.681-.838-1.128-1.169l.437-.477C889.282,335.043,889.693,336.022,889.627,336.849Z",
    transform: "translate(-561.317 -62.037)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55109",
    "data-name": "Path 55109",
    d: "M157.783,360.974l.65.369.592-.592.351.685-.351.513-1.344-.4Z",
    transform: "translate(-57.285 -79.669)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55110",
    "data-name": "Path 55110",
    d: "M128.825,359.219l-.982-.647,2.044-.408c-.035.191-.005.452-.116.544A5.508,5.508,0,0,1,128.825,359.219Z",
    transform: "translate(-36.707 -77.885)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55111",
    "data-name": "Path 55111",
    d: "M871.659,352.566l-.69-.528.439-1.239c.842.39.341,1.086.545,1.6Z",
    transform: "translate(-549.227 -72.805)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55112",
    "data-name": "Path 55112",
    d: "M869.1,334.255l-.587-1.062c.593-.33.956.215,1.453.348C869.819,334.035,869.581,334.32,869.1,334.255Z",
    transform: "translate(-547.536 -60.59)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55113",
    "data-name": "Path 55113",
    d: "M563.223,946.853v.977c-.432.058-.793.7-1.518.2Z",
    transform: "translate(-335.933 -483.893)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55114",
    "data-name": "Path 55114",
    d: "M849.338,337.056l-.287.862c-.769-.211-.769-.211-.815-1.052C848.669,336.548,848.983,336.918,849.338,337.056Z",
    transform: "translate(-533.548 -63.109)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55115",
    "data-name": "Path 55115",
    d: "M555.265,939.45h.834c-.158.512,1.033.378.62,1.109A2.123,2.123,0,0,1,555.265,939.45Z",
    transform: "translate(-331.492 -478.787)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55116",
    "data-name": "Path 55116",
    d: "M584.838,965.805l-1.423-.3c.015-.142.028-.272.053-.515l.624.224,1.178-.251Z",
    transform: "translate(-350.906 -496.385)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55117",
    "data-name": "Path 55117",
    d: "M552.068,929.316l-.518-.675,1.422-.477.16.316Z",
    transform: "translate(-328.93 -471.003)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55118",
    "data-name": "Path 55118",
    d: "M890.6,342.462h-.814c-.164-.573-.027-.964.722-1.176C890.535,341.693,890.564,342.059,890.6,342.462Z",
    transform: "translate(-562.159 -66.244)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55119",
    "data-name": "Path 55119",
    d: "M157.717,365.657v-.43l.781.2.578-.347c.035.382.059.638.082.878-.137.055-.233.133-.3.112C158.472,365.945,158.089,365.795,157.717,365.657Z",
    transform: "translate(-57.31 -82.657)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55120",
    "data-name": "Path 55120",
    d: "M854.633,349.8l-1.217-.372c.769-.741.771-.754,1.5-.152-.094.1-.193.194-.278.3C854.614,349.6,854.633,349.665,854.633,349.8Z",
    transform: "translate(-537.121 -71.457)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55121",
    "data-name": "Path 55121",
    d: "M132.71,368.3h.5v1.955l-.315.069c-.575-.276.409-.737-.161-.995C133.254,368.971,132.878,368.636,132.71,368.3Z",
    transform: "translate(-40.061 -84.873)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55122",
    "data-name": "Path 55122",
    d: "M577.371,962.524l-.955.113c-.077-.208-.129-.378-.2-.537a.99.99,0,0,0-.183-.2l.438-.439Z",
    transform: "translate(-345.812 -493.965)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55123",
    "data-name": "Path 55123",
    d: "M857.136,350.773l1.077.806-.9.848Z",
    transform: "translate(-539.687 -72.787)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55124",
    "data-name": "Path 55124",
    d: "M870.543,347.936c-.7.221-1.063.036-1.248-.543C870.005,347.143,870.005,347.143,870.543,347.936Z",
    transform: "translate(-548.072 -70.354)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55125",
    "data-name": "Path 55125",
    d: "M115.941,365.485l1.066.857-.935.823C116.026,366.583,116,366.219,115.941,365.485Z",
    transform: "translate(-28.498 -82.934)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55126",
    "data-name": "Path 55126",
    d: "M172.691,350.976l-1.014-.592.447-.907.736,1.355Z",
    transform: "translate(-66.938 -71.893)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55127",
    "data-name": "Path 55127",
    d: "M868.066,355.75l.548-1.414.548,1.414Z",
    transform: "translate(-547.225 -75.245)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55128",
    "data-name": "Path 55128",
    d: "M850.207,340.862l.7.38a5.361,5.361,0,0,1-.543.6c-.087.069-.246.048-.375.068C849.753,341.456,849.811,341.084,850.207,340.862Z",
    transform: "translate(-534.661 -65.952)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55129",
    "data-name": "Path 55129",
    d: "M165,354.051l.4.8c-.5.368-.833.182-1.184-.3Z",
    transform: "translate(-61.79 -75.048)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55130",
    "data-name": "Path 55130",
    d: "M850.976,355.133l-.985.732c-.037-.411-.06-.663-.079-.878l.378-.378Z",
    transform: "translate(-534.704 -75.433)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55131",
    "data-name": "Path 55131",
    d: "M886.322,355.534l.986-.732c.037.411.06.663.079.878l-.378.378Z",
    transform: "translate(-559.816 -75.566)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55132",
    "data-name": "Path 55132",
    d: "M852.766,362.389l1.093-.888v.888Z",
    transform: "translate(-536.673 -80.186)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55133",
    "data-name": "Path 55133",
    d: "M883.526,336.044l-.5.191.115.157h-1.613l-.019-.137,1.9-.411Z",
    transform: "translate(-556.497 -62.49)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55134",
    "data-name": "Path 55134",
    d: "M166.861,350.7c.023.49.061.988-.574,1.149l-.3-.55A.736.736,0,0,1,166.861,350.7Z",
    transform: "translate(-63.013 -72.728)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55135",
    "data-name": "Path 55135",
    d: "M865.715,333.376v.727l-.812.074v-.8Z",
    transform: "translate(-545.043 -60.789)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55136",
    "data-name": "Path 55136",
    d: "M94.328,364.214l.708-.458.392,1.047C94.812,364.743,94.812,364.743,94.328,364.214Z",
    transform: "translate(-13.592 -81.741)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55137",
    "data-name": "Path 55137",
    d: "M874.123,362.386v1.088l-.684-.4Z",
    transform: "translate(-550.93 -80.797)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55138",
    "data-name": "Path 55138",
    d: "M591.6,974.453v.809h-.838C590.805,974.643,591.113,974.427,591.6,974.453Z",
    transform: "translate(-355.975 -502.926)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55139",
    "data-name": "Path 55139",
    d: "M174.3,345.779h-.861V345.2l.78-.4Z",
    transform: "translate(-68.151 -68.673)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55140",
    "data-name": "Path 55140",
    d: "M145.164,355.568c0-.251.013-.491,0-.727-.011-.146-.371-.16-.154-.438.7.042.78.489.715,1.116Z",
    transform: "translate(-48.495 -75.29)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55141",
    "data-name": "Path 55141",
    d: "M549.091,941.526v.988l-.786.056C548.2,941.986,548.554,941.833,549.091,941.526Z",
    transform: "translate(-326.678 -480.219)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55142",
    "data-name": "Path 55142",
    d: "M849.787,347.529H848.74l.5-.945Z",
    transform: "translate(-533.896 -69.898)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55143",
    "data-name": "Path 55143",
    d: "M607.627,975.817l.889.579-.889.549Z",
    transform: "translate(-367.605 -503.869)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55144",
    "data-name": "Path 55144",
    d: "M626.456,984.74l.913-.682.075,1.161Z",
    transform: "translate(-380.591 -509.552)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55145",
    "data-name": "Path 55145",
    d: "M625.154,985.667l-.914.682c-.029-.457-.048-.739-.075-1.161Z",
    transform: "translate(-379.011 -510.332)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55146",
    "data-name": "Path 55146",
    d: "M133.393,363.727l.815-.647c.062.437.1.707.169,1.189Z",
    transform: "translate(-40.534 -81.275)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55147",
    "data-name": "Path 55147",
    d: "M548.472,937.938l.847.54-.847.607Z",
    transform: "translate(-326.807 -477.744)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55148",
    "data-name": "Path 55148",
    d: "M837.87,336.986v.479h-.814v-.479Z",
    transform: "translate(-525.838 -63.279)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55149",
    "data-name": "Path 55149",
    d: "M585.343,974.736v-1.005l.875.351Z",
    transform: "translate(-352.236 -502.43)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55150",
    "data-name": "Path 55150",
    d: "M593.054,972.547l-.355-.458.427-.427.6.719Z",
    transform: "translate(-357.309 -501.004)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55151",
    "data-name": "Path 55151",
    d: "M841.2,356.114l.428.762c-.547.334-.665-.078-.889-.3Z",
    transform: "translate(-528.376 -76.471)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55152",
    "data-name": "Path 55152",
    d: "M585.893,969.755h-.474v-.83C586.222,968.9,585.869,969.4,585.893,969.755Z",
    transform: "translate(-352.288 -499.115)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55153",
    "data-name": "Path 55153",
    d: "M539.51,929.905v.844l-.5.1c-.023-.286-.043-.542-.066-.832Z",
    transform: "translate(-320.238 -472.204)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55154",
    "data-name": "Path 55154",
    d: "M867.515,349.788h.439l.431.879C867.745,350.611,867.489,350.341,867.515,349.788Z",
    transform: "translate(-546.843 -72.108)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55155",
    "data-name": "Path 55155",
    d: "M554.241,951.3l-.522.585-.593-1.09Z",
    transform: "translate(-330.017 -486.612)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55156",
    "data-name": "Path 55156",
    d: "M103.947,372.96v.474h-.831C103.09,372.631,103.592,372.984,103.947,372.96Z",
    transform: "translate(-19.652 -88.05)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55157",
    "data-name": "Path 55157",
    d: "M838.538,356.232h-.479v-.814h.479Z",
    transform: "translate(-526.53 -75.991)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55158",
    "data-name": "Path 55158",
    d: "M176.575,327.091l-.6-.5,1.1-.591Z",
    transform: "translate(-69.902 -55.7)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55159",
    "data-name": "Path 55159",
    d: "M635.081,985.024l.522-.585.593,1.09Z",
    transform: "translate(-386.539 -509.815)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55160",
    "data-name": "Path 55160",
    d: "M542.647,925.322l.6.5-1.1.591Z",
    transform: "translate(-322.442 -469.043)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55161",
    "data-name": "Path 55161",
    d: "M544.578,937.616h-1.054l.178-.721Z",
    transform: "translate(-323.394 -477.025)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55162",
    "data-name": "Path 55162",
    d: "M173.052,363.819l-.117.665-.916-.665Z",
    transform: "translate(-67.175 -81.785)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55163",
    "data-name": "Path 55163",
    d: "M547.756,931.882c.164.164.267.263.365.368a.147.147,0,0,1,.026.072l-.38.433-.433-.433Z",
    transform: "translate(-326.023 -473.567)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55164",
    "data-name": "Path 55164",
    d: "M862.641,353.475l-.65-.905.894-.057Z",
    transform: "translate(-543.035 -73.987)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55165",
    "data-name": "Path 55165",
    d: "M640.678,993.026l-.663.9V992.9Z",
    transform: "translate(-389.942 -515.649)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55166",
    "data-name": "Path 55166",
    d: "M650.934,987.2l-.92.782-.312-.623Z",
    transform: "translate(-396.623 -511.721)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55167",
    "data-name": "Path 55167",
    d: "M632.687,986.083l.642.816-.642.25Z",
    transform: "translate(-384.888 -510.949)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55168",
    "data-name": "Path 55168",
    d: "M580.677,966.283l-.916.665-.117-.665Z",
    transform: "translate(-348.306 -497.293)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55169",
    "data-name": "Path 55169",
    d: "M562.543,954.329l.93-.66.1.66Z",
    transform: "translate(-336.511 -488.593)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55170",
    "data-name": "Path 55170",
    d: "M829.1,339.577l.4.431-.393.448-.433-.433Z",
    transform: "translate(-520.055 -65.066)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55171",
    "data-name": "Path 55171",
    d: "M556.471,948.107v.642l-.82.068-.057-.192Z",
    transform: "translate(-331.719 -484.758)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55172",
    "data-name": "Path 55172",
    d: "M164.8,370.309l.861-.637C165.44,370.275,165.44,370.275,164.8,370.309Z",
    transform: "translate(-62.195 -85.822)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55173",
    "data-name": "Path 55173",
    d: "M152.734,367.022l-.546-.043-.041-.488.541-.059Z",
    transform: "translate(-53.469 -83.587)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55174",
    "data-name": "Path 55174",
    d: "M578.788,957.885h.512l.081.423C579,958.53,578.762,958.526,578.788,957.885Z",
    transform: "translate(-347.714 -491.501)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55175",
    "data-name": "Path 55175",
    d: "M574.16,959.736h.512l.081.423C574.372,960.381,574.135,960.377,574.16,959.736Z",
    transform: "translate(-344.522 -492.778)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55176",
    "data-name": "Path 55176",
    d: "M862.5,359.607l-.93-.065.611-.531Z",
    transform: "translate(-542.745 -78.47)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55177",
    "data-name": "Path 55177",
    d: "M890.659,351.906l-.635.87C890.05,352.15,890.05,352.15,890.659,351.906Z",
    transform: "translate(-562.369 -73.569)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55178",
    "data-name": "Path 55178",
    d: "M548.762,928.727h-.512l-.081-.423C548.55,928.082,548.787,928.086,548.762,928.727Z",
    transform: "translate(-326.598 -471.008)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55179",
    "data-name": "Path 55179",
    d: "M168.8,349.354l.788-.411.12.466-.9.115C168.812,349.468,168.809,349.411,168.8,349.354Z",
    transform: "translate(-64.957 -71.525)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55180",
    "data-name": "Path 55180",
    d: "M178.615,364.171l-.513-.517.513-.647Z",
    transform: "translate(-71.369 -81.225)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55181",
    "data-name": "Path 55181",
    d: "M156.068,356.783c-.406-.076-.387-.34-.155-.533.151-.126.434-.091.442.246Z",
    transform: "translate(-55.953 -76.518)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55182",
    "data-name": "Path 55182",
    d: "M844.267,335.862l-.3-.623C844.323,335.164,844.323,335.164,844.267,335.862Z",
    transform: "translate(-530.601 -62.051)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55183",
    "data-name": "Path 55183",
    d: "M881.475,365.527v-.471l.558.369Z",
    transform: "translate(-556.473 -82.638)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55184",
    "data-name": "Path 55184",
    d: "M835.253,344l-.606-.379C835.344,343.563,835.344,343.563,835.253,344Z",
    transform: "translate(-524.176 -67.835)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55185",
    "data-name": "Path 55185",
    d: "M120.888,360.621l.382.612C120.9,361.3,120.562,361.386,120.888,360.621Z",
    transform: "translate(-31.82 -79.579)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55186",
    "data-name": "Path 55186",
    d: "M652.784,986.152l.042-.568.548.037-.437.676Z",
    transform: "translate(-398.749 -510.605)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55187",
    "data-name": "Path 55187",
    d: "M883.016,345.37l-.639.32C882.33,345.414,882.186,345.04,883.016,345.37Z",
    transform: "translate(-557.067 -68.972)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55188",
    "data-name": "Path 55188",
    d: "M877.353,350.009h-.477l-.019-.142.48-.1C877.342,349.845,877.347,349.927,877.353,350.009Z",
    transform: "translate(-553.288 -72.091)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55189",
    "data-name": "Path 55189",
    d: "M109.8,366.593v.476l-.137.022-.111-.467Z",
    transform: "translate(-24.089 -83.698)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55190",
    "data-name": "Path 55190",
    d: "M834.578,346.087v.574h-.144v-.574Z",
    transform: "translate(-524.029 -69.555)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55191",
    "data-name": "Path 55191",
    d: "M180.081,366.422l.047.551-.186.023q-.054-.281-.11-.561Z",
    transform: "translate(-72.563 -83.58)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55192",
    "data-name": "Path 55192",
    d: "M159.411,368.993l.2-.7a2.369,2.369,0,0,1,.124.4C159.739,368.74,159.631,368.8,159.411,368.993Z",
    transform: "translate(-58.479 -84.873)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55193",
    "data-name": "Path 55193",
    d: "M89.441,356.436v.476l-.142.019-.1-.48Z",
    transform: "translate(-10.052 -76.693)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55194",
    "data-name": "Path 55194",
    d: "M645.643,991.7v-.574h.144v.574Z",
    transform: "translate(-393.824 -514.423)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55195",
    "data-name": "Path 55195",
    d: "M856.413,335.259c.025-.43.357-.244.574-.287C856.963,335.4,856.631,335.216,856.413,335.259Z",
    transform: "translate(-539.188 -61.887)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55196",
    "data-name": "Path 55196",
    d: "M549.312,926.5h.476l.022.137-.467.111C549.333,926.663,549.323,926.581,549.312,926.5Z",
    transform: "translate(-327.386 -469.854)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55197",
    "data-name": "Path 55197",
    d: "M578,933.9h.476l.022.137-.467.111C578.022,934.067,578.011,933.985,578,933.9Z",
    transform: "translate(-347.172 -474.961)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55198",
    "data-name": "Path 55198",
    d: "M581.227,934.885h-.476l-.022-.136.467-.111Q581.212,934.761,581.227,934.885Z",
    transform: "translate(-349.054 -475.467)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55199",
    "data-name": "Path 55199",
    d: "M583.577,935.752h.476l.019.142-.48.1Z",
    transform: "translate(-351.018 -476.236)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55200",
    "data-name": "Path 55200",
    d: "M590.465,937.666h-.476l-.02-.142.48-.1Q590.457,937.543,590.465,937.666Z",
    transform: "translate(-355.426 -477.387)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55201",
    "data-name": "Path 55201",
    d: "M825.874,335.213h.574v.143h-.574Z",
    transform: "translate(-518.126 -62.056)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55202",
    "data-name": "Path 55202",
    d: "M859.348,341.13v-.476l.137-.022.112.47Z",
    transform: "translate(-541.212 -65.793)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55203",
    "data-name": "Path 55203",
    d: "M139.352,378.148v-.476l.137-.022.112.467Z",
    transform: "translate(-44.644 -91.324)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55204",
    "data-name": "Path 55204",
    d: "M147.194,376.842h-.476c-.008-.046-.015-.091-.023-.137l.467-.111Z",
    transform: "translate(-49.709 -90.596)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55205",
    "data-name": "Path 55205",
    d: "M858.264,334.452l.193-.238.095.238Z",
    transform: "translate(-540.465 -61.367)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55206",
    "data-name": "Path 55206",
    d: "M172.51,345.557l.193-.238.095.238Z",
    transform: "translate(-67.513 -69.026)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55207",
    "data-name": "Path 55207",
    d: "M171.961,346.045l-.2.235-.091-.09.235-.2Z",
    transform: "translate(-66.933 -69.488)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55208",
    "data-name": "Path 55208",
    d: "M660.178,978.993l.235.2-.091.091-.2-.235Z",
    transform: "translate(-403.81 -506.059)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55209",
    "data-name": "Path 55209",
    d: "M576.291,933.223H576v-.1h.287Z",
    transform: "translate(-345.795 -474.426)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55210",
    "data-name": "Path 55210",
    d: "M587.4,936.924h-.287v-.1h.287Z",
    transform: "translate(-353.454 -476.979)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55211",
    "data-name": "Path 55211",
    d: "M607.873,941.147v.287h-.1v-.287Z",
    transform: "translate(-367.708 -479.957)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55212",
    "data-name": "Path 55212",
    d: "M626.382,943v.287h-.1V943Z",
    transform: "translate(-380.474 -481.234)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55213",
    "data-name": "Path 55213",
    d: "M108.016,377.956h-.287v-.1h.287Z",
    transform: "translate(-22.834 -91.469)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 0.203,
    cy: 0.068,
    rx: 0.203,
    ry: 0.068,
    transform: "translate(104.651 284.361)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55214",
    "data-name": "Path 55214",
    d: "M842.011,362.745v.287h-.1v-.287Z",
    transform: "translate(-529.189 -81.044)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55215",
    "data-name": "Path 55215",
    d: "M161.308,354.736l.2-.235.091.091-.235.2Z",
    transform: "translate(-59.787 -75.358)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55216",
    "data-name": "Path 55216",
    d: "M142.375,353.49v.287h-.1v-.287Z",
    transform: "translate(-46.663 -74.661)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55217",
    "data-name": "Path 55217",
    d: "M842.936,352.565v.287h-.1v-.287Z",
    transform: "translate(-529.827 -74.023)",
    fill: "#f57d77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3288",
    "data-name": "Group 3288",
    transform: "translate(499.326 380.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55218",
    "data-name": "Path 55218",
    d: "M1484.324,717.157a1.021,1.021,0,0,1-.559.109l.259-.445-.295-.295-2.309.609.7.415c-.245.45-.75.611-.6,1.122h-.415c-.4-1.361-.4-1.361-.182-2.251-.377,0-.734,0-1.1.015a.511.511,0,0,0,.042-.04l-.2-.23-.089.089a1.593,1.593,0,0,0,.243.181c.1.271.189.556.307.938-.6.375-.185,1.022-.459,1.928.057.144.161.088.155.046a2.315,2.315,0,0,0-.122-.394c-.048.17-.1.339-.034.348a1.562,1.562,0,0,1,1.3-.238l-.818.6.248,1.261-.888.423.259-.907a3.293,3.293,0,0,1-.567-1.048,1.037,1.037,0,0,1,.053-1.21.733.733,0,0,0,0-.675c-.473-.568-.134-1.241-.308-1.825l-.737-.375a6.491,6.491,0,0,1-2.095.564c-.068,0-.146.175-.22.268-.667.1-.439.791-.759,1.235l-.873-.725.746-.308.04-.38-.843.178v-.495c-.469.077-.941.471-1.456.031l.844-1.7-.332-.332-1.026.522c-.052-.466-.421-.206-.715-.307l-.5.672-.445-.52.77-1.169a1.9,1.9,0,0,0-1.749.262l-.411-.492a1.7,1.7,0,0,1,1.569-.679,10.284,10.284,0,0,1,1.61.523,1.777,1.777,0,0,0,.377-1.582c-.506.024-.77.366-1,.841l-1.382-.876-.155.463-.506.082.153-.556c-.061-.488-.1-.826-.145-1.166l.281-.213-.281-.35.281-.844c.61.119.518.71.668,1.161l.334-.334.915,1.142h.335l.093.233a.556.556,0,0,0,.141-.257c.313-.024.58-.024,1.093-.024l-.633-.5a3.7,3.7,0,0,0-.459.527.639.639,0,0,1-.234.024V709.2a2.447,2.447,0,0,1-.851-.644c.287-.021.564-.057,1.086-.124l-1.04-.535c-.024.306-.037.474-.046.66-.585.2-.7-.61-1.252-.591l-.149.293-.562-.281.115-.247-.806-.806.161-.17c-.023-.22-.047-.44-.075-.7h-1.017c-.037-.388-.071-.736-.1-1.016l-.787-.495a2.892,2.892,0,0,1,1.1-2.937v-1.223h.563v-.532a3.928,3.928,0,0,0,.429-.3l.289.252-.3-.348.731-.052-.12-.155-1.027.054v.545c-.188.157-.375.345-.563.532h-.844c.094-.188.188-.375.267-.576,0,.006.022.024.04.042l.23-.2-.089-.089a1.571,1.571,0,0,0-.182.243c-.267-.081-.548-.175-.829-.269l-.281-.281.362-.543c.3-.308.87.337,1.069-.314a3.78,3.78,0,0,1,.475.326c.13-.5.129-.892-.451-1.133,0,.286,0,.553-.024.807-.307-.079-.59-.17-.944-.285l.242-.285-.247-.51-.537.3c-.532-.355-.641-1.115-1.352-1.172v-.563l.281-.281h.844v1.034l.925.39-.311-.8,1.229-.834.408.227.587-.415-.3-.3c.288-.343.813-.63.451-1.256-.095.077-.174.186-.276.214a4.06,4.06,0,0,1-.611.072l-.479-.713.609-.284-.025-.151h-.8v-.664l1-.7h.98l-.962.534c.487.572,1.131.768,1.314,1.483.237-.778,1.123-.8,1.329-1.5-.09-.173-.19-.365-.3-.569,0,.006.022.024.04.042l.23-.2-.089-.089a1.592,1.592,0,0,0-.182.243c-.159.013-.333.013-.631.013l.452-1.092h.5l1.1.961-.316.316.568.307c.02-.286.045-.636.069-.967.074-.031.115-.064.138-.054.04.018.064.067.1.094a28.989,28.989,0,0,1,4.426,3.881c.1.114.08.341.135.607-.946.137-1.069,1.083-1.606,1.648a10.56,10.56,0,0,0-1.239,2.164v.731l-.5.395c-.136.916-.291,1.667-.348,2.425s-.012,1.495-.012,2.14a4.671,4.671,0,0,1,.839,2.763,6.322,6.322,0,0,1,1.026,1.484c.345,1.083,1.22,1.527,2.07,2.042l-.208.208,1.23,1.022.257-.258a4.071,4.071,0,0,0,2.835,1.442c.267.5.85-.463,1.075.231.465.007.93.018,1.4.022.421,0,.845.027,1.263-.007a2.533,2.533,0,0,0,1.317-.224,5.1,5.1,0,0,1,1.717-.336l.957,3.621-.674.052-.731.866c0-.012-.024.209-.055.475l-.974.14.8.514c-.646.69-.152,1.43-.406,2.019l.55.55v1.049h-.41l-.491-1.313c-.273-.154-.82-.28-.72-.936h.511c.02-.335.04-.675.065-1.114l-1.077-.433-.244-.541-.19.987c-1.039-.084-.519-1.352-1.319-1.5a2.666,2.666,0,0,0,.28-.6.673.673,0,0,1,.011.133l.548-.107c-.008-.061-.016-.121-.025-.182A.993.993,0,0,0,1484.324,717.157Zm-14.655-12.806.055-.055-.2-.23-.089.089c.077.065.153.131.375.011l-.371.96.958.482A2.969,2.969,0,0,0,1469.669,704.351Zm1.933-8.761-.243.012.108.55.182-.025a.559.559,0,0,0-.341-.53l.318-1.633-.75.665.26.4-.318.567C1471.061,695.6,1471.153,695.6,1471.6,695.59Zm-3.314,8.948c0-.222.057-.42-.012-.485a3.3,3.3,0,0,0-.753-.351l.824,1.439.869-.438a1.183,1.183,0,0,1-.957-.688l.055.055.23-.2-.089-.089C1468.389,703.862,1468.324,703.938,1468.288,704.538Zm9.031,8.759-.055.055.2.23.089-.089a.812.812,0,0,0-.255-.167c-.049-.458-.411-.21-.633-.281-.461.185-.586.823-1.173.867-.061,0-.1.329-.145.5.363-.361.756-.229,1.061-.344v.878l-.525.172.036.173,1.048-.184.273.2c-.023-.808-.023-.808-.787-1.14.09-.137.264-.28.256-.411C1476.673,713.269,1476.989,713.321,1477.318,713.3Zm10.608,3.206-.8.23-.83.776c.011.109.035.353.065.655l.362-.315.4.33.413-1.16.792-.11Zm-13.448-3.48v-.106l-1.073-1.073v1.179Zm-2.19-5.726-1.269-.992-.9.5.394.367.579-.333C1471.546,706.911,1471.6,707.616,1472.289,707.3Zm-3.342-5.462-.169.15.6.815-.451.545,1.038-.457-.348-.735Zm5.248,12.474c.017.272.039.611.068,1.074l.712-.749Zm-5.12-17.193-.438-.489v1.367Zm.653-1.85-.6.114c.018.28.034.528.06.939Zm5.107,17.524v.852l.6-.121Zm-2.434-19.747-.271-.584-.134.1v.484Zm-4.464,10.282v-.438l-.373.065Zm1.372-6.189c.813.323.672-.043.626-.313Zm4.212,14.14c.089-.425.089-.425-.594-.37Zm5.11,3.177h-.141v.563h.141Zm-8.605-12.708.243-.03-.109-.458-.134.022Zm1.289,1.452h-.141v.563h.141Zm10.107,12.382h-.094v.281h.094Zm-7.035-4.5h-.094v.281h.094Zm11.162,6.472h.094v-.281h-.094Zm-2.72-1.407h-.094v.281h.094Zm-10.6-22.325v-.094h-.281v.094Zm-1.595-.469h.094v-.281h-.094Zm-.375,12.476v.094h.281v-.094Zm-.188-4.878h.094v-.281h-.094Zm.938-3.1h-.094v.281h.094Zm-.844,0h-.094v.281h.094Zm-.469-.094v-.094h-.281v.094Zm-2.532-.938v.094h.281v-.094Zm2.345-2.064h.094v-.281h-.094Z",
    transform: "translate(-1458.183 -687.718)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55219",
    "data-name": "Path 55219",
    d: "M1517.906,778.637a6.174,6.174,0,0,0,.274.921.513.513,0,0,0-.04-.042l-.23.2.089.089a1.585,1.585,0,0,0,.181-.243c.126-.013.267-.013.5-.013l.074.736,1.611.849v1.032l-.7-.33-1.213.245.346-1.345-1.107-.1-.173-.478-.755.369v.428h-.844a3.938,3.938,0,0,1,.024-.564c.257-.125.529-.268.84-.433l-.816-.385c0,.286,0,.552-.024.818-.33.209-.636.417-1.066.709-.036-.42-.06-.7-.083-.989h.565l-.335-.642.754-.435.522.313-.38-1.488c.708.005,1-.41,1.142-1.049a2.515,2.515,0,0,1,.457-.711l.653.353c0,.469,0,.938.015,1.42a.474.474,0,0,0-.04-.043l-.23.2.089.089a1.585,1.585,0,0,0,.181-.243,5.367,5.367,0,0,1,.5-.309c.019.262.037.511.054.738a4.972,4.972,0,0,1-.829.339,10.1,10.1,0,0,0-1.388-.421v.667l.36.36C1517.212,779.06,1517.365,778.542,1517.906,778.637Zm1.9,2.83q-.008-.121-.015-.241l-.47.1.019.139Z",
    transform: "translate(-1492.583 -746.901)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55220",
    "data-name": "Path 55220",
    d: "M1466.658,698.024l-.563-.844,1.166-.434c-.068-.231-.146-.477-.213-.725s-.127-.509-.176-.708l-1.005.213-.055-.532.838-.128V693.8h1.134l-.2.785.483.622v.766l-.754.246.972.186-.274.839Z",
    transform: "translate(-1458.805 -690.145)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55221",
    "data-name": "Path 55221",
    d: "M1468.471,738.257c.013.527.029,1.071,0,1.611-.006.119-.175.229-.281.358a.511.511,0,0,0,.042-.04l-.2-.23-.089.089a1.559,1.559,0,0,0,.243.181c.013.126.013.266.013.409l-.755.387-.62-.891v-.793l1.025.2.246-.577c-.067-.287-.153-.655-.279-1.193l-.794-.631.542-.93,1.193.821c-.156.331.289.86-.289,1.233a.58.58,0,0,0,.042-.04l-.2-.23-.089.089A1.591,1.591,0,0,0,1468.471,738.257Z",
    transform: "translate(-1459.505 -719.388)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55222",
    "data-name": "Path 55222",
    d: "M1460.324,685.642l.259.445-.515.515.963.629-.93.146v.8l.51-.331.614.507-.33.685c-.007.029.709.352-.009.548-.36-.575-1.05-.851-1.4-1.775l.245-1.212-.2-.2.367-.751Z",
    transform: "translate(-1454.441 -684.516)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55223",
    "data-name": "Path 55223",
    d: "M1475.436,747.032l-.759-.2-.59.288v-1.1a2.726,2.726,0,0,1-.51-.155,1.876,1.876,0,0,1-.341-.329V744.46a2.752,2.752,0,0,1,1.311.677,1.7,1.7,0,0,0,.608.206l-.219.8.5.325Z",
    transform: "translate(-1463.925 -725.082)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55224",
    "data-name": "Path 55224",
    d: "M1461.077,708.143l-.906.248-.819-.405c.151-.487.392-.753.867-.693.026.194.062.377.066.4l.555-.211-.108-.156c-.166-.012-.332-.024-.513-.033-.013-.336.131-.724-.311-1l1.047-.674.4.555-.281.281-.281.213.281.35Z",
    transform: "translate(-1454.349 -698.293)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55225",
    "data-name": "Path 55225",
    d: "M1490.147,774.952l.38,2.257-1.614-.488.651-.557-.534-.634.418-.85Z",
    transform: "translate(-1474.738 -745.923)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55226",
    "data-name": "Path 55226",
    d: "M1467.94,687.866l-1.9.377v-1.416a4.313,4.313,0,0,1,1.9.341Z",
    transform: "translate(-1458.961 -685.332)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55227",
    "data-name": "Path 55227",
    d: "M1518.583,796.7l-.562.844c-.188-.175-.548-.366-.533-.523.065-.69-.447-.807-.869-1.023.131-.512.261-1.018.391-1.525l.322-.031.5,1.976h.472Z",
    transform: "translate(-1493.845 -759.554)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55228",
    "data-name": "Path 55228",
    d: "M1482.107,782.482l-.8.359-.309-.176-.263.222-.422-.388.192-.8.582-.717Z",
    transform: "translate(-1468.806 -750.272)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55229",
    "data-name": "Path 55229",
    d: "M1461.487,698.338l.255.445-.25.266.839.472v.787h-.761l-.518-.844h-.638c-.021-.242-.042-.492-.06-.706Z",
    transform: "translate(-1455.041 -693.272)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55230",
    "data-name": "Path 55230",
    d: "M1466,715.677l-.51.7-.682-.608.283-.508c-.507-.187-.578-.834-1.051-1.083l.271-.467c.593-.16.6.64,1.074.66.231.307-.266.841.333,1.028Z",
    transform: "translate(-1457.58 -703.857)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55231",
    "data-name": "Path 55231",
    d: "M1510.64,793.385l.447.45c-.339.74-1,1.364-.773,2.382l-.852.043v-.765l.5-.18-.274-.436Z",
    transform: "translate(-1488.909 -758.825)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55232",
    "data-name": "Path 55232",
    d: "M1459.688,723.839c-.094.07-.235.12-.272.212-.123.307-.208.631-.307.945l-.547-.313v-.435l.567-.258-.33-.355.473-.971.909.25.213-.2.41.41-.347.374-.769-.3Z",
    transform: "translate(-1453.805 -710.05)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55233",
    "data-name": "Path 55233",
    d: "M1528.5,798.015l.417.367,1.012-.778.7.687c-.449.256-.675.364-.877.506a5.725,5.725,0,0,0-.5.445l-1.264-.512Z",
    transform: "translate(-1501.683 -761.734)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55234",
    "data-name": "Path 55234",
    d: "M1466.977,765l-1.109,1.32a1.6,1.6,0,0,1-.865-1.773h.4l.2.591,1.2-.3Z",
    transform: "translate(-1458.226 -738.938)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55235",
    "data-name": "Path 55235",
    d: "M1476.79,689.389c.054.388.1.7.151,1.08-.744-.3-.53-.865-.572-1.344-.449-.219-1.09.166-1.368-.584l.73-.417,1.239.828Z",
    transform: "translate(-1465.142 -686.228)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55236",
    "data-name": "Path 55236",
    d: "M1498.745,780.033l.713-.372.282.634-.426.452,1.245.436-.765.72-.283-.689c-.424-.067-.91-.053-1.049-.619C1498.885,780.572,1498.7,780.247,1498.745,780.033Z",
    transform: "translate(-1481.324 -749.359)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55237",
    "data-name": "Path 55237",
    d: "M1463.454,730.769c.243.01.508.01.8.01v.419l-1.581.362-.313-.711c.064-.581.064-.581,1.04-.638.016.172.031.346.057.557a.191.191,0,0,0-.048-.065l-.23.2.089.089C1463.33,730.912,1463.4,730.835,1463.454,730.769Z",
    transform: "translate(-1456.422 -715.255)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55238",
    "data-name": "Path 55238",
    d: "M1469.122,723.344,1468.6,725l-.757-.445.743-.149-.789-1.268.8-.8.7.722Z",
    transform: "translate(-1460.173 -709.826)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55239",
    "data-name": "Path 55239",
    d: "M1496.08,779.5h-1.073v-1.43l1.354.425v.442C1495.94,778.958,1496.122,779.283,1496.08,779.5Z",
    transform: "translate(-1478.94 -748.26)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55240",
    "data-name": "Path 55240",
    d: "M1539.362,778.163l.841.418.249-.709.553,1.363-1.7.457-.145-.217.817-.189-.28-.288Z",
    transform: "translate(-1509.395 -748.125)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55241",
    "data-name": "Path 55241",
    d: "M1522.042,797.058a2.111,2.111,0,0,1,1.407-1.688l.309.587-1.435,1.383Z",
    transform: "translate(-1497.585 -760.194)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55242",
    "data-name": "Path 55242",
    d: "M1485.144,775.555l.328-.182-.426-.848.946-.133-.151,1.127.242.827-1.22.065v-.574Z",
    transform: "translate(-1471.943 -745.725)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55243",
    "data-name": "Path 55243",
    d: "M1462.916,738.028l.814.6-.678.441-.116.68-.74-.359C1461.959,738.781,1462.484,738.5,1462.916,738.028Z",
    transform: "translate(-1456.27 -720.646)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55244",
    "data-name": "Path 55244",
    d: "M1463.895,753.463l-.67.241.145.162h-.916l-.446-.964c.715-.476,1.128.516,1.79.012Z",
    transform: "translate(-1456.181 -730.813)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55245",
    "data-name": "Path 55245",
    d: "M1504.325,774.36l-.437-1.327.466-.492.31.544-.286.329h1.191c-.066.163-.073.257-.12.286C1505.085,773.923,1504.713,774.134,1504.325,774.36Z",
    transform: "translate(-1485.065 -744.449)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55246",
    "data-name": "Path 55246",
    d: "M1502.163,799.251v-.883l.919-.446.613.73Z",
    transform: "translate(-1483.875 -761.954)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55247",
    "data-name": "Path 55247",
    d: "M1513.918,804.5c.512-.2.838-.018,1.124.448l-.267.454.209.362C1514.256,805.586,1513.741,805.279,1513.918,804.5Z",
    transform: "translate(-1491.958 -766.432)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55248",
    "data-name": "Path 55248",
    d: "M1454.172,696.744v-1.067c.575-.281.451.259.627.458l.492.051-.743.743Z",
    transform: "translate(-1450.777 -691.382)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55249",
    "data-name": "Path 55249",
    d: "M1467.573,760.125h-1.43a1.9,1.9,0,0,1,.867-1.14Z",
    transform: "translate(-1459.033 -735.1)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55250",
    "data-name": "Path 55250",
    d: "M1450.845,698.79l-.611.271.178.188-.36.7-.7-.624c.063-.141.083-.3.171-.364.272-.209.57-.383.862-.574Z",
    transform: "translate(-1447.455 -693.305)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55251",
    "data-name": "Path 55251",
    d: "M1537.085,796.033l-.96.346-.445-.879.947-.408Z",
    transform: "translate(-1506.991 -760.003)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55252",
    "data-name": "Path 55252",
    d: "M1457.042,705.8l-.654-.5.521-.66.342.342.255,1.269-.8.415Z",
    transform: "translate(-1452.305 -697.62)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55253",
    "data-name": "Path 55253",
    d: "M1475.808,771.218a.833.833,0,0,1-1.031-.608l.7-.459.7.325Z",
    transform: "translate(-1464.988 -742.8)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55254",
    "data-name": "Path 55254",
    d: "M1499.614,789.308c-.146.706-.508.9-1.091.735-.231-.535-.024-.867.471-1.1Z",
    transform: "translate(-1481.3 -755.761)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55255",
    "data-name": "Path 55255",
    d: "M1453.629,730.724a1.174,1.174,0,0,1-.475-1.441h.677A2.026,2.026,0,0,1,1453.629,730.724Z",
    transform: "translate(-1450.029 -714.615)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55256",
    "data-name": "Path 55256",
    d: "M1478.5,765.706c.132-.1.231-.184.341-.25a2.276,2.276,0,0,1,.337-.123l.53,1.006a1.773,1.773,0,0,1-.41.149C1478.707,766.528,1478.479,766.2,1478.5,765.706Z",
    transform: "translate(-1467.556 -739.478)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55257",
    "data-name": "Path 55257",
    d: "M1495.04,794.32l-.437.437h-.777a3.1,3.1,0,0,1,.174-.787c.19-.355.411-.308.624.031C1494.712,794.14,1494.9,794.215,1495.04,794.32Z",
    transform: "translate(-1478.126 -759.058)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55258",
    "data-name": "Path 55258",
    d: "M1521.643,805.283l-.713.372-.282-.632.151-.584C1521.43,804.5,1521.584,804.653,1521.643,805.283Z",
    transform: "translate(-1496.624 -766.448)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55259",
    "data-name": "Path 55259",
    d: "M1532.826,807.166l-.478,1.142-.841-.769,1.109-.552Z",
    transform: "translate(-1504.113 -768.206)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55260",
    "data-name": "Path 55260",
    d: "M1453.594,736.56h1.215c.016.2.035.454.055.706C1454.221,737.526,1453.908,737.251,1453.594,736.56Z",
    transform: "translate(-1450.378 -719.633)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55261",
    "data-name": "Path 55261",
    d: "M1468.735,682.754l1.859.386v.418a.8.8,0,0,1-.98-.178,3.339,3.339,0,0,0-.916-.419Z",
    transform: "translate(-1460.796 -682.524)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55262",
    "data-name": "Path 55262",
    d: "M1500.278,773.024l.814.527v.853l-.814-.813Z",
    transform: "translate(-1482.575 -744.782)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55263",
    "data-name": "Path 55263",
    d: "M1458.791,742.181l.645.805c-.506.438-.988.064-1.359.25Z",
    transform: "translate(-1453.47 -723.51)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55264",
    "data-name": "Path 55264",
    d: "M1507.434,794.156c-.037-.083-.121-.179-.1-.237a2.865,2.865,0,0,1,.225-.423l-.327-.659h1.006C1507.986,793.344,1507.955,793.877,1507.434,794.156Z",
    transform: "translate(-1487.371 -758.446)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55265",
    "data-name": "Path 55265",
    d: "M1475.688,755.031l.258.889-.574.333-.337-.337.368-.753Z",
    transform: "translate(-1465.166 -732.372)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55266",
    "data-name": "Path 55266",
    d: "M1488.021,786.512l.9,1.3h-.777C1488.229,787.439,1487.453,787.236,1488.021,786.512Z",
    transform: "translate(-1473.977 -754.084)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55267",
    "data-name": "Path 55267",
    d: "M1470.75,773.111l-1.157.449v-.854C1470.04,772.356,1470.36,772.672,1470.75,773.111Z",
    transform: "translate(-1461.412 -744.459)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55268",
    "data-name": "Path 55268",
    d: "M1465.152,682.014h.713c.022.242.044.492.072.8h-.785Z",
    transform: "translate(-1458.349 -682.014)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55269",
    "data-name": "Path 55269",
    d: "M1454.029,744.415V743.7l.8-.072v.785Z",
    transform: "translate(-1450.678 -724.509)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55270",
    "data-name": "Path 55270",
    d: "M1471.49,691.3l-.3-.563.3-.563c.551.157.652.537.487,1.125Z",
    transform: "translate(-1462.51 -687.643)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55271",
    "data-name": "Path 55271",
    d: "M1455.064,716.6h.774v.745h-.774Z",
    transform: "translate(-1451.392 -705.869)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55272",
    "data-name": "Path 55272",
    d: "M1541.386,786.653c-.043-.913-.043-.913.345-1.449l.377.684Z",
    transform: "translate(-1510.914 -753.182)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55273",
    "data-name": "Path 55273",
    d: "M1488.13,767.884l-.636.271c-.035-.045-.176-.228-.321-.408a.71.71,0,0,1-.2-.6l1.054.411Z",
    transform: "translate(-1473.398 -740.73)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55274",
    "data-name": "Path 55274",
    d: "M1454.865,757.061l-.781-1.576.781-.042Z",
    transform: "translate(-1450.716 -732.657)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55275",
    "data-name": "Path 55275",
    d: "M1494.888,790.741l-.386-1.526,1.065.684Z",
    transform: "translate(-1478.592 -755.949)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55276",
    "data-name": "Path 55276",
    d: "M1490.417,800.207v-1.191l.751-.049c.024.18.1.355.047.423A11.4,11.4,0,0,1,1490.417,800.207Z",
    transform: "translate(-1475.774 -762.674)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55277",
    "data-name": "Path 55277",
    d: "M1481.5,770.952l1.254-.491v1.06Z",
    transform: "translate(-1469.625 -743.014)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55278",
    "data-name": "Path 55278",
    d: "M1512.94,800.317l.442-.442c.22.352.744.459.683,1.1C1513.469,801.129,1513.32,800.55,1512.94,800.317Z",
    transform: "translate(-1491.308 -763.301)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55279",
    "data-name": "Path 55279",
    d: "M1453.555,714.2c-.4-.338-.679-.633-.434-1.108.453.079.453.079.8.491Z",
    transform: "translate(-1449.989 -703.451)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55280",
    "data-name": "Path 55280",
    d: "M1447.3,726.73l-.721.9-.538-.5C1446,726.856,1446.393,726.7,1447.3,726.73Z",
    transform: "translate(-1445.169 -712.851)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55281",
    "data-name": "Path 55281",
    d: "M1471.653,759.436l-1.14-.082.932-1.018Z",
    transform: "translate(-1462.047 -734.652)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55282",
    "data-name": "Path 55282",
    d: "M1452.9,692.411l-.905-.486.966-.333.33.339Z",
    transform: "translate(-1449.278 -688.617)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55283",
    "data-name": "Path 55283",
    d: "M1494.048,785.288l-.86.078v-.842C1493.748,784.45,1493.9,784.785,1494.048,785.288Z",
    transform: "translate(-1477.685 -752.706)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55284",
    "data-name": "Path 55284",
    d: "M1483.727,792.734l.789-.662c.071.4.113.638.169.953h-.887Z",
    transform: "translate(-1471.16 -757.919)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55285",
    "data-name": "Path 55285",
    d: "M1511.254,791.712v-.853l.678-.032C1512.232,791.167,1511.98,791.5,1511.254,791.712Z",
    transform: "translate(-1490.145 -757.06)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55286",
    "data-name": "Path 55286",
    d: "M1526.566,813.627h.792v.821C1526.753,814.408,1526.542,814.107,1526.566,813.627Z",
    transform: "translate(-1500.704 -772.785)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55287",
    "data-name": "Path 55287",
    d: "M1462.18,726.569h.793v.821C1462.367,727.351,1462.156,727.049,1462.18,726.569Z",
    transform: "translate(-1456.298 -712.743)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55288",
    "data-name": "Path 55288",
    d: "M1504.453,787.026l1.085.538-.722.73-.2-.13c.057-.146.175-.3.156-.434A3.176,3.176,0,0,0,1504.453,787.026Z",
    transform: "translate(-1485.455 -754.439)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55289",
    "data-name": "Path 55289",
    d: "M1469.955,755.984l-.619-.492.757-.6.137.957Z",
    transform: "translate(-1461.235 -732.276)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55290",
    "data-name": "Path 55290",
    d: "M1455.521,685.8h1.026l-.494.926Z",
    transform: "translate(-1451.707 -684.623)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55291",
    "data-name": "Path 55291",
    d: "M1483.614,777.217h-.495c-.022-.262-.044-.532-.067-.8a.65.65,0,0,1,.843.521Z",
    transform: "translate(-1470.695 -747.106)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55292",
    "data-name": "Path 55292",
    d: "M1507.905,810.047l.966-.579c.022.383.036.629.061,1.052Z",
    transform: "translate(-1487.835 -769.917)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55293",
    "data-name": "Path 55293",
    d: "M1529.446,805.539l-.541-.874h1.1Z",
    transform: "translate(-1502.319 -766.604)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55294",
    "data-name": "Path 55294",
    d: "M1462.4,716.965l.473.929-.915.065C1462.114,717.6,1462.224,717.352,1462.4,716.965Z",
    transform: "translate(-1456.143 -706.119)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55295",
    "data-name": "Path 55295",
    d: "M1460.9,682.29l1.014.566a2.607,2.607,0,0,1-.379.372C1461.319,683.36,1461.31,683.345,1460.9,682.29Z",
    transform: "translate(-1455.415 -682.204)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55296",
    "data-name": "Path 55296",
    d: "M1452.187,707.4l-.419.751-.471-.485.657-.479Z",
    transform: "translate(-1448.795 -699.374)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55297",
    "data-name": "Path 55297",
    d: "M1531.959,786.051h-.811c-.015-.159-.026-.282-.043-.466h.816Z",
    transform: "translate(-1503.836 -753.445)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55298",
    "data-name": "Path 55298",
    d: "M1459.716,765.422l-.435-.684c.5-.446.646.06.909.237Z",
    transform: "translate(-1454.3 -738.944)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55299",
    "data-name": "Path 55299",
    d: "M1476.637,764.641l-.449.347-.418-.418.7-.587Z",
    transform: "translate(-1465.673 -738.547)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55300",
    "data-name": "Path 55300",
    d: "M1523.831,807.281h.811l.043.466h-.816Z",
    transform: "translate(-1498.819 -768.408)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55301",
    "data-name": "Path 55301",
    d: "M1506.056,780.615l.543.543-.741.421-.151-.175a1.43,1.43,0,0,0,.277-.294A1.878,1.878,0,0,0,1506.056,780.615Z",
    transform: "translate(-1486.319 -750.017)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55302",
    "data-name": "Path 55302",
    d: "M1462.713,736.975l-.491-.038c-.015-.169-.025-.291-.044-.5l.85-.039Z",
    transform: "translate(-1456.298 -719.52)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55303",
    "data-name": "Path 55303",
    d: "M1540.071,798.049l.677.052-.535,1.04C1540.145,798.621,1540.109,798.346,1540.071,798.049Z",
    transform: "translate(-1510.02 -762.041)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55304",
    "data-name": "Path 55304",
    d: "M1543.048,798.223v-1.046c.2.029.5-.207.413.211a7.351,7.351,0,0,1-.275.846Z",
    transform: "translate(-1512.073 -761.411)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55305",
    "data-name": "Path 55305",
    d: "M1498.385,801.027c.043-.216.074-.371.13-.649l.878.649Z",
    transform: "translate(-1481.27 -763.647)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55306",
    "data-name": "Path 55306",
    d: "M1538.848,805.346l.413.413-.448.478-.36-.5Z",
    transform: "translate(-1508.904 -767.074)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55307",
    "data-name": "Path 55307",
    d: "M1502.067,788.638l.038-.491.5-.044c.012.266.023.51.039.85Z",
    transform: "translate(-1483.809 -755.182)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55308",
    "data-name": "Path 55308",
    d: "M1443.231,718.536l.732-.6.121.6Z",
    transform: "translate(-1443.231 -706.791)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55309",
    "data-name": "Path 55309",
    d: "M1458.571,717.46h.5c.027.143.052.268.079.414C1458.778,718.092,1458.546,718.088,1458.571,717.46Z",
    transform: "translate(-1453.809 -706.46)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55310",
    "data-name": "Path 55310",
    d: "M1449.138,745.576l-.5-.969.5-.1Z",
    transform: "translate(-1446.961 -725.116)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55311",
    "data-name": "Path 55311",
    d: "M1493.586,773.606v.563h-.563v-.563Z",
    transform: "translate(-1477.572 -745.183)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55312",
    "data-name": "Path 55312",
    d: "M1480.813,791.981v.408l-.494.1c-.037-.183-.062-.308-.1-.511Z",
    transform: "translate(-1468.739 -757.856)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55313",
    "data-name": "Path 55313",
    d: "M1473.987,779.125h.5c.027.143.051.269.079.414C1474.195,779.757,1473.962,779.753,1473.987,779.125Z",
    transform: "translate(-1464.442 -748.99)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55314",
    "data-name": "Path 55314",
    d: "M1457.313,729.134l-.042.535-.479.04c-.019-.17-.036-.324-.058-.53Z",
    transform: "translate(-1452.544 -714.512)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55315",
    "data-name": "Path 55315",
    d: "M1475.4,742.391h-.5l-.079-.414C1475.19,741.759,1475.422,741.763,1475.4,742.391Z",
    transform: "translate(-1465.015 -723.279)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55316",
    "data-name": "Path 55316",
    d: "M1479.62,686.281l.374.6C1479.635,686.943,1479.3,687.03,1479.62,686.281Z",
    transform: "translate(-1468.239 -684.957)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55317",
    "data-name": "Path 55317",
    d: "M1480.891,774.956h-.4v-.484l.134-.1Z",
    transform: "translate(-1468.925 -745.712)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55318",
    "data-name": "Path 55318",
    d: "M1520.51,794.725l.594.371C1520.421,795.15,1520.421,795.15,1520.51,794.725Z",
    transform: "translate(-1496.5 -759.749)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55319",
    "data-name": "Path 55319",
    d: "M1490.38,785.085v-.447h.83Z",
    transform: "translate(-1475.749 -752.792)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55320",
    "data-name": "Path 55320",
    d: "M1502.165,793.112v-.3h.484l.089.122Z",
    transform: "translate(-1483.877 -758.427)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55321",
    "data-name": "Path 55321",
    d: "M1526.928,784.715l-.373.373-.065-.373Z",
    transform: "translate(-1500.653 -752.845)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55322",
    "data-name": "Path 55322",
    d: "M1460.033,720.545h-.4v-.484l.134-.1Z",
    transform: "translate(-1454.54 -708.185)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55323",
    "data-name": "Path 55323",
    d: "M1454.626,733.674l.557.041c-.013.2-.023.349-.036.537l-.662-.428Z",
    transform: "translate(-1450.993 -717.643)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55324",
    "data-name": "Path 55324",
    d: "M1467.355,744.749h-.5l-.085-.1.54-.168C1467.287,744.38,1467.31,744.5,1467.355,744.749Z",
    transform: "translate(-1459.463 -725.073)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55325",
    "data-name": "Path 55325",
    d: "M1488.15,772.009h-.467c-.006-.046-.013-.092-.019-.138l.471-.1C1488.139,771.848,1488.145,771.928,1488.15,772.009Z",
    transform: "translate(-1473.875 -743.916)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55326",
    "data-name": "Path 55326",
    d: "M1521.818,792.088l-.682-.194a2.316,2.316,0,0,1,.394-.122C1521.57,791.767,1521.626,791.873,1521.818,792.088Z",
    transform: "translate(-1496.961 -757.712)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55327",
    "data-name": "Path 55327",
    d: "M1509.915,803.748h-.467l-.019-.139.47-.1C1509.9,803.587,1509.909,803.668,1509.915,803.748Z",
    transform: "translate(-1488.886 -765.805)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55328",
    "data-name": "Path 55328",
    d: "M1521.29,815.905v-.467l.134-.022.109.458Z",
    transform: "translate(-1497.067 -774.02)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55329",
    "data-name": "Path 55329",
    d: "M1448.265,705.8h-.467c-.007-.044-.015-.089-.022-.134l.458-.109Z",
    transform: "translate(-1446.366 -698.254)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55330",
    "data-name": "Path 55330",
    d: "M1454.245,724.8v.467l-.138.019-.1-.47Z",
    transform: "translate(-1450.661 -711.524)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55331",
    "data-name": "Path 55331",
    d: "M1444.28,692.553v-.563h.141v.563Z",
    transform: "translate(-1443.954 -688.894)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55332",
    "data-name": "Path 55332",
    d: "M1462.407,746.566v.467l-.139.019-.1-.47Z",
    transform: "translate(-1456.29 -726.534)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55333",
    "data-name": "Path 55333",
    d: "M1474.282,752.123v-.281h.094v.281Z",
    transform: "translate(-1464.646 -730.173)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55334",
    "data-name": "Path 55334",
    d: "M1474.282,785.676V785.4h.094v.281Z",
    transform: "translate(-1464.646 -753.314)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55335",
    "data-name": "Path 55335",
    d: "M1544.109,784.769v-.281h.094v.281Z",
    transform: "translate(-1512.805 -752.688)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 0.199,
    cy: 0.066,
    rx: 0.199,
    ry: 0.066,
    transform: "translate(14.83 34.688)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55336",
    "data-name": "Path 55336",
    d: "M1544.089,794.86h-.281v-.094h.281Z",
    transform: "translate(-1512.597 -759.777)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55337",
    "data-name": "Path 55337",
    d: "M1527.8,799.366l-.23-.2.089-.089.2.23Z",
    transform: "translate(-1501.396 -762.753)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55338",
    "data-name": "Path 55338",
    d: "M1525.984,812.969l-.23-.2.088-.089.2.23Z",
    transform: "translate(-1500.146 -772.135)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55339",
    "data-name": "Path 55339",
    d: "M1466.12,693.177V692.9h.094v.281Z",
    transform: "translate(-1459.017 -689.519)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55340",
    "data-name": "Path 55340",
    d: "M1482.141,687.758h.281v.094h-.281Z",
    transform: "translate(-1470.067 -685.976)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55341",
    "data-name": "Path 55341",
    d: "M1456.145,682.3v-.281h.094v.281Z",
    transform: "translate(-1452.138 -682.014)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55342",
    "data-name": "Path 55342",
    d: "M1471.259,723.1l.281-.281Z",
    transform: "translate(-1462.561 -710.159)",
    fill: "#104c96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3289",
    "data-name": "Group 3289",
    transform: "translate(251.625 581.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55343",
    "data-name": "Path 55343",
    d: "M742.374,1448.325l.8-1.51h.771a2.148,2.148,0,0,1-2.069,2.553l-.508-.77-.345.76H739.6l-.771-.711c.036-.161.031-.268.08-.333a.837.837,0,0,1,1.022-.327c.019.109.043.239.063.37s.035.265.055.418h.749l.076-.437-.5-.174-.407-1.253.664-.38.634.49-.773.918a5.5,5.5,0,0,1,1.055.015A4.082,4.082,0,0,1,742.374,1448.325Zm-.37.57v.1h.287v-.1Z",
    transform: "translate(-709.716 -1410.342)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55344",
    "data-name": "Path 55344",
    d: "M794.493,1443.934l.567-.329c.486.452.486.452.563.959l-1.693,1.071c.154.712,1.213.476,1.117,1.336a1.963,1.963,0,0,1-1.823-.257l-.315.659-.417-.076.3-.526-1.19-.939,1.138-.346.119.087.89-1.108h.7C794.462,1444.269,794.479,1444.091,794.493,1443.934Z",
    transform: "translate(-746.112 -1408.325)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55345",
    "data-name": "Path 55345",
    d: "M774.281,1443.407c.1-.346.224-.678.354-1.027l.993-.331.757.378-.7,1.012.268,1.947c-.609.086-.923-.357-1.252-.869l-.505.784-.611-.728.237-1.131c.121-.011.3-.027.453-.035.122.1.218.2.326.276-.006,0-.024.023-.043.041l.2.235.091-.091a1.626,1.626,0,0,0-.248-.185C774.5,1443.6,774.4,1443.507,774.281,1443.407Z",
    transform: "translate(-733.692 -1407.252)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55346",
    "data-name": "Path 55346",
    d: "M784.986,1446.04H784.4l-.476-1.225,1.534-1.378v-.48h1.928c.465.675.483.823.137,1.167s-.638.275-1.438-.394Z",
    transform: "translate(-740.818 -1407.878)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55347",
    "data-name": "Path 55347",
    d: "M838.021,1415.49l-.427-1.091-.77-.136.413-.832.65.619h.859c.4-.76.4-.76,1.173-.826.034.034.094.065.1.1.01.187,0,.375,0,.6.547.02.589.549.846.841-.311.6-.844.4-1.34.441l-.159-1-.568,1.564h-.49Z",
    transform: "translate(-777.302 -1387.371)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55348",
    "data-name": "Path 55348",
    d: "M877.854,1447.365h.659l.554,1.314.926-.711h.912a2.036,2.036,0,0,1-.7,2.032l-2.355-1.053Zm1.675,1.532v.1h.287v-.1Z",
    transform: "translate(-805.6 -1410.918)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55349",
    "data-name": "Path 55349",
    d: "M882.757,1389.92l1.073-.22c0,.32.094.621-.016.755a2.244,2.244,0,0,1-1.839,1.019l-.421-.421.253-.293c-.449-.4-1.323-.32-1.455-1.312l1.128.163.155-.807A1.693,1.693,0,0,1,882.757,1389.92Zm-.07.591v-.1H882.4v.1Z",
    transform: "translate(-807.322 -1370.529)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55350",
    "data-name": "Path 55350",
    d: "M791.615,1431.3h.889l.607-1,.584,1.078a3.826,3.826,0,0,0-.674.3,2.392,2.392,0,0,0-.345.42c-.123.144-.255.279-.438.478l.161.695-.473.634-.88-.388-.4-.792Z",
    transform: "translate(-745.456 -1399.151)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55351",
    "data-name": "Path 55351",
    d: "M891.58,1401.363l.523-.712.7.625-.322.562.517.187c-.031.262-.07.587-.123,1.029l.582.831.623-.358.1.841c-.347.347-1.4-.025-2.065-.705l.371-.547-.9.167v-1.345h.788Z",
    transform: "translate(-815.067 -1378.7)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55352",
    "data-name": "Path 55352",
    d: "M712.487,1448.989h-.449l-1.231,1.43c-.515-.8-1.311.636-1.776-.289-.419.541-.984.161-1.569.372l.412-.992c.4.088.937.387,1.194.227.481-.3.928-.062,1.4-.2.2-.49.43-1,1.177-.81l.234-.671Z",
    transform: "translate(-688.085 -1411.393)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55353",
    "data-name": "Path 55353",
    d: "M814.273,1425.56l-.509-.822.006-.006-.662-.662.322-1.606h.789c-.06.362-.114.688-.184,1.11l.258.534c.51.076,1.241.1,1.037.989C815.241,1425.484,814.882,1425.679,814.273,1425.56Z",
    transform: "translate(-760.946 -1393.745)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55354",
    "data-name": "Path 55354",
    d: "M832.808,1425.559v1.277a.767.767,0,0,1-1.1-.306c-.016-.308-.034-.628-.057-1.057l-.413.307a1.8,1.8,0,0,1-.63-1.78C831.557,1424.329,832.008,1425.186,832.808,1425.559Z",
    transform: "translate(-772.979 -1394.804)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55355",
    "data-name": "Path 55355",
    d: "M870.551,1444.127l-2-1.364v-.567l.8-.42.408,1.047,1.193-.217c.169.352.459.676.393.892C871.274,1443.741,870.879,1443.886,870.551,1444.127Z",
    transform: "translate(-799.183 -1407.064)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55356",
    "data-name": "Path 55356",
    d: "M902.845,1414.572l.29.29.649-.864a.833.833,0,0,1,.415.011c.4.187.415.26.5,1.021l-1.03.5-.559.884-.814-.636.4-.49-.259-.3Z",
    transform: "translate(-822.454 -1387.889)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55357",
    "data-name": "Path 55357",
    d: "M838.113,1447.193c-.215.127-.446.24-.643.338l-.49-.612v-1.033l1.1.742h1.429c.021.35.041.7.068,1.16l-1,.357c-.182-.38-.316-.659-.466-.951a.554.554,0,0,0,.041.043l.235-.2-.091-.091A1.629,1.629,0,0,0,838.113,1447.193Z",
    transform: "translate(-777.409 -1409.898)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55358",
    "data-name": "Path 55358",
    d: "M880.311,1398.419v1.073l-.491.468-.746-.584.382-.494-.83-.516a.874.874,0,0,1,.656-1.1c.141.161.31.356.482.549C879.919,1397.991,880.078,1398.163,880.311,1398.419Z",
    transform: "translate(-806.122 -1376.366)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55359",
    "data-name": "Path 55359",
    d: "M915.112,1442.381l.712.259-.453.768c-.5-.41-.681-1.086-1.235-1.2l.277-1.461,1.623.741C916.077,1442.127,915.572,1442.146,915.112,1442.381Z",
    transform: "translate(-830.623 -1406.351)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55360",
    "data-name": "Path 55360",
    d: "M801.9,1432.676V1431.1l.419-.4c.677,0,.833.5.4,1.362l.837.137v.689C802.932,1433.309,802.467,1432.7,801.9,1432.676Z",
    transform: "translate(-753.215 -1399.429)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55361",
    "data-name": "Path 55361",
    d: "M762.1,1447.126c.364-.6,1.127-.811,1.437-1.473.039-.083.233-.113.361-.127a2.252,2.252,0,0,1,.435.035v1C763.153,1447.7,762.937,1447.761,762.1,1447.126Z",
    transform: "translate(-725.768 -1409.647)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55362",
    "data-name": "Path 55362",
    d: "M727.293,1439.054l.671-.817.806,1.025,1.048-.529.351.321-.769.848-.407-.238-.294.621Z",
    transform: "translate(-701.761 -1404.623)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55363",
    "data-name": "Path 55363",
    d: "M909.054,1391.005c-.508.784-.326,1.84-1.356,2.182l-.469-1.355.461-.187.545-1.259Z",
    transform: "translate(-825.859 -1371.621)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55364",
    "data-name": "Path 55364",
    d: "M743.365,1428.338l.507-.506c.226.7,1.472.506,1.257,1.6l-.559.588.262.3-.4.4Z",
    transform: "translate(-712.845 -1397.446)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55365",
    "data-name": "Path 55365",
    d: "M857.5,1437.261l-1.051-1.046-.884.727-.174-.75.85-.863,1.078.4C857.388,1436.091,857.967,1436.468,857.5,1437.261Z",
    transform: "translate(-790.106 -1402.616)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55366",
    "data-name": "Path 55366",
    d: "M802.188,1423.662c-.223.6-.585.758-1.107.588l-.2-.573-.639.293-.446-.419.562-.312.136-.978a.973.973,0,0,1,.82.71C801.44,1423.252,801.845,1423.406,802.188,1423.662Z",
    transform: "translate(-751.765 -1393.605)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55367",
    "data-name": "Path 55367",
    d: "M849.32,1399.132c.586-.1.393-.768.692-1.28l.844.835-.688.231a2.258,2.258,0,0,1,.214.509,4.751,4.751,0,0,1,.009.743l-1.46.453Z",
    transform: "translate(-785.653 -1376.77)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55368",
    "data-name": "Path 55368",
    d: "M784.188,1432.947l.332.244.188-.532h1v.769l-.93.089-.659.967-.993-.891Z",
    transform: "translate(-740.267 -1400.776)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55369",
    "data-name": "Path 55369",
    d: "M909.033,1423.054l-.758.078-.092.463a4.25,4.25,0,0,0-.644-.208,3.753,3.753,0,0,0-.636-.008l-.359-.756.44-.459.867.605.142-.515h1.04Z",
    transform: "translate(-825.387 -1393.538)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55370",
    "data-name": "Path 55370",
    d: "M782.471,1420.5l-.089.413h-.74v-1.149l1.045.225.072-.358c.425-.332.749-.095,1.066.259l-.328.782Z",
    transform: "translate(-739.244 -1391.678)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55371",
    "data-name": "Path 55371",
    d: "M878.624,1381.873v-.78c.378-.447.78-.7,1.283-.156l.3-.272.621.621-.343.606-.494-.248Z",
    transform: "translate(-806.131 -1364.89)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55372",
    "data-name": "Path 55372",
    d: "M862.253,1428.08l.268.62-.267,1.018h-1v-1.638Z",
    transform: "translate(-794.15 -1397.618)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55373",
    "data-name": "Path 55373",
    d: "M776.506,1430.87l.347.677c-.186.179-.171.33.031.6.137.183.026.552.026.933l-.771.046-.44-2.253Z",
    transform: "translate(-735.145 -1399.542)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55374",
    "data-name": "Path 55374",
    d: "M756.049,1440.029l-.57-.327-.97.9-.658-.657v-.835l.735.319.443-.594.6.6.423-.228Z",
    transform: "translate(-720.078 -1405.031)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55375",
    "data-name": "Path 55375",
    d: "M865.318,1446.864l-.444.445-1.89-.335v-.7c.456-.063.906-.221,1.26.194l.509-.359Z",
    transform: "translate(-795.344 -1410.052)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55376",
    "data-name": "Path 55376",
    d: "M857.552,1407.7v-.945l1.316-1.05.444,1C858.566,1406.922,858.388,1407.8,857.552,1407.7Z",
    transform: "translate(-791.598 -1382.189)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55377",
    "data-name": "Path 55377",
    d: "M885.989,1424.831l.729-.3c.348.528,1.31-.223,1.582.8l-.393.54h-.9C886.958,1425.272,886.287,1425.292,885.989,1424.831Z",
    transform: "translate(-811.211 -1395.167)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55378",
    "data-name": "Path 55378",
    d: "M871.351,1425.045l.339,1.165-1.031.442v-.91l-1.161.231v-.814a1.024,1.024,0,0,1,.353-.071,1.381,1.381,0,0,1,.5.17A.686.686,0,0,0,871.351,1425.045Z",
    transform: "translate(-799.837 -1395.524)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55379",
    "data-name": "Path 55379",
    d: "M910.04,1400.936a2.33,2.33,0,0,1,.648-1.666h.637c.44.585-.018,1.087-.2,1.666Z",
    transform: "translate(-827.786 -1377.748)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55380",
    "data-name": "Path 55380",
    d: "M870.5,1405.72v.491l.861.166v.472l-.784-.177-.122.365c-.783.083-1.046-.036-1.1-.514C869.282,1405.974,869.551,1405.786,870.5,1405.72Z",
    transform: "translate(-799.727 -1382.196)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55381",
    "data-name": "Path 55381",
    d: "M894.626,1446.3a5.839,5.839,0,0,1,.733.15,5.526,5.526,0,0,1,.658.332l-.428,1.583-.585-.12.409-.7h-.787Z",
    transform: "translate(-817.167 -1410.186)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55382",
    "data-name": "Path 55382",
    d: "M824.75,1414.305l-1.139.353-.746-.421.748-1.271C824.417,1413.133,824.415,1413.813,824.75,1414.305Z",
    transform: "translate(-767.675 -1387.194)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55383",
    "data-name": "Path 55383",
    d: "M858.547,1443.748v1.019l-.79.11.384.976-1.05-.535.311-.342-.358-.484C857.491,1444.117,857.683,1443.472,858.547,1443.748Z",
    transform: "translate(-791.248 -1408.377)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55384",
    "data-name": "Path 55384",
    d: "M840.788,1424.675v1.6l-.432.72-.69-.612A1.892,1.892,0,0,1,840.788,1424.675Z",
    transform: "translate(-779.263 -1395.269)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55385",
    "data-name": "Path 55385",
    d: "M893.962,1434.809l1.362.671-1.266,1.183h-.618a1.983,1.983,0,0,1,.094-.754C893.711,1435.6,894.145,1435.441,893.962,1434.809Z",
    transform: "translate(-816.349 -1402.258)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55386",
    "data-name": "Path 55386",
    d: "M845.435,1421.416l.543,1.707a.84.84,0,0,1-1.041.6l-.359-.376Z",
    transform: "translate(-782.65 -1393.022)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55387",
    "data-name": "Path 55387",
    d: "M906.154,1443.311l-.425.426h-.976v-1.559l.987.713.266-.732C906.075,1442.7,906.116,1443.015,906.154,1443.311Z",
    transform: "translate(-824.152 -1407.328)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55388",
    "data-name": "Path 55388",
    d: "M754.2,1427.775a.715.715,0,0,1-.754.646.7.7,0,0,1-.682-.718.713.713,0,0,1,.826-.718A.729.729,0,0,1,754.2,1427.775Z",
    transform: "translate(-719.328 -1396.857)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55389",
    "data-name": "Path 55389",
    d: "M888.387,1378.639a.715.715,0,0,1-.646.753.72.72,0,1,1,.646-.753Z",
    transform: "translate(-811.874 -1363.049)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55390",
    "data-name": "Path 55390",
    d: "M743.906,1440.032h1.485c.367.56-.158.92-.275,1.4l-.637.03Z",
    transform: "translate(-713.219 -1405.861)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55391",
    "data-name": "Path 55391",
    d: "M824.677,1445.212a1.8,1.8,0,0,1,.923,1.77h-1.033l-.333-1.007Z",
    transform: "translate(-768.619 -1409.433)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55392",
    "data-name": "Path 55392",
    d: "M717.751,1440.045l.9-.337.566.665a6.972,6.972,0,0,0-.9.69,5.757,5.757,0,0,0-.563,1.016Z",
    transform: "translate(-695.18 -1405.637)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55393",
    "data-name": "Path 55393",
    d: "M845.452,1376.186h1.1l.384.927-.813.411-.675-.32Z",
    transform: "translate(-783.253 -1361.827)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55394",
    "data-name": "Path 55394",
    d: "M912.355,1410.037l1.154-1.165.251.724.155-.156v1h-.994l.142-.132Z",
    transform: "translate(-829.395 -1384.37)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55395",
    "data-name": "Path 55395",
    d: "M824.186,1423.432l-.955.511-.714-1.067.661-.38Z",
    transform: "translate(-767.434 -1393.766)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55396",
    "data-name": "Path 55396",
    d: "M899.243,1429.855a2.926,2.926,0,0,0,1.175-1.292l.6.788-.639.233a1.409,1.409,0,0,1-.834,1.325Z",
    transform: "translate(-820.352 -1397.951)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55397",
    "data-name": "Path 55397",
    d: "M852.555,1429.539c.175.161.347.242.367.351.085.451.123.911.2,1.521l-1.068-.268C851.969,1430.1,851.969,1430.1,852.555,1429.539Z",
    transform: "translate(-787.778 -1398.624)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55398",
    "data-name": "Path 55398",
    d: "M891.066,1352.089l-.868.431c-.457-.266-.684-.617-.469-1.068a.671.671,0,0,1,.827-.389A.734.734,0,0,1,891.066,1352.089Z",
    transform: "translate(-813.734 -1344.477)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55399",
    "data-name": "Path 55399",
    d: "M791.075,1421.5l-.369-.741,1.616-.777c.053.325.089.492.106.661.042.418.055.782-.575.675A2.189,2.189,0,0,0,791.075,1421.5Z",
    transform: "translate(-745.496 -1392.03)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55400",
    "data-name": "Path 55400",
    d: "M797.219,1402.922l.522.545-.894,1.03c-.237-.268-.534-.459-.6-.713C796.1,1403.268,796.34,1403.084,797.219,1402.922Z",
    transform: "translate(-749.288 -1380.267)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55401",
    "data-name": "Path 55401",
    d: "M829.091,1404.01l-.524,1.2-.813-.425c.089.089.022.045.029.025.17-.525.347-1.047.5-1.5Z",
    transform: "translate(-771.046 -1380.538)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55402",
    "data-name": "Path 55402",
    d: "M838.517,1405.3l.7.892-.3.637h-.939C837.716,1406.563,837.891,1405.942,838.517,1405.3Z",
    transform: "translate(-778.018 -1381.906)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55403",
    "data-name": "Path 55403",
    d: "M883.22,1408.131a2.29,2.29,0,0,1-.291,2.158l-.762-1.143A2.209,2.209,0,0,1,883.22,1408.131Z",
    transform: "translate(-808.575 -1383.859)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55404",
    "data-name": "Path 55404",
    d: "M733.267,1452c.482-.629.482-.629,1.515-.944l-.3.773.518.518A1.512,1.512,0,0,1,733.267,1452Z",
    transform: "translate(-705.881 -1413.462)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55405",
    "data-name": "Path 55405",
    d: "M868.481,1434.409h.729l.642,1.005c-.663.533-.663.533-1.421.016C868.447,1435.114,868.464,1434.759,868.481,1434.409Z",
    transform: "translate(-799.101 -1401.983)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55406",
    "data-name": "Path 55406",
    d: "M896.908,1388.054l-.68.349c-.04-.452-.071-.8-.113-1.263.285,0,.559-.082.724.017a10.672,10.672,0,0,1,1.117.875A.634.634,0,0,1,896.908,1388.054Z",
    transform: "translate(-818.194 -1369.36)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55407",
    "data-name": "Path 55407",
    d: "M891.366,1416.184l.28-1.049h1.289l-.28,1.049Z",
    transform: "translate(-814.919 -1388.69)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55408",
    "data-name": "Path 55408",
    d: "M815.468,1452.278v.789H814.12C814.083,1451.912,814.353,1451.751,815.468,1452.278Z",
    transform: "translate(-761.642 -1414.108)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55409",
    "data-name": "Path 55409",
    d: "M872.956,1380.445h-.713l-.525-1.347h1.238Z",
    transform: "translate(-801.368 -1363.836)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55410",
    "data-name": "Path 55410",
    d: "M874.415,1394.894l-.917.478-.683-1.652.731-.1Z",
    transform: "translate(-802.125 -1373.85)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55411",
    "data-name": "Path 55411",
    d: "M876,1413.886l-1.077-.494c-.008-.166-.016-.351-.028-.591l.727-.377.817.4Z",
    transform: "translate(-803.557 -1386.82)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55412",
    "data-name": "Path 55412",
    d: "M819.4,1436.022v-.659l1.044-.062c.091.494.646.837.248,1.483Z",
    transform: "translate(-765.283 -1402.598)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55413",
    "data-name": "Path 55413",
    d: "M833.567,1412.845h-1.049v-1.338l1.049.305Z",
    transform: "translate(-774.333 -1386.188)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55414",
    "data-name": "Path 55414",
    d: "M885.263,1361.741l.76-.337.49.915-.978.666-.271-.271Z",
    transform: "translate(-810.71 -1351.632)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55415",
    "data-name": "Path 55415",
    d: "M837.2,1441.635l.295-.7c.3-.187.568-.061,1.087.521l-.918.921Z",
    transform: "translate(-777.562 -1406.425)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55416",
    "data-name": "Path 55416",
    d: "M772.626,1436.954l-.708.465c-.1-.036-.413-.063-.564-.234a2.635,2.635,0,0,1-.322-.837C771.707,1436.209,772.244,1436.1,772.626,1436.954Z",
    transform: "translate(-731.927 -1403.255)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55417",
    "data-name": "Path 55417",
    d: "M891.241,1343.36c-.793.673-.793.673-1.512.065C890.291,1342.5,890.415,1342.491,891.241,1343.36Z",
    transform: "translate(-813.79 -1338.747)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55418",
    "data-name": "Path 55418",
    d: "M838.065,1374.547v1.3h-1.074a2.413,2.413,0,0,1-.03-.868C837.131,1374.453,837.63,1374.931,838.065,1374.547Z",
    transform: "translate(-777.372 -1360.697)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55419",
    "data-name": "Path 55419",
    d: "M815.254,1410.067l-.182-.737-.237.209v-.984c.141-.022.287-.092.392-.053a8.711,8.711,0,0,1,.816.4l-.5,1.032Z",
    transform: "translate(-762.137 -1384.107)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55420",
    "data-name": "Path 55420",
    d: "M701.035,1450.352c-.516.067-.871-.071-1.031-.56.128-.508.5-.619,1.027-.577l.528.492Z",
    transform: "translate(-682.94 -1412.189)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55421",
    "data-name": "Path 55421",
    d: "M843.744,1439.962h.8c.087.492.2.976-.328,1.387l-.76-.373v-.727Z",
    transform: "translate(-781.877 -1405.812)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55422",
    "data-name": "Path 55422",
    d: "M879.557,1421.479l.664,1.356h-1.612C878.594,1422.212,879.115,1422.072,879.557,1421.479Z",
    transform: "translate(-806.121 -1393.065)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55423",
    "data-name": "Path 55423",
    d: "M919.748,1425.449l1.029.848-.761.77C919.216,1426.561,919.216,1426.561,919.748,1425.449Z",
    transform: "translate(-834.238 -1395.803)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55424",
    "data-name": "Path 55424",
    d: "M881.4,1431.024c.073-1.044.073-1.044,1.047-1.106l.389.819C882.414,1431.115,881.9,1431.017,881.4,1431.024Z",
    transform: "translate(-808.046 -1398.885)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55425",
    "data-name": "Path 55425",
    d: "M881.748,1368.468l.6-.692a.852.852,0,0,1,1.06.728l-.649.2.147.273a5.94,5.94,0,0,0-.546-.338A4.114,4.114,0,0,0,881.748,1368.468Z",
    transform: "translate(-808.286 -1356.022)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55426",
    "data-name": "Path 55426",
    d: "M850.347,1359.956l1.157.487-1.425,1.1C849.67,1360.944,850.214,1360.581,850.347,1359.956Z",
    transform: "translate(-786.341 -1350.634)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55427",
    "data-name": "Path 55427",
    d: "M722.529,1451.005l.937.487-.446,1.035C722.08,1451.947,722.08,1451.947,722.529,1451.005Z",
    transform: "translate(-698.274 -1413.429)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55428",
    "data-name": "Path 55428",
    d: "M886.6,1444.277l-1.333,1.053-.425-.92.4-.4Z",
    transform: "translate(-810.421 -1408.601)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55429",
    "data-name": "Path 55429",
    d: "M896.942,1398.194l.766-.765c.537.334.5.829.4,1.339C897.543,1399,897.2,1398.8,896.942,1398.194Z",
    transform: "translate(-818.765 -1376.478)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55430",
    "data-name": "Path 55430",
    d: "M750.771,1411.486h1.355l-1.072,1.529C750.63,1412.425,750.948,1411.933,750.771,1411.486Z",
    transform: "translate(-717.953 -1386.173)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55431",
    "data-name": "Path 55431",
    d: "M796.286,1412.387v-.606l.384-.384.848.427-.513,1.148Z",
    transform: "translate(-749.344 -1386.112)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55432",
    "data-name": "Path 55432",
    d: "M915.094,1414.769c.029.273.052.493.082.781l-.841.795-.649-.5C914.155,1415.5,914.408,1414.943,915.094,1414.769Z",
    transform: "translate(-830.313 -1388.437)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55433",
    "data-name": "Path 55433",
    d: "M812.576,1437.981c.829.488.927.919.439,1.682-.033.021-.09.066-.1.06-.236-.228-.468-.461-.6-.6Z",
    transform: "translate(-760.4 -1404.446)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55434",
    "data-name": "Path 55434",
    d: "M783.128,1411.791a.7.7,0,0,1,.274-.723c.524.348,1.087.635.887,1.5-.748.013-.865-.751-1.16-.777a2.31,2.31,0,0,1,.361.232l.235-.2-.091-.091C783.566,1411.811,783.5,1411.889,783.128,1411.791Z",
    transform: "translate(-740.263 -1385.885)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55435",
    "data-name": "Path 55435",
    d: "M856.708,1416.886h-1.08v-.764h1.432Z",
    transform: "translate(-790.271 -1389.37)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55436",
    "data-name": "Path 55436",
    d: "M860.617,1415.747c.5.355.68.708.477,1.078a.736.736,0,0,1-1.154.247Z",
    transform: "translate(-793.246 -1389.112)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55437",
    "data-name": "Path 55437",
    d: "M831.944,1422.095v-.753l-.524-.175-.076-.449a5.274,5.274,0,0,0,.714.22,4.412,4.412,0,0,0,.681.008C832.724,1421.882,832.724,1421.882,831.944,1422.095Z",
    transform: "translate(-773.523 -1392.54)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55438",
    "data-name": "Path 55438",
    d: "M818.139,1450.427l.751-.619.57,1.088-.6.7Z",
    transform: "translate(-764.416 -1412.603)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55439",
    "data-name": "Path 55439",
    d: "M805.058,1451.409c-.437-.826-.437-.826.271-1.483l.6.565A2.2,2.2,0,0,1,805.058,1451.409Z",
    transform: "translate(-755.188 -1412.684)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55440",
    "data-name": "Path 55440",
    d: "M780.594,1399.068c.746.718.746.718.76,1.536l-1.2-.477Z",
    transform: "translate(-738.22 -1377.609)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55441",
    "data-name": "Path 55441",
    d: "M879.107,1439.449l1.2,1.12-.951.32C879.127,1441.044,878.92,1440.356,879.107,1439.449Z",
    transform: "translate(-806.414 -1405.459)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55442",
    "data-name": "Path 55442",
    d: "M806.95,1445.834v.638c-.447.447-1.058.016-1.4-1.06Z",
    transform: "translate(-755.732 -1409.571)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55443",
    "data-name": "Path 55443",
    d: "M879.745,1356.3l1.13.552-.671.792C879.608,1357.326,879.36,1356.982,879.745,1356.3Z",
    transform: "translate(-806.777 -1348.115)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55444",
    "data-name": "Path 55444",
    d: "M870.913,1453.709h-1.469a.6.6,0,0,1,.537-.809C870.48,1452.8,870.722,1453.105,870.913,1453.709Z",
    transform: "translate(-799.781 -1414.722)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55445",
    "data-name": "Path 55445",
    d: "M885.633,1439.826l-.487-.5.423-.457.58.218.667-.265v.888l-.543-.262Z",
    transform: "translate(-810.629 -1405.027)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55446",
    "data-name": "Path 55446",
    d: "M834.568,1436.039v.74l-.843.827-.587-.509Z",
    transform: "translate(-774.76 -1403.107)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55447",
    "data-name": "Path 55447",
    d: "M698.747,1436.418l-1.13-.552.671-.792C698.884,1435.4,699.132,1435.74,698.747,1436.418Z",
    transform: "translate(-681.294 -1402.441)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55448",
    "data-name": "Path 55448",
    d: "M829.318,1435.64l-1.208-.6.608-.743C829.337,1434.435,829.529,1434.8,829.318,1435.64Z",
    transform: "translate(-771.293 -1401.908)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55449",
    "data-name": "Path 55449",
    d: "M886.021,1432.551c.472-.03.946-.056,1.183.622l-.471.534C885.971,1433.6,886.005,1433.065,886.021,1432.551Z",
    transform: "translate(-811.229 -1400.693)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55450",
    "data-name": "Path 55450",
    d: "M912.593,1431.166l.584-.459c.418,0,.568.252.591,1.073C913.26,1431.993,912.911,1431.813,912.593,1431.166Z",
    transform: "translate(-829.559 -1399.429)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55451",
    "data-name": "Path 55451",
    d: "M734.486,1422.378h.642l.408.807-1.05.508Z",
    transform: "translate(-706.722 -1393.685)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55452",
    "data-name": "Path 55452",
    d: "M873.071,1402.547v-.959l.407-.4c.639.273.41.826.469,1.355Z",
    transform: "translate(-802.301 -1379.073)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55453",
    "data-name": "Path 55453",
    d: "M865.614,1398.153l.329,1.332c-.571-.367-1.2-.4-1.463-1.167Z",
    transform: "translate(-796.376 -1376.977)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55454",
    "data-name": "Path 55454",
    d: "M808.278,1399.364c-.563.156-.927.009-1.189-.7l.585-.41C808.219,1398.407,808.427,1398.745,808.278,1399.364Z",
    transform: "translate(-756.795 -1377.049)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55455",
    "data-name": "Path 55455",
    d: "M804.784,1386.843l1.13.552-.671.792C804.647,1387.865,804.4,1387.521,804.784,1386.843Z",
    transform: "translate(-755.078 -1369.177)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55456",
    "data-name": "Path 55456",
    d: "M862.221,1385.516l-.577,1.21-.772-.632C861.09,1385.46,861.462,1385.324,862.221,1385.516Z",
    transform: "translate(-793.888 -1368.207)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55457",
    "data-name": "Path 55457",
    d: "M898.884,1381.921l.457-.725c.645.585.645.585.671,1.21C899.5,1382.639,899.156,1382.448,898.884,1381.921Z",
    transform: "translate(-820.104 -1365.283)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55458",
    "data-name": "Path 55458",
    d: "M904.943,1375.727a2.39,2.39,0,0,0-.361-.288,3.025,3.025,0,0,0-.537-.135l.811-1.006C905.426,1374.557,905.456,1374.91,904.943,1375.727Z",
    transform: "translate(-823.664 -1360.525)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55459",
    "data-name": "Path 55459",
    d: "M692.044,1445.514c.429.559.429.559.291,1.432C691.4,1446.461,691.378,1446.373,692.044,1445.514Z",
    transform: "translate(-677.132 -1409.641)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55460",
    "data-name": "Path 55460",
    d: "M772.039,1430.2c-.708-.273-.862-.634-.7-1.192h.675l.364.726Z",
    transform: "translate(-732.099 -1398.258)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55461",
    "data-name": "Path 55461",
    d: "M776.165,1422.733l.642.69-.563.724-.822-.626Z",
    transform: "translate(-734.955 -1393.93)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55462",
    "data-name": "Path 55462",
    d: "M815.7,1446.084l-1.045.5-.387-.834h1.3Z",
    transform: "translate(-761.748 -1409.802)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55463",
    "data-name": "Path 55463",
    d: "M830.019,1452.19l-.244-.371.345-.712c.475-.061.648.2.7,1.083Z",
    transform: "translate(-772.441 -1413.493)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55464",
    "data-name": "Path 55464",
    d: "M833.415,1389.536l.757-.376.358.542c-.122.5-.521.636-1.115.558Z",
    transform: "translate(-774.951 -1370.775)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55465",
    "data-name": "Path 55465",
    d: "M849.623,1388.211l.413-1.08.865.494C850.73,1388.171,850.421,1388.423,849.623,1388.211Z",
    transform: "translate(-786.13 -1369.376)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55466",
    "data-name": "Path 55466",
    d: "M906.216,1379.644c.024.39.046.736.065,1.046l-.433.433C905.173,1380.282,905.189,1380.2,906.216,1379.644Z",
    transform: "translate(-824.588 -1364.212)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55467",
    "data-name": "Path 55467",
    d: "M843.115,1397.069l-.425-.836c-.008.019,0-.034.022-.045.2-.089.4-.17.558-.233l.842.707Z",
    transform: "translate(-781.345 -1375.462)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55468",
    "data-name": "Path 55468",
    d: "M897.369,1359.692l-.653-.794.652-.713.719.6Z",
    transform: "translate(-818.608 -1349.412)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55469",
    "data-name": "Path 55469",
    d: "M895.7,1393.849l-.719-.669.588-.7.747.552Z",
    transform: "translate(-817.409 -1373.062)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55470",
    "data-name": "Path 55470",
    d: "M863.9,1390.294v-.678l.673-.344.5.361C864.883,1390.22,864.576,1390.475,863.9,1390.294Z",
    transform: "translate(-795.976 -1370.852)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55471",
    "data-name": "Path 55471",
    d: "M903.87,1437.5l-.46-.19.245-.3-.353-.506.768-.637c.092.216.2.345.178.441C904.151,1436.7,904.013,1437.07,903.87,1437.5Z",
    transform: "translate(-823.151 -1402.991)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55472",
    "data-name": "Path 55472",
    d: "M868.591,1373.071s.063.019.093,0a.515.515,0,0,0,.111-.108l.726.726-.93.367Z",
    transform: "translate(-799.211 -1359.599)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55473",
    "data-name": "Path 55473",
    d: "M892.75,1369.712h.716v1.067C892.685,1370.6,892.688,1370.6,892.75,1369.712Z",
    transform: "translate(-815.856 -1357.362)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55474",
    "data-name": "Path 55474",
    d: "M831.436,1363.517l-.515.482-.708-.551.641-.843Z",
    transform: "translate(-772.744 -1352.461)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55475",
    "data-name": "Path 55475",
    d: "M885.368,1418.676l.5.5-1.422.6C884.549,1419.115,884.549,1419.115,885.368,1418.676Z",
    transform: "translate(-810.146 -1391.132)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55476",
    "data-name": "Path 55476",
    d: "M758.472,1419.784v-1.238c.314.071.746.073.781.193C759.4,1419.242,759.193,1419.623,758.472,1419.784Z",
    transform: "translate(-723.264 -1391.042)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55477",
    "data-name": "Path 55477",
    d: "M878.806,1349.126h-1.238c.071-.314.074-.746.194-.781C878.264,1348.2,878.645,1348.406,878.806,1349.126Z",
    transform: "translate(-805.403 -1342.594)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55478",
    "data-name": "Path 55478",
    d: "M829.576,1399.055l.708-.709c.355.274.613.582.362,1.1h-.678Z",
    transform: "translate(-772.304 -1377.111)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55479",
    "data-name": "Path 55479",
    d: "M790.828,1396.469v.765a.8.8,0,0,1-1.154-.641C790.033,1396.3,790.423,1396.469,790.828,1396.469Z",
    transform: "translate(-744.784 -1375.783)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55480",
    "data-name": "Path 55480",
    d: "M874.022,1331.029a.863.863,0,0,1-1.08-.63l.432-.484.72.924Z",
    transform: "translate(-802.212 -1329.915)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55481",
    "data-name": "Path 55481",
    d: "M917.734,1424.149h-.671l-.4-.407a.789.789,0,0,1,1.069-.394Z",
    transform: "translate(-832.367 -1394.307)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55482",
    "data-name": "Path 55482",
    d: "M786.124,1424.684v.943l-.707.074-.52-.52Z",
    transform: "translate(-741.489 -1395.275)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55483",
    "data-name": "Path 55483",
    d: "M850.674,1413.264l-.565,1.417-.533-1.417Z",
    transform: "translate(-786.097 -1387.399)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55484",
    "data-name": "Path 55484",
    d: "M809.216,1408.252v-.562c.247-.294.492-.237,1.143.265C810.046,1408.317,809.726,1408.652,809.216,1408.252Z",
    transform: "translate(-758.262 -1383.432)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55485",
    "data-name": "Path 55485",
    d: "M763.172,1436.82l-1.116.422c-.028-.386-.046-.64-.064-.891C762.483,1436.139,762.841,1436.213,763.172,1436.82Z",
    transform: "translate(-725.692 -1403.248)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55486",
    "data-name": "Path 55486",
    d: "M809.611,1410.485l.359.807-.634.563-.5-.476Z",
    transform: "translate(-757.996 -1385.483)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55487",
    "data-name": "Path 55487",
    d: "M927.541,1453.281H926.25l.735-1.02Z",
    transform: "translate(-838.978 -1414.295)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55488",
    "data-name": "Path 55488",
    d: "M738.962,1447.358v-.768h.789c.016.2.036.46.061.768Z",
    transform: "translate(-709.809 -1410.384)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55489",
    "data-name": "Path 55489",
    d: "M864.846,1412.4l.474-.583.7.681C865.779,1412.943,865.5,1412.894,864.846,1412.4Z",
    transform: "translate(-796.629 -1386.402)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55490",
    "data-name": "Path 55490",
    d: "M823.481,1391.016l.582.474-.68.7C822.939,1391.949,822.988,1391.673,823.481,1391.016Z",
    transform: "translate(-767.822 -1372.055)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55491",
    "data-name": "Path 55491",
    d: "M823.848,1428.9h-.727c-.022-.245-.045-.5-.074-.812h.8Z",
    transform: "translate(-767.801 -1397.626)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55492",
    "data-name": "Path 55492",
    d: "M841.99,1388.24l.583.474-.681.7C841.448,1389.172,841.5,1388.9,841.99,1388.24Z",
    transform: "translate(-780.588 -1370.141)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55493",
    "data-name": "Path 55493",
    d: "M924.311,1443.435l.586-.538c.475.214.558.581.338,1.2Z",
    transform: "translate(-837.641 -1407.837)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55494",
    "data-name": "Path 55494",
    d: "M830.657,1442.813h.765v.788l-.765.065Z",
    transform: "translate(-773.049 -1407.779)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55495",
    "data-name": "Path 55495",
    d: "M853.637,1371.3v-.727l.812-.074v.8Z",
    transform: "translate(-788.898 -1357.907)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55496",
    "data-name": "Path 55496",
    d: "M840.895,1438.921l-1.153-.376a3.781,3.781,0,0,1,.67-.42,4.6,4.6,0,0,1,.77-.088v.6Z",
    transform: "translate(-779.315 -1404.485)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55497",
    "data-name": "Path 55497",
    d: "M879.778,1432.86l-.874.921c-.454-.256-.4-.52.123-1.2.1.094.194.192.3.277C879.356,1432.88,879.419,1432.86,879.778,1432.86Z",
    transform: "translate(-806.112 -1400.721)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55498",
    "data-name": "Path 55498",
    d: "M892.606,1378.684l-.974-.835.9-.331C892.782,1377.633,892.88,1378,892.606,1378.684Z",
    transform: "translate(-815.103 -1362.746)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55499",
    "data-name": "Path 55499",
    d: "M750.09,1436.462l.474-.582.7.68C751.023,1437,750.747,1436.956,750.09,1436.462Z",
    transform: "translate(-717.484 -1402.997)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55500",
    "data-name": "Path 55500",
    d: "M882.241,1340.529v.945l-.8.057C881.363,1340.958,881.687,1340.782,882.241,1340.529Z",
    transform: "translate(-808.068 -1337.235)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55501",
    "data-name": "Path 55501",
    d: "M904.688,1403v-.737h1.04l-.79.862Z",
    transform: "translate(-824.107 -1379.811)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55502",
    "data-name": "Path 55502",
    d: "M848.144,1400.034h-.809v-.838C847.953,1399.236,848.169,1399.544,848.144,1400.034Z",
    transform: "translate(-784.552 -1377.697)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55503",
    "data-name": "Path 55503",
    d: "M907.816,1404.695v.838c-.611.187-.677-.269-.968-.7Z",
    transform: "translate(-825.597 -1381.489)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55504",
    "data-name": "Path 55504",
    d: "M852.74,1444.385c-.043-.577.26-.758.806-.852.019.3.035.554.054.852Z",
    transform: "translate(-788.276 -1408.275)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55505",
    "data-name": "Path 55505",
    d: "M920.97,1447.931l.491-.6.8.8-1.17.08Z",
    transform: "translate(-835.336 -1410.897)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55506",
    "data-name": "Path 55506",
    d: "M818.969,1446.991l.567-.917.419.786C819.891,1447.362,819.443,1446.969,818.969,1446.991Z",
    transform: "translate(-764.988 -1410.028)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55507",
    "data-name": "Path 55507",
    d: "M910.866,1451.584h-1.047l.5-.945Z",
    transform: "translate(-827.646 -1413.176)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55508",
    "data-name": "Path 55508",
    d: "M741.139,1417.982h1.147l-.524.848Z",
    transform: "translate(-711.31 -1390.653)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55509",
    "data-name": "Path 55509",
    d: "M726.005,1447.808l.972-.721c.087.211.169.314.144.365C726.949,1447.8,726.789,1448.208,726.005,1447.808Z",
    transform: "translate(-700.873 -1410.726)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55510",
    "data-name": "Path 55510",
    d: "M827.846,1420.248l-.544.59-.42-.742.365-.365Z",
    transform: "translate(-770.446 -1391.859)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55511",
    "data-name": "Path 55511",
    d: "M838.973,1362.14l1.235.071-.526.877Z",
    transform: "translate(-778.785 -1352.14)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55512",
    "data-name": "Path 55512",
    d: "M898.955,1370.322c.165.731-.265.808-.662,1.062C898.041,1370.671,898.4,1370.5,898.955,1370.322Z",
    transform: "translate(-819.64 -1357.783)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55513",
    "data-name": "Path 55513",
    d: "M868.6,1355.6v-1.047l.945.5Z",
    transform: "translate(-799.219 -1346.906)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55514",
    "data-name": "Path 55514",
    d: "M846.357,1431.384c-.142-.725.268-.819.678-1.054C847.284,1431.031,846.922,1431.2,846.357,1431.384Z",
    transform: "translate(-783.857 -1399.169)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55515",
    "data-name": "Path 55515",
    d: "M885.18,1404.547l.647.815-1.188.169Z",
    transform: "translate(-810.279 -1381.387)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55516",
    "data-name": "Path 55516",
    d: "M831.952,1405.879h1.079l-.489.908Z",
    transform: "translate(-773.942 -1382.306)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55517",
    "data-name": "Path 55517",
    d: "M909.793,1433.341l-.563.979-.629-.82Z",
    transform: "translate(-826.806 -1401.246)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55518",
    "data-name": "Path 55518",
    d: "M904.448,1366l-.815.647-.169-1.188Z",
    transform: "translate(-823.263 -1354.432)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55519",
    "data-name": "Path 55519",
    d: "M853.772,1389.658l.552.892H853.2Z",
    transform: "translate(-788.599 -1371.119)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55520",
    "data-name": "Path 55520",
    d: "M833.955,1384.492l.815-.647.169,1.188Z",
    transform: "translate(-775.324 -1367.109)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55521",
    "data-name": "Path 55521",
    d: "M901.464,1409.28l-.563.979-.629-.82Z",
    transform: "translate(-821.062 -1384.652)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55522",
    "data-name": "Path 55522",
    d: "M839.531,1400.709l.491-.641.628.761-.975.147Z",
    transform: "translate(-779.169 -1378.298)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55523",
    "data-name": "Path 55523",
    d: "M805.514,1415.433v-.459l.954-.075-.445.918Z",
    transform: "translate(-755.708 -1388.526)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55524",
    "data-name": "Path 55524",
    d: "M764.1,1440.658l.632.5-.773.614c-.062-.437-.1-.707-.139-.977Z",
    transform: "translate(-726.952 -1406.292)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55525",
    "data-name": "Path 55525",
    d: "M819.916,1401.619l-.632-.5.772-.614c.062.437.1.707.139.977Z",
    transform: "translate(-765.205 -1378.598)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55526",
    "data-name": "Path 55526",
    d: "M852.952,1409.422h.444c.021.247.044.5.069.793l-.513.1Z",
    transform: "translate(-788.426 -1384.75)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55527",
    "data-name": "Path 55527",
    d: "M908.114,1408.565l.826-.2.109.54h-.9Z",
    transform: "translate(-826.47 -1384.023)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55528",
    "data-name": "Path 55528",
    d: "M868.527,1390.622v-.474h.831C869.383,1390.951,868.882,1390.6,868.527,1390.622Z",
    transform: "translate(-799.167 -1371.457)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55529",
    "data-name": "Path 55529",
    d: "M889.72,1403.518h-.837v-.574h.837Z",
    transform: "translate(-813.207 -1380.282)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55530",
    "data-name": "Path 55530",
    d: "M866.791,1438.843l.787.5-.62.314C866.857,1439.5,866.342,1439.356,866.791,1438.843Z",
    transform: "translate(-797.845 -1405.041)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55531",
    "data-name": "Path 55531",
    d: "M876,1368.364l.469.834-1.282-.558Z",
    transform: "translate(-803.757 -1356.433)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55532",
    "data-name": "Path 55532",
    d: "M821.83,1397.267l.2.826-.539.109v-.9Z",
    transform: "translate(-766.725 -1376.366)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55533",
    "data-name": "Path 55533",
    d: "M708.812,1437.969h-.444c-.022-.247-.044-.5-.069-.793l.513-.1Z",
    transform: "translate(-688.661 -1403.819)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55534",
    "data-name": "Path 55534",
    d: "M789.7,1385.611l.7-.444c.455.511-.062.659-.242.928Z",
    transform: "translate(-744.799 -1368.021)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55535",
    "data-name": "Path 55535",
    d: "M768.5,1415.444V1415l.793-.069.1.513Z",
    transform: "translate(-730.178 -1388.549)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55536",
    "data-name": "Path 55536",
    d: "M866.31,1372.064l-.462.358-.492-.686C865.979,1371.346,866.111,1371.814,866.31,1372.064Z",
    transform: "translate(-796.98 -1358.655)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55537",
    "data-name": "Path 55537",
    d: "M845.712,1407.352l-.44-.44.686-.488C846.391,1406.95,845.9,1407.1,845.712,1407.352Z",
    transform: "translate(-783.129 -1382.682)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55538",
    "data-name": "Path 55538",
    d: "M889.649,1372.44v.474h-.83C888.793,1372.111,889.295,1372.464,889.649,1372.44Z",
    transform: "translate(-813.162 -1359.205)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55539",
    "data-name": "Path 55539",
    d: "M808.863,1418.7l-.786-.428.524-.453.473.638Z",
    transform: "translate(-757.476 -1390.54)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55540",
    "data-name": "Path 55540",
    d: "M849.042,1446.424l-.427.8-.447-.536.627-.469Z",
    transform: "translate(-785.126 -1410.126)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55541",
    "data-name": "Path 55541",
    d: "M784.863,1429.7h-.474v-.83C785.192,1428.845,784.839,1429.347,784.863,1429.7Z",
    transform: "translate(-741.139 -1398.162)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55542",
    "data-name": "Path 55542",
    d: "M688.908,1454.313v-.444l.793-.069c.036.178.062.306.1.513Z",
    transform: "translate(-675.288 -1415.356)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55543",
    "data-name": "Path 55543",
    d: "M865.828,1422.461h.475v.81h-.475Z",
    transform: "translate(-797.306 -1393.742)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55544",
    "data-name": "Path 55544",
    d: "M735.056,1446.073l.427-.8.447.536-.627.469Z",
    transform: "translate(-707.115 -1409.477)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55545",
    "data-name": "Path 55545",
    d: "M765.6,1429.415l.427-.8.447.535-.627.469Z",
    transform: "translate(-728.178 -1397.989)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55546",
    "data-name": "Path 55546",
    d: "M907.948,1452.886h-.475v-.81h.475Z",
    transform: "translate(-826.028 -1414.167)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55547",
    "data-name": "Path 55547",
    d: "M811.3,1450.968l-.623-.414.623-.734Z",
    transform: "translate(-759.27 -1412.611)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55548",
    "data-name": "Path 55548",
    d: "M891.842,1391.921H893l-.638.674Z",
    transform: "translate(-815.247 -1372.679)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55549",
    "data-name": "Path 55549",
    d: "M812.808,1445.019l-.664.122v-1.031Z",
    transform: "translate(-760.281 -1408.673)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55550",
    "data-name": "Path 55550",
    d: "M810.585,1437.244l-.414-.414.356-.381C811.02,1436.863,811.02,1436.863,810.585,1437.244Z",
    transform: "translate(-758.92 -1403.39)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55551",
    "data-name": "Path 55551",
    d: "M792.937,1430.005l.37.37-.448.393-.476-.439Z",
    transform: "translate(-746.652 -1398.945)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55552",
    "data-name": "Path 55552",
    d: "M892.021,1429.339l.144.66h-1.029Z",
    transform: "translate(-814.76 -1398.486)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55553",
    "data-name": "Path 55553",
    d: "M755.877,1432.341l.373.6-.838.053.156-.616Z",
    transform: "translate(-721.154 -1400.556)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55554",
    "data-name": "Path 55554",
    d: "M839.659,1420.814l-.393.588-.483-.445.589-.43Z",
    transform: "translate(-778.654 -1392.408)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55555",
    "data-name": "Path 55555",
    d: "M886.25,1352.388l.37-.37.393.448-.439.476Z",
    transform: "translate(-811.391 -1345.159)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55556",
    "data-name": "Path 55556",
    d: "M875.464,1418.825c-.038.216-.066.376-.117.665l-.916-.665Z",
    transform: "translate(-803.24 -1391.235)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55557",
    "data-name": "Path 55557",
    d: "M770.862,1454.036l.815-.642.25.642Z",
    transform: "translate(-731.81 -1415.076)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55558",
    "data-name": "Path 55558",
    d: "M898.911,1420.976l-.431.4-.448-.393.433-.433Z",
    transform: "translate(-819.516 -1392.423)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55559",
    "data-name": "Path 55559",
    d: "M797.564,1422.6l.37.37-.448.393-.476-.439Z",
    transform: "translate(-749.843 -1393.839)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55560",
    "data-name": "Path 55560",
    d: "M871.152,1385.748h-.774v-.584l.832.382Z",
    transform: "translate(-800.444 -1368.019)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55561",
    "data-name": "Path 55561",
    d: "M842.614,1404.73v-1.16l.674.638Z",
    transform: "translate(-781.296 -1380.714)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55562",
    "data-name": "Path 55562",
    d: "M802.032,1404.818l-.663-.9.663-.133Z",
    transform: "translate(-752.85 -1380.864)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55563",
    "data-name": "Path 55563",
    d: "M899.083,1402.975l1.108-.1-.072.728Z",
    transform: "translate(-820.241 -1380.232)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55564",
    "data-name": "Path 55564",
    d: "M853.261,1425.982l-.108.717-.928-.568Z",
    transform: "translate(-787.924 -1396.171)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55565",
    "data-name": "Path 55565",
    d: "M812.141,1427.441l.665.916-.665.116Z",
    transform: "translate(-760.279 -1397.177)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55566",
    "data-name": "Path 55566",
    d: "M904.3,1391.144l-.263.642-.8-.642Z",
    transform: "translate(-823.112 -1372.144)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55567",
    "data-name": "Path 55567",
    d: "M903.77,1451.338l.509.988-.509.1Z",
    transform: "translate(-823.474 -1413.658)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55568",
    "data-name": "Path 55568",
    d: "M824.03,1409.5h.512l.081.423C824.242,1410.147,824,1410.142,824.03,1409.5Z",
    transform: "translate(-768.477 -1384.805)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55569",
    "data-name": "Path 55569",
    d: "M827.335,1427.013v.512l-.423.081C826.69,1427.225,826.694,1426.988,827.335,1427.013Z",
    transform: "translate(-770.375 -1396.88)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55570",
    "data-name": "Path 55570",
    d: "M897.629,1424.472v.416l-.5.105-.106-.521Z",
    transform: "translate(-818.818 -1395.129)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55571",
    "data-name": "Path 55571",
    d: "M889.43,1452.022l-.626-.626.477-.477Z",
    transform: "translate(-813.152 -1413.369)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55572",
    "data-name": "Path 55572",
    d: "M737.031,1435.784v-.416l.5-.105.106.522Z",
    transform: "translate(-708.477 -1402.571)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55573",
    "data-name": "Path 55573",
    d: "M645.947,1454.408l-.931-.065.612-.531Z",
    transform: "translate(-645.016 -1415.365)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55574",
    "data-name": "Path 55574",
    d: "M852.282,1421.695v.416l-.5.105-.106-.522Z",
    transform: "translate(-787.544 -1393.214)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55575",
    "data-name": "Path 55575",
    d: "M871.052,1419.844l-.747.61-.123-.61Z",
    transform: "translate(-800.309 -1391.937)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55576",
    "data-name": "Path 55576",
    d: "M890.592,1387.789l-.613-.5.717-.135.085.445Z",
    transform: "translate(-813.962 -1369.392)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55577",
    "data-name": "Path 55577",
    d: "M889.046,1359.448h.416l.105.5-.522.106Z",
    transform: "translate(-813.319 -1350.283)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55578",
    "data-name": "Path 55578",
    d: "M773.061,1444.241l-.613-.5.717-.134c.036.188.061.317.085.445Z",
    transform: "translate(-732.904 -1408.326)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55579",
    "data-name": "Path 55579",
    d: "M890.313,1384.085l-.546-.042c-.015-.172-.025-.3-.041-.488l.541-.059C890.285,1383.73,890.3,1383.9,890.313,1384.085Z",
    transform: "translate(-813.788 -1366.868)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55580",
    "data-name": "Path 55580",
    d: "M846.729,1381.9v.416l-.5.105c-.038-.187-.064-.315-.106-.522Z",
    transform: "translate(-783.714 -1365.769)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55581",
    "data-name": "Path 55581",
    d: "M874.083,1437.438l.747-.609.123.609Z",
    transform: "translate(-802.999 -1403.652)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55582",
    "data-name": "Path 55582",
    d: "M870.744,1365.5h-.417l-.1-.5.521-.106Z",
    transform: "translate(-800.337 -1354.035)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55583",
    "data-name": "Path 55583",
    d: "M826.885,1376.359l.747-.609.124.609Z",
    transform: "translate(-770.448 -1361.527)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55584",
    "data-name": "Path 55584",
    d: "M890.655,1333.985v-.417l.5-.105.106.522Z",
    transform: "translate(-814.429 -1332.362)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55585",
    "data-name": "Path 55585",
    d: "M818.47,1392.288v-.416l.5-.105.106.522Z",
    transform: "translate(-764.644 -1372.573)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55586",
    "data-name": "Path 55586",
    d: "M911.948,1436.34h.512l.081.423C912.16,1436.985,911.922,1436.98,911.948,1436.34Z",
    transform: "translate(-829.113 -1403.314)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55587",
    "data-name": "Path 55587",
    d: "M843.348,1432.785v.456H842.5Z",
    transform: "translate(-781.218 -1400.863)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55588",
    "data-name": "Path 55588",
    d: "M897.929,1441.887h.472l-.369.558Z",
    transform: "translate(-819.445 -1407.14)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55589",
    "data-name": "Path 55589",
    d: "M762.092,1428.863v-.471l.558.368Z",
    transform: "translate(-725.761 -1397.833)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55590",
    "data-name": "Path 55590",
    d: "M799.076,1444.362c-.023-.295-.032-.418-.05-.647l.669.054Z",
    transform: "translate(-751.234 -1408.401)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55591",
    "data-name": "Path 55591",
    d: "M868.213,1402.954l.558-.106.172.815Z",
    transform: "translate(-798.951 -1380.216)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55592",
    "data-name": "Path 55592",
    d: "M916.942,1401.093v.861H916.8v-.861Z",
    transform: "translate(-832.459 -1379.005)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55593",
    "data-name": "Path 55593",
    d: "M836.321,1400.293l.378-.606C836.755,1400.383,836.755,1400.383,836.321,1400.293Z",
    transform: "translate(-776.955 -1378.036)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55594",
    "data-name": "Path 55594",
    d: "M846.741,1385.109l-.382-.612C846.725,1384.433,847.068,1384.344,846.741,1385.109Z",
    transform: "translate(-783.879 -1367.531)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55595",
    "data-name": "Path 55595",
    d: "M877.352,1383.667l-.577.145-.085-.755Z",
    transform: "translate(-804.797 -1366.565)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55596",
    "data-name": "Path 55596",
    d: "M896.668,1378.911l-.558.106-.172-.815Z",
    transform: "translate(-818.072 -1363.218)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55597",
    "data-name": "Path 55597",
    d: "M828.615,1454.927l-.838.04-.017-.192.846-.111C828.609,1454.751,828.612,1454.839,828.615,1454.927Z",
    transform: "translate(-771.051 -1415.952)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55598",
    "data-name": "Path 55598",
    d: "M776.436,1418.547v.471l-.558-.368Z",
    transform: "translate(-735.269 -1391.043)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55599",
    "data-name": "Path 55599",
    d: "M762.922,1454.969h-.762c-.005-.049-.01-.1-.016-.146l.753-.109Z",
    transform: "translate(-725.797 -1415.987)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55600",
    "data-name": "Path 55600",
    d: "M849.584,1440.337h-.574v-.144h.574Z",
    transform: "translate(-785.707 -1405.972)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55601",
    "data-name": "Path 55601",
    d: "M799.257,1435.5v.476l-.141.019q-.053-.24-.1-.48Z",
    transform: "translate(-751.224 -1402.738)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55602",
    "data-name": "Path 55602",
    d: "M835.91,1449.912c.1-.35.149-.522.2-.7a2.357,2.357,0,0,1,.124.4C836.238,1449.659,836.13,1449.716,835.91,1449.912Z",
    transform: "translate(-776.672 -1412.195)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55603",
    "data-name": "Path 55603",
    d: "M922.716,1434.625h-.476l-.022-.137.467-.111C922.7,1434.46,922.706,1434.542,922.716,1434.625Z",
    transform: "translate(-836.197 -1401.96)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55604",
    "data-name": "Path 55604",
    d: "M826.09,1438.257v.476l-.137.022-.111-.467Z",
    transform: "translate(-769.728 -1404.636)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55605",
    "data-name": "Path 55605",
    d: "M786.226,1441.97h.476l.022.137-.467.112C786.247,1442.135,786.236,1442.053,786.226,1441.97Z",
    transform: "translate(-742.406 -1407.197)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55606",
    "data-name": "Path 55606",
    d: "M874.577,1442.033H874.1c-.006-.047-.013-.094-.019-.141l.48-.1Z",
    transform: "translate(-802.998 -1407.071)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55607",
    "data-name": "Path 55607",
    d: "M907.482,1367.009h.476l.02.141-.48.1Z",
    transform: "translate(-826.034 -1355.498)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55608",
    "data-name": "Path 55608",
    d: "M876.92,1338.321h.476l.022.136-.467.111C876.94,1338.486,876.93,1338.4,876.92,1338.321Z",
    transform: "translate(-804.956 -1335.713)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55609",
    "data-name": "Path 55609",
    d: "M887.111,1410.018v-.476l.137-.022.111.467Z",
    transform: "translate(-811.984 -1384.817)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55610",
    "data-name": "Path 55610",
    d: "M910.669,1454.99h-.476c-.006-.047-.013-.094-.019-.141l.48-.1Z",
    transform: "translate(-827.89 -1416.007)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55611",
    "data-name": "Path 55611",
    d: "M857.508,1399.4h.476l.02.141-.48.1Q857.516,1399.523,857.508,1399.4Z",
    transform: "translate(-791.568 -1377.838)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55612",
    "data-name": "Path 55612",
    d: "M800.558,1397.607h-.476l-.022-.137.467-.111Z",
    transform: "translate(-751.946 -1376.43)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55613",
    "data-name": "Path 55613",
    d: "M830.732,1390.562v-.574h.144v.574Z",
    transform: "translate(-773.101 -1371.346)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55614",
    "data-name": "Path 55614",
    d: "M853.783,1380.891h.476l.022.137-.467.111Z",
    transform: "translate(-788.999 -1365.072)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55615",
    "data-name": "Path 55615",
    d: "M712.044,1449.524h.287v.1h-.287Z",
    transform: "translate(-691.244 -1412.407)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55616",
    "data-name": "Path 55616",
    d: "M729.627,1455.077h.287v.1h-.287Z",
    transform: "translate(-703.371 -1416.237)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55617",
    "data-name": "Path 55617",
    d: "M694.769,1454.13v-.287h.1v.287Z",
    transform: "translate(-679.33 -1415.386)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55618",
    "data-name": "Path 55618",
    d: "M913.174,1448.577v-.287h.1v.287Z",
    transform: "translate(-829.96 -1411.556)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55619",
    "data-name": "Path 55619",
    d: "M733.638,1450.428v-.287h.1v.287Z",
    transform: "translate(-706.137 -1412.833)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55620",
    "data-name": "Path 55620",
    d: "M780.835,1455.056v-.287h.1v.287Z",
    transform: "translate(-738.688 -1416.025)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55621",
    "data-name": "Path 55621",
    d: "M904.845,1352.331v-.287h.1v.287Z",
    transform: "translate(-824.215 -1345.177)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55622",
    "data-name": "Path 55622",
    d: "M905.866,1354.821v.287h-.1v-.287Z",
    transform: "translate(-824.853 -1347.092)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 0.203,
    cy: 0.068,
    rx: 0.203,
    ry: 0.068,
    transform: "translate(69.274 10.964)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55623",
    "data-name": "Path 55623",
    d: "M905.77,1372.691v-.287h.1v.287Z",
    transform: "translate(-824.853 -1359.219)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55624",
    "data-name": "Path 55624",
    d: "M784.537,1384.722v-.287h.1v.287Z",
    transform: "translate(-741.241 -1367.516)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 0.203,
    cy: 0.068,
    rx: 0.203,
    ry: 0.068,
    transform: "translate(69.274 28.769)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55625",
    "data-name": "Path 55625",
    d: "M809.62,1431.632v.287h-.1v-.287Z",
    transform: "translate(-758.474 -1400.067)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55626",
    "data-name": "Path 55626",
    d: "M909.568,1431.632v.287h-.1v-.287Z",
    transform: "translate(-827.406 -1400.067)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55627",
    "data-name": "Path 55627",
    d: "M832.66,1432.845v-.287h.1v.287Z",
    transform: "translate(-774.431 -1400.706)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55628",
    "data-name": "Path 55628",
    d: "M817.949,1433.483v.287h-.1v-.287Z",
    transform: "translate(-764.219 -1401.344)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55629",
    "data-name": "Path 55629",
    d: "M894.677,1434.785l-.235-.2.091-.091.2.234Z",
    transform: "translate(-817.041 -1402.041)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55630",
    "data-name": "Path 55630",
    d: "M743.509,1436.568h.287v.1h-.287Z",
    transform: "translate(-712.945 -1403.472)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55631",
    "data-name": "Path 55631",
    d: "M724.362,1443.142h-.287v-.1h.287Z",
    transform: "translate(-699.542 -1407.939)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55632",
    "data-name": "Path 55632",
    d: "M823.406,1444.876v-.287h.1v.287Z",
    transform: "translate(-768.048 -1409.004)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55633",
    "data-name": "Path 55633",
    d: "M842.936,1446.44v.287h-.1v-.287Z",
    transform: "translate(-781.452 -1410.28)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55634",
    "data-name": "Path 55634",
    d: "M891.539,1385.263l.235.2-.091.09-.2-.235Z",
    transform: "translate(-815 -1368.088)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55635",
    "data-name": "Path 55635",
    d: "M815.694,1402.327h.287v.1h-.287Z",
    transform: "translate(-762.729 -1379.856)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55636",
    "data-name": "Path 55636",
    d: "M847.563,1402.944v.287h-.1v-.287Z",
    transform: "translate(-784.643 -1380.282)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55637",
    "data-name": "Path 55637",
    d: "M899.36,1403.828l-.2.235-.091-.091.235-.2Z",
    transform: "translate(-820.232 -1380.853)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55638",
    "data-name": "Path 55638",
    d: "M768.783,1408.9H768.5v-.1h.287Z",
    transform: "translate(-730.178 -1384.324)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55639",
    "data-name": "Path 55639",
    d: "M888.283,1412.2v.287h-.1v-.287Z",
    transform: "translate(-812.727 -1386.664)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 0.203,
    cy: 0.068,
    rx: 0.203,
    ry: 0.068,
    transform: "translate(82.485 25.61)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55640",
    "data-name": "Path 55640",
    d: "M804.965,1416.785l-.2.234-.091-.09.235-.2Z",
    transform: "translate(-755.129 -1389.789)",
    fill: "#104c96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55641",
    "data-name": "Path 55641",
    d: "M811.992,1419.91h.287v.1h-.287Z",
    transform: "translate(-760.176 -1391.983)",
    fill: "#104c96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3290",
    "data-name": "Group 3290",
    transform: "translate(191.221 419.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55642",
    "data-name": "Path 55642",
    d: "M450.833,809.258a.468.468,0,0,1-.394-.719,4.368,4.368,0,0,1,5.929-1.4.468.468,0,1,1-.482.8,3.433,3.433,0,0,0-4.658,1.1A.468.468,0,0,1,450.833,809.258Z",
    transform: "translate(-450.366 -806.523)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3291",
    "data-name": "Group 3291",
    transform: "translate(255.812 405.237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55643",
    "data-name": "Path 55643",
    d: "M661.469,777.194a.468.468,0,0,1-.06-.932,4.586,4.586,0,0,0,3.83-2.851c.612-1.93-.623-3.906-1.182-4.666a22.329,22.329,0,0,0-1.857-2.113,25.863,25.863,0,0,1-1.739-1.947,16.8,16.8,0,0,1-1.905-3.178.468.468,0,1,1,.846-.4,15.894,15.894,0,0,0,1.8,3,25.121,25.121,0,0,0,1.677,1.875,23.02,23.02,0,0,1,1.934,2.2,6.276,6.276,0,0,1,1.321,5.5,5.5,5.5,0,0,1-4.6,3.5A.5.5,0,0,1,661.469,777.194Z",
    transform: "translate(-658.51 -760.839)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3292",
    "data-name": "Group 3292",
    transform: "translate(299.566 248.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55644",
    "data-name": "Path 55644",
    d: "M807,267.872a.468.468,0,0,1-.452-.345,24.613,24.613,0,0,0-2.873-7.235,10.01,10.01,0,0,0-3.9-3.516.468.468,0,1,1,.4-.844,10.953,10.953,0,0,1,4.282,3.845,25.39,25.39,0,0,1,3,7.505.467.467,0,0,1-.328.574A.457.457,0,0,1,807,267.872Z",
    transform: "translate(-799.505 -255.886)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3293",
    "data-name": "Group 3293",
    transform: "translate(290.04 258.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55645",
    "data-name": "Path 55645",
    d: "M782.365,313.857a.468.468,0,0,1-.38-.74,13.777,13.777,0,0,0,1.608-12.684.468.468,0,0,1,.323-.623c2.352-.587,5-1.429,6.844-3.23,1.622-1.588,2.666-4.448,1.4-6.622a2.574,2.574,0,0,0-1.618-1.312,4.164,4.164,0,0,0-2,.3l-10.08,3.226a21.744,21.744,0,0,0-5.505,2.336,6.969,6.969,0,0,0-3.224,4.547.468.468,0,1,1-.925-.14,7.9,7.9,0,0,1,3.63-5.186,22.438,22.438,0,0,1,5.739-2.448l10.08-3.225a4.914,4.914,0,0,1,2.466-.328,3.5,3.5,0,0,1,2.242,1.76c1.515,2.61.363,5.88-1.559,7.761a14.866,14.866,0,0,1-6.769,3.341,14.761,14.761,0,0,1-1.9,13.072A.466.466,0,0,1,782.365,313.857Z",
    transform: "translate(-768.81 -287.672)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3294",
    "data-name": "Group 3294",
    transform: "translate(293.352 258.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55646",
    "data-name": "Path 55646",
    d: "M782.486,293.645a.468.468,0,0,1-.444-.32,13.7,13.7,0,0,0-2.453-4.42.468.468,0,1,1,.721-.6,14.647,14.647,0,0,1,2.62,4.721.468.468,0,0,1-.444.616Z",
    transform: "translate(-779.482 -288.138)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295",
    transform: "translate(305.673 269.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55647",
    "data-name": "Path 55647",
    d: "M819.656,328.61a.468.468,0,0,1-.214-.885,5.769,5.769,0,0,0,3.087-4.758.468.468,0,1,1,.935.049,6.72,6.72,0,0,1-3.6,5.543A.466.466,0,0,1,819.656,328.61Z",
    transform: "translate(-819.187 -322.523)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296",
    transform: "translate(307.689 248.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55648",
    "data-name": "Path 55648",
    d: "M828.262,282.539a5.608,5.608,0,0,1-2.3-.468.468.468,0,0,1,.385-.853c2.648,1.2,5.878-.454,7.35-2.67,1.408-2.118,1.945-5,1.641-8.817a35.19,35.19,0,0,0-1.475-7.643,17.783,17.783,0,0,0-1.789-4.046.468.468,0,0,1,.8-.492,18.709,18.709,0,0,1,1.886,4.259,36.142,36.142,0,0,1,1.514,7.846c.321,4.033-.266,7.111-1.8,9.41A7.547,7.547,0,0,1,828.262,282.539Z",
    transform: "translate(-825.683 -257.328)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3297",
    "data-name": "Group 3297",
    transform: "translate(313.648 252.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55649",
    "data-name": "Path 55649",
    d: "M848.525,289.86a7.3,7.3,0,0,1-3.385-.813.468.468,0,0,1,.43-.831c2.842,1.472,7.55.629,10.2-3.3,2.488-3.691,2.335-8.36,1.769-11.626a17.576,17.576,0,0,0-1.215-4.173.468.468,0,0,1,.854-.384,18.248,18.248,0,0,1,1.283,4.4c.6,3.436.747,8.361-1.915,12.31A10.155,10.155,0,0,1,848.525,289.86Z",
    transform: "translate(-844.887 -268.457)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3298",
    "data-name": "Group 3298",
    transform: "translate(320.76 271.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55650",
    "data-name": "Path 55650",
    d: "M872.546,333.785a6.89,6.89,0,0,1-4.581-1.632.468.468,0,0,1,.618-.7,6.556,6.556,0,0,0,6.551.939.468.468,0,0,1,.316.881A8.615,8.615,0,0,1,872.546,333.785Z",
    transform: "translate(-867.806 -331.333)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3299",
    "data-name": "Group 3299",
    transform: "translate(301.275 304.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55651",
    "data-name": "Path 55651",
    d: "M827.173,439.432c-1.342-.027-2.616-.039-3.859-.051a99.524,99.524,0,0,1-18.3-1.442l.241-1.383a98.353,98.353,0,0,0,18.074,1.421c1.248.012,2.528.024,3.874.052Z",
    transform: "translate(-805.013 -436.556)",
    fill: "#323b6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3300",
    "data-name": "Group 3300",
    transform: "translate(99.614 263.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55652",
    "data-name": "Path 55652",
    d: "M166.193,328.981a.468.468,0,0,1-.439-.308A18.727,18.727,0,0,1,166.3,314.7c-2.161.566-4.595,1.176-6.94.555a6.005,6.005,0,0,1-3.793-3.23,3.958,3.958,0,0,1-.01-3.459c1.09-2.161,3.76-2.709,6.228-2.961l8.578-.876c.714-.073,1.532-.142,2.333-.153a.468.468,0,0,1,0,.936h-.037a21.978,21.978,0,0,0-2.2.148l-8.578.876c-2.216.226-4.6.694-5.487,2.451a3.037,3.037,0,0,0,.028,2.654,5.033,5.033,0,0,0,3.179,2.709c2.162.573,4.425-.021,6.614-.595.283-.074.563-.147.839-.218a.468.468,0,0,1,.529.672,17.747,17.747,0,0,0-.946,14.145.468.468,0,0,1-.279.6A.463.463,0,0,1,166.193,328.981Z",
    transform: "translate(-155.162 -304.574)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301",
    transform: "translate(99.75 255.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55653",
    "data-name": "Path 55653",
    d: "M161,288.517a.468.468,0,0,1-.452-.348,23.684,23.684,0,0,0-3.171-7.038,15.281,15.281,0,0,0-1.647-2.1.468.468,0,1,1,.677-.645,16.189,16.189,0,0,1,1.749,2.231,24.633,24.633,0,0,1,3.3,7.316.468.468,0,0,1-.332.573A.475.475,0,0,1,161,288.517Z",
    transform: "translate(-155.601 -278.237)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3302",
    "data-name": "Group 3302",
    transform: "translate(95.968 273.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55654",
    "data-name": "Path 55654",
    d: "M147.156,343.813a5.856,5.856,0,0,1-3.559-1.143.468.468,0,1,1,.57-.743,5.38,5.38,0,0,0,5.366.425,8.844,8.844,0,0,0,4.211-4.937.468.468,0,0,1,.871.343,9.766,9.766,0,0,1-4.685,5.442A6.56,6.56,0,0,1,147.156,343.813Z",
    transform: "translate(-143.414 -337.119)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3303",
    "data-name": "Group 3303",
    transform: "translate(88.582 256.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55655",
    "data-name": "Path 55655",
    d: "M120.08,307.5a.468.468,0,0,1,0-.936c2.612-.025,5.483-.31,6.974-2.232,1.559-2.008.978-5.019.4-7.11a52.444,52.444,0,0,0-3.75-9.746,9.245,9.245,0,0,0-2.335-3.23,4.554,4.554,0,0,0-1.126-.633.468.468,0,0,1,.341-.872,5.5,5.5,0,0,1,1.358.764,10.038,10.038,0,0,1,2.6,3.549,53.356,53.356,0,0,1,3.817,9.92c.626,2.284,1.248,5.592-.568,7.931-1.736,2.236-4.869,2.566-7.7,2.593Z",
    transform: "translate(-119.612 -282.713)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3304",
    "data-name": "Group 3304",
    transform: "translate(78.197 262.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55656",
    "data-name": "Path 55656",
    d: "M93.227,321.674a5.644,5.644,0,0,1-2.465-.549c-2.1-1.031-3.737-3.277-4.6-6.325a.468.468,0,0,1,.9-.254c.456,1.615,1.6,4.508,4.108,5.738a4.884,4.884,0,0,0,3.85.118,3.376,3.376,0,0,0,1.987-1.919,6.061,6.061,0,0,0,.133-2.861,25.571,25.571,0,0,0-5.24-12.468,6.5,6.5,0,0,0-2.088-1.893.468.468,0,1,1,.406-.843,7.338,7.338,0,0,1,2.418,2.158A26.506,26.506,0,0,1,98.072,315.5a6.872,6.872,0,0,1-.184,3.307,4.3,4.3,0,0,1-2.517,2.463A5.805,5.805,0,0,1,93.227,321.674Z",
    transform: "translate(-86.147 -300.373)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3305",
    "data-name": "Group 3305",
    transform: "translate(105.685 275.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55657",
    "data-name": "Path 55657",
    d: "M178.935,344.567h-.029a5.993,5.993,0,0,1-4.059-1.939.468.468,0,1,1,.694-.628,5.049,5.049,0,0,0,3.421,1.633.468.468,0,0,1-.027.935Z",
    transform: "translate(-174.726 -341.845)",
    fill: "#bf453f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3306",
    "data-name": "Group 3306",
    transform: "translate(218.736 481.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55658",
    "data-name": "Path 55658",
    d: "M557.055,1014a26.241,26.241,0,0,1-5.807-.6c-4.475-1.011-8.409-3.365-12.214-5.642l.721-1.2c3.71,2.22,7.546,4.516,11.8,5.478,4.526,1.024,9.348.464,13.9-.2l.2,1.389A60.158,60.158,0,0,1,557.055,1014Z",
    transform: "translate(-539.034 -1006.555)",
    fill: "#323b6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3307",
    "data-name": "Group 3307",
    transform: "translate(104.793 316.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55659",
    "data-name": "Path 55659",
    d: "M172.081,482.142l-.229-1.385a40.954,40.954,0,0,0,15.278-5.867l.757,1.182A42.365,42.365,0,0,1,172.081,482.142Z",
    transform: "translate(-171.852 -474.89)",
    fill: "#323b6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311",
    transform: "translate(120.204 620.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3308",
    "data-name": "Group 3308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    width: 70.041,
    height: 1.404,
    fill: "#104c96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3309",
    "data-name": "Group 3309",
    transform: "translate(104.429 0.074)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1531",
    "data-name": "Rectangle 1531",
    width: 401.971,
    height: 1.404,
    fill: "#104c96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3310",
    "data-name": "Group 3310",
    transform: "translate(70.041 0.019)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1532",
    "data-name": "Rectangle 1532",
    width: 34.388,
    height: 1.404,
    fill: "#323b6e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3314",
    "data-name": "Group 3314",
    transform: "translate(167.987 590.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(14.456 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55660",
    "data-name": "Path 55660",
    d: "M464.641,1400.356q-.6,2.6-1.308,5.26l-.058.216-30.171.045a35.932,35.932,0,0,1-2.851-5.57,84.8,84.8,0,0,1-4.262-14.17c-.305-1.363-.587-2.736-.846-4.095-.885-4.642-1.539-9.174-2-13.044-.232-1.916-.42-3.673-.568-5.2-.365-3.73-.5-6.087-.5-6.087l3.776-.107,43.738-1.24A190.512,190.512,0,0,1,464.641,1400.356Z",
    transform: "translate(-422.076 -1356.366)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3313",
    "data-name": "Group 3313",
    transform: "translate(0 5.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55661",
    "data-name": "Path 55661",
    d: "M393.017,1394.292c.259,1.359.54,2.732.846,4.095a15.259,15.259,0,0,1-15.4-4.621c-3.69-4.447-4.049-11.491-.463-16.024a9.02,9.02,0,0,1,6.53-3.611,10.664,10.664,0,0,1,5.918,1.918c.148,1.524.336,3.282.568,5.2a6.7,6.7,0,0,0-8.183-.681,7.277,7.277,0,0,0-2.7,7.611,8.964,8.964,0,0,0,5.631,6.031A11.511,11.511,0,0,0,393.017,1394.292Z",
    transform: "translate(-375.492 -1374.127)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3316",
    "data-name": "Group 3316",
    transform: "translate(193.469 638.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3315",
    "data-name": "Group 3315",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1533",
    "data-name": "Rectangle 1533",
    width: 30.171,
    height: 1.404,
    transform: "translate(0 0.049) rotate(-0.094)",
    fill: "#104c96"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3317",
    "data-name": "Group 3317",
    transform: "translate(509.914 597.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55662",
    "data-name": "Path 55662",
    d: "M1482.126,1410.523a89.249,89.249,0,0,1-4.767-29.734v-.084l13.405-.242,10.369-.186,14.06-.25,0,.342a89.286,89.286,0,0,1-6.584,36.693l-23.855.265Q1483.3,1413.98,1482.126,1410.523Z",
    transform: "translate(-1477.353 -1380.026)",
    fill: "#104c96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3318",
    "data-name": "Group 3318",
    transform: "translate(509.445 545.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55663",
    "data-name": "Path 55663",
    d: "M1498.36,1223.265c.419,13.726,1.684,30.3,1.728,41.384v.093l-10.369.186v-.047q-.351-3.829-.708-7.658c-.181-1.945-.4-4.011-1.62-5.537-1.387-1.861-4.563-3.347-7.438-5.168a9.62,9.62,0,0,1-3.59-3.418,3.94,3.94,0,0,1,.491-4.643,3.606,3.606,0,0,1,3.113-.774,6.167,6.167,0,0,1,2.891,1.559,24.382,24.382,0,0,0,2.312,2.146c.7.488,1.94,1.069,2.533.108a2.3,2.3,0,0,0,.268-1.15c.008-.164.006-.328.009-.487.029-1.587-.3-3.263-.428-4.853-.141-1.791-.264-3.582-.35-5.374a90.2,90.2,0,0,1,.048-10.788c.141-2.042.5-4.306,2.119-5.555,2.214-1.7,5.667-.414,7.21,1.909S1498.277,1220.472,1498.36,1223.265Z",
    transform: "translate(-1475.841 -1212.508)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(512.729 618.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3319",
    "data-name": "Group 3319",
    transform: "translate(27.29 14.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55664",
    "data-name": "Path 55664",
    d: "M1575.285,1495.682h-.465l-.457-1.072.455-.089.467.587Z",
    transform: "translate(-1574.363 -1494.521)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3320",
    "data-name": "Group 3320",
    transform: "translate(3.3 10.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55665",
    "data-name": "Path 55665",
    d: "M1498.707,1482.629c.1.589.539.072.78.441.064-.458.1-.719.171-1.23.312,1.182,1.261,1.218,1.921,1.651l.305.521-.338.767.156.147.318-.287c.677.339.676.34,1.062,1.146l-.879-.2-.5.826,1.093-.464-.3.9a1.151,1.151,0,0,0,.314.085,1.961,1.961,0,0,0,1.408-.757,9.433,9.433,0,0,1,.917-.641l-.387,1.146.32.663c-.936.655-1.894-.431-2.842.1l-.228-.2-.2.2-1.356-.694c-.189-.491.3-.875.486-1.4-.24-.25-.376-.554.086-.842l-.467-.43c-.116.743-.23,1.471-.358,2.3h-1.77v-.574l.287-.217-.287-.357c0-.047.02-.112,0-.137-.127-.136-.264-.263-.463-.457l-.509.744c-.156-.5-.265-.854-.386-1.246h.694A1.573,1.573,0,0,1,1498.707,1482.629Zm.862,1.723h.583c-.027-.245-.044-.4-.06-.55-.5-.008-.5,0-.81.263h-1.149a5.856,5.856,0,0,1,1.462,1.119l-.056.056.2.235.091-.091a.831.831,0,0,0-.261-.17Z",
    transform: "translate(-1497.058 -1481.84)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3321",
    "data-name": "Group 3321",
    transform: "translate(8.542 11.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55666",
    "data-name": "Path 55666",
    d: "M1513.948,1484.917l.953-.488.674,1.424.435-.288,1.2.388v.781l-.392-.281-.559.416-.362-.769-.7.347C1514.692,1486.032,1514.79,1485.212,1513.948,1484.917Z",
    transform: "translate(-1513.948 -1484.429)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3322",
    "data-name": "Group 3322",
    transform: "translate(5.233 7.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55667",
    "data-name": "Path 55667",
    d: "M1504.942,1473.39l-1.063,1.447-.593-.978a5.1,5.1,0,0,0,.283-.725,5.028,5.028,0,0,0,.065-.769h.415l.19.565.4-.295Z",
    transform: "translate(-1503.286 -1472.364)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3323",
    "data-name": "Group 3323",
    transform: "translate(2.061 8.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55668",
    "data-name": "Path 55668",
    d: "M1493.144,1475.133l.433-.045c.049.478.1.962.173,1.689.269-.679.148-1.385.99-1.4v1.353l-1.151.373A1.985,1.985,0,0,1,1493.144,1475.133Z",
    transform: "translate(-1493.065 -1475.088)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3324",
    "data-name": "Group 3324",
    transform: "translate(12.417 14.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55669",
    "data-name": "Path 55669",
    d: "M1527.858,1496.613c-.06.548-.511.073-.692.361l-.273-.634-.458.258v-.815a4.683,4.683,0,0,0,.794-.056,4.405,4.405,0,0,0,.714-.295.863.863,0,0,1,.425,1.166c-.142,0-.32,0-.51.015a.5.5,0,0,0,.043-.041l-.2-.234-.091.091A1.592,1.592,0,0,0,1527.858,1496.613Z",
    transform: "translate(-1526.435 -1495.432)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3325",
    "data-name": "Group 3325",
    transform: "translate(7.226 9.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55670",
    "data-name": "Path 55670",
    d: "M1510.481,1477.917l.471-.326.52.926-1.681.695c-.027-.527-.051-.973-.083-1.59Z",
    transform: "translate(-1509.708 -1477.591)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3326",
    "data-name": "Group 3326",
    transform: "translate(12.663 12.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55671",
    "data-name": "Path 55671",
    d: "M1527.229,1488.389l1.438-.808c-.047.388-.073.606-.12.989l.19.492C1527.958,1489.4,1527.641,1488.873,1527.229,1488.389Z",
    transform: "translate(-1527.229 -1487.581)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3327",
    "data-name": "Group 3327",
    transform: "translate(16.728 14.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55672",
    "data-name": "Path 55672",
    d: "M1540.33,1494.656a.784.784,0,0,1,1.119.3v.979h-.734Z",
    transform: "translate(-1540.33 -1494.532)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328",
    transform: "translate(9.271 9.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55673",
    "data-name": "Path 55673",
    d: "M1517.656,1477.038l.489.807-.888.048-.174.506h-.776c.008-.16-.037-.354.029-.406C1516.751,1477.665,1517.191,1477.369,1517.656,1477.038Z",
    transform: "translate(-1516.3 -1477.038)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(1.792 6.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55674",
    "data-name": "Path 55674",
    d: "M1493.364,1469.736l-.451,1.467a1.346,1.346,0,0,1-.709-1.467Z",
    transform: "translate(-1492.199 -1469.736)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(1.219 3.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55675",
    "data-name": "Path 55675",
    d: "M1490.423,1459.624c-.041-.218-.065-.306-.071-.4,0-.04.031-.082.059-.149.341-.057.7-.111,1.053-.177a1.509,1.509,0,0,1,.954.037,1.7,1.7,0,0,1-.41.353A7.4,7.4,0,0,1,1490.423,1459.624Z",
    transform: "translate(-1490.353 -1458.842)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331",
    transform: "translate(18.461 15.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55676",
    "data-name": "Path 55676",
    d: "M1545.926,1497.144c-.089-.663.258-.527.513-.586a3.777,3.777,0,0,0,.724-.334,3.668,3.668,0,0,0,.31.618c.175.226.118.3-.137.3C1546.879,1497.146,1546.42,1497.144,1545.926,1497.144Z",
    transform: "translate(-1545.912 -1496.223)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(4.36 15.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55677",
    "data-name": "Path 55677",
    d: "M1501.924,1497.275c-.354.137-.667.509-1.1.193a.744.744,0,0,1-.281-.955c.022-.055.152-.067.232-.1.118.1.236.272.355.273A.735.735,0,0,1,1501.924,1497.275Z",
    transform: "translate(-1500.473 -1496.414)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3333",
    "data-name": "Group 3333",
    transform: "translate(0.756 4.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55678",
    "data-name": "Path 55678",
    d: "M1488.859,1463.8l.626-.823c.667.18.78.569.627,1.188a1.921,1.921,0,0,0-.444-.279A5.351,5.351,0,0,0,1488.859,1463.8Z",
    transform: "translate(-1488.859 -1462.972)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3334",
    "data-name": "Group 3334",
    transform: "translate(11.111 10.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55679",
    "data-name": "Path 55679",
    d: "M1522.612,1484.065l-.381-1.208.29-.325C1523.145,1482.532,1523.212,1482.872,1522.612,1484.065Z",
    transform: "translate(-1522.227 -1482.532)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3335",
    "data-name": "Group 3335",
    transform: "translate(4.089 9.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55680",
    "data-name": "Path 55680",
    d: "M1500.378,1477.743l-.339.436c-.575-.761-.58-.821-.063-1.57Z",
    transform: "translate(-1499.598 -1476.609)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3336",
    "data-name": "Group 3336",
    transform: "translate(12.199 13.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55681",
    "data-name": "Path 55681",
    d: "M1526.464,1491.786l.233,1.084h-.963l.335-1.084Z",
    transform: "translate(-1525.734 -1491.786)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3337",
    "data-name": "Group 3337",
    transform: "translate(0.983 6.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55682",
    "data-name": "Path 55682",
    d: "M1490.4,1466.757l-.465,1.963c-.059-.5-.066-.747-.121-.981a4.353,4.353,0,0,0-.227-.59,1.973,1.973,0,0,1,.387-.38C1490.085,1466.707,1490.256,1466.757,1490.4,1466.757Z",
    transform: "translate(-1489.591 -1466.738)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3338",
    "data-name": "Group 3338",
    transform: "translate(14.579 13.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55683",
    "data-name": "Path 55683",
    d: "M1534.327,1491.989l-.922-1.064.852-.123.389.762Z",
    transform: "translate(-1533.405 -1490.802)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3339",
    "data-name": "Group 3339",
    transform: "translate(21.653 13.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55684",
    "data-name": "Path 55684",
    d: "M1556.2,1491.867h.768v.789l-.768.06Z",
    transform: "translate(-1556.2 -1491.867)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3340",
    "data-name": "Group 3340",
    transform: "translate(13.498 10.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55685",
    "data-name": "Path 55685",
    d: "M1530.045,1481.18l.917.567-.786.419C1529.673,1482.1,1530.066,1481.655,1530.045,1481.18Z",
    transform: "translate(-1529.919 -1481.18)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3341",
    "data-name": "Group 3341",
    transform: "translate(3.071 5.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55686",
    "data-name": "Path 55686",
    d: "M1496.882,1463.786l.629.82-1.191.159Z",
    transform: "translate(-1496.32 -1463.786)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3342",
    "data-name": "Group 3342",
    transform: "translate(0 2.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55687",
    "data-name": "Path 55687",
    d: "M1486.549,1454.342l.917.567-.786.419C1486.177,1455.264,1486.57,1454.817,1486.549,1454.342Z",
    transform: "translate(-1486.423 -1454.342)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3343",
    "data-name": "Group 3343",
    transform: "translate(13.496 8.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55688",
    "data-name": "Path 55688",
    d: "M1530.844,1474.666l-.44.44-.489-.686C1530.441,1473.986,1530.589,1474.479,1530.844,1474.666Z",
    transform: "translate(-1529.915 -1474.246)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3344",
    "data-name": "Group 3344",
    transform: "translate(2.395 11.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55689",
    "data-name": "Path 55689",
    d: "M1495.108,1484.509l-.969-1.307,1.129.488Z",
    transform: "translate(-1494.139 -1483.202)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(16.461 13.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55690",
    "data-name": "Path 55690",
    d: "M1540.282,1490.09v.479h-.814v-.479Z",
    transform: "translate(-1539.468 -1490.09)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3346",
    "data-name": "Group 3346",
    transform: "translate(17.866 11.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55691",
    "data-name": "Path 55691",
    d: "M1544.054,1485.392h.474v.83C1543.725,1486.248,1544.079,1485.746,1544.054,1485.392Z",
    transform: "translate(-1543.997 -1485.392)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3347",
    "data-name": "Group 3347",
    transform: "translate(23.613 11.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55692",
    "data-name": "Path 55692",
    d: "M1563.424,1486.225l-.427.766-.48-.495.67-.488Z",
    transform: "translate(-1562.517 -1486.008)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3348",
    "data-name": "Group 3348",
    transform: "translate(11.565 15.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55693",
    "data-name": "Path 55693",
    d: "M1524.8,1498.466l-1.108.1c.024-.239.042-.422.072-.728Z",
    transform: "translate(-1523.692 -1497.842)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3349",
    "data-name": "Group 3349",
    transform: "translate(21.964 15.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55694",
    "data-name": "Path 55694",
    d: "M1557.849,1497.2l.237.552-.883.08A1.461,1.461,0,0,1,1557.849,1497.2Z",
    transform: "translate(-1557.203 -1497.199)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(4.065 6.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55695",
    "data-name": "Path 55695",
    d: "M1499.65,1467.282l.9.663h-1.03C1499.565,1467.726,1499.6,1467.567,1499.65,1467.282Z",
    transform: "translate(-1499.523 -1467.282)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(19.685 13.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55696",
    "data-name": "Path 55696",
    d: "M1550.735,1492.245h-.876a1.423,1.423,0,0,1,.632-.593Z",
    transform: "translate(-1549.859 -1491.652)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352",
    transform: "translate(9.461 13.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55697",
    "data-name": "Path 55697",
    d: "M1516.912,1492.9l.263-.642.8.642Z",
    transform: "translate(-1516.912 -1492.263)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353",
    transform: "translate(5.793 5.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55698",
    "data-name": "Path 55698",
    d: "M1505.728,1464.154l-.5.614-.135-.717.445-.085Z",
    transform: "translate(-1505.092 -1463.965)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354",
    transform: "translate(2.255 1.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55699",
    "data-name": "Path 55699",
    d: "M1494.3,1452.749l-.61-.747.61-.123Z",
    transform: "translate(-1493.688 -1451.879)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355",
    transform: "translate(24.748 13.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55700",
    "data-name": "Path 55700",
    d: "M1566.807,1491.917l-.5.613-.134-.717.445-.085Z",
    transform: "translate(-1566.172 -1491.728)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356",
    transform: "translate(3.661 10.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55701",
    "data-name": "Path 55701",
    d: "M1498.22,1481.468l.773.432C1498.48,1482.348,1498.333,1481.831,1498.22,1481.468Z",
    transform: "translate(-1498.22 -1481.468)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357",
    transform: "translate(7.711 11.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55702",
    "data-name": "Path 55702",
    d: "M1511.881,1484.214l-.61-.746.61-.124Z",
    transform: "translate(-1511.271 -1483.344)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358",
    transform: "translate(10.693 7.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55703",
    "data-name": "Path 55703",
    d: "M1521.943,1470.321l-.639.639-.422-.486Z",
    transform: "translate(-1520.882 -1470.321)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359",
    transform: "translate(19.016 13.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55704",
    "data-name": "Path 55704",
    d: "M1548.256,1489.943v.512l-.423.081C1547.611,1490.155,1547.615,1489.918,1548.256,1489.943Z",
    transform: "translate(-1547.7 -1489.941)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360",
    transform: "translate(20.435 15.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55705",
    "data-name": "Path 55705",
    d: "M1552.8,1496.909h-.416l-.105-.5.522-.106Z",
    transform: "translate(-1552.275 -1496.3)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    transform: "translate(9.909 11.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55706",
    "data-name": "Path 55706",
    d: "M1518.969,1485.886l-.613-.5.717-.135.085.445Z",
    transform: "translate(-1518.356 -1485.251)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362",
    transform: "translate(4.088 14.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55707",
    "data-name": "Path 55707",
    d: "M1499.6,1492.99c.025-.43.357-.244.574-.287v.574h-.287Z",
    transform: "translate(-1499.597 -1492.699)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3363",
    "data-name": "Group 3363",
    transform: "translate(25.394 15.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55708",
    "data-name": "Path 55708",
    d: "M1568.256,1498.424h.762l.012.15-.772.1Z",
    transform: "translate(-1568.256 -1498.424)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3364",
    "data-name": "Group 3364",
    transform: "translate(7.822 12.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55709",
    "data-name": "Path 55709",
    d: "M1512.49,1486.179c-.135.553-.579.178-.861.287C1511.763,1485.913,1512.207,1486.289,1512.49,1486.179Z",
    transform: "translate(-1511.628 -1486.155)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365",
    transform: "translate(15.961 11.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55710",
    "data-name": "Path 55710",
    d: "M1537.858,1486.087l.386-.316C1538.276,1486.175,1538.276,1486.175,1537.858,1486.087Z",
    transform: "translate(-1537.858 -1485.771)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366",
    transform: "translate(12.129 11.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55711",
    "data-name": "Path 55711",
    d: "M1526.22,1484.739l-.711-.2a2.343,2.343,0,0,1,.4-.125C1525.954,1484.406,1526.012,1484.513,1526.22,1484.739Z",
    transform: "translate(-1525.509 -1484.412)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3367",
    "data-name": "Group 3367",
    transform: "translate(11.627 14.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55712",
    "data-name": "Path 55712",
    d: "M1523.89,1495.137v-.574h.144v.574Z",
    transform: "translate(-1523.89 -1494.563)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3368",
    "data-name": "Group 3368",
    transform: "translate(15.009 16.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55713",
    "data-name": "Path 55713",
    d: "M1535.364,1499.358l-.549.047-.025-.185.559-.109Z",
    transform: "translate(-1534.79 -1499.11)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369",
    transform: "translate(23.93 15.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55714",
    "data-name": "Path 55714",
    d: "M1564.032,1498.485h-.476l-.019-.142.48-.1Z",
    transform: "translate(-1563.537 -1498.239)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370",
    transform: "translate(15.628 15.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55715",
    "data-name": "Path 55715",
    d: "M1536.784,1496.572h.476l.02.141-.48.1Q1536.792,1496.695,1536.784,1496.572Z",
    transform: "translate(-1536.784 -1496.572)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371",
    transform: "translate(25.658 14.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55716",
    "data-name": "Path 55716",
    d: "M1569.6,1495.7h-.476l-.022-.137.467-.112Z",
    transform: "translate(-1569.104 -1495.456)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372",
    transform: "translate(3.544 7.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55717",
    "data-name": "Path 55717",
    d: "M1498.343,1471.643h-.476l-.022-.137.467-.111C1498.322,1471.478,1498.332,1471.56,1498.343,1471.643Z",
    transform: "translate(-1497.844 -1471.395)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373",
    transform: "translate(0.397 3.902)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    cx: 0.102,
    cy: 0.406,
    rx: 0.102,
    ry: 0.406,
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374",
    transform: "translate(4.942 11.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55718",
    "data-name": "Path 55718",
    d: "M1502.349,1483.559l.549-.047.025.186-.559.109Z",
    transform: "translate(-1502.349 -1483.512)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375",
    transform: "translate(15.545 15.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55719",
    "data-name": "Path 55719",
    d: "M1536.518,1498.584l.2-.234.091.091-.235.2Z",
    transform: "translate(-1536.518 -1498.35)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376",
    transform: "translate(5.781 16.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55720",
    "data-name": "Path 55720",
    d: "M1505.109,1499.093l.235.2-.091.091-.2-.235Z",
    transform: "translate(-1505.053 -1499.093)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(16.15 10.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55721",
    "data-name": "Path 55721",
    d: "M1538.466,1480.064h.287v.1h-.287Z",
    transform: "translate(-1538.466 -1480.064)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(21.702 12.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55722",
    "data-name": "Path 55722",
    d: "M1556.454,1486.234v.287h-.1v-.287Z",
    transform: "translate(-1556.358 -1486.234)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379",
    transform: "translate(12.225 10.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55723",
    "data-name": "Path 55723",
    d: "M1525.818,1480.043v-.287h.1v.287Z",
    transform: "translate(-1525.818 -1479.756)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380",
    transform: "translate(1.599 8.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55724",
    "data-name": "Path 55724",
    d: "M1491.576,1474.49v-.287h.1v.287Z",
    transform: "translate(-1491.576 -1474.203)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381",
    transform: "translate(3.85 14.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55725",
    "data-name": "Path 55725",
    d: "M1499.067,1493.924l-.238-.193.238-.095Z",
    transform: "translate(-1498.829 -1493.637)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382",
    transform: "translate(4.088 14.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55726",
    "data-name": "Path 55726",
    d: "M1499.884,1494.563l-.192.238-.095-.238Z",
    transform: "translate(-1499.597 -1494.563)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383",
    transform: "translate(15.545 14.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55727",
    "data-name": "Path 55727",
    d: "M1536.574,1494.466l.235.2-.091.091-.2-.235Z",
    transform: "translate(-1536.518 -1494.466)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384",
    transform: "translate(23.425 14.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55728",
    "data-name": "Path 55728",
    d: "M1562.006,1494.563v.287h-.1v-.287Z",
    transform: "translate(-1561.91 -1494.563)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385",
    transform: "translate(1.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55729",
    "data-name": "Path 55729",
    d: "M1490.747,1447.365v.287h-.1v-.287Z",
    transform: "translate(-1490.651 -1447.365)",
    fill: "#297ee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386",
    transform: "translate(5.524 12.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55730",
    "data-name": "Path 55730",
    d: "M1504.224,1489.01l.287.287Z",
    transform: "translate(-1504.224 -1489.01)",
    fill: "#297ee8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CXtvMH.tif",
    transform: "translate(186.357 611.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388",
    transform: "translate(8.493 19.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55731",
    "data-name": "Path 55731",
    d: "M469.263,1496.275c-.01-.173-.01-.358-.01-.559l-.449-.206c0-.125,0-.236-.012-.357,0,0,.018.019.032.034l.183-.156-.071-.071a1.28,1.28,0,0,0-.145.194c-.234-.021-.427.585-.722.005-.325.176-.51.707-1.024.372v-.494l-.488-.16v-.611l.424-.285-.288-.6-1.049.288c.217.3.688.512.4,1.017h-.914l-.374.374.386.325.293-.542c.459.4.71.825,1.275.837.133,0,.259.374.363.537l-.66.988c-.5-.11-.342-.331-.109-.55l-.288-.581-.258.215-.552-.749-.609.839-1.258-.564-1.205.223c-.258-.4.244-.5.377-.762v-.925l.6-.411c-.158-.358-.352-.772.122-1.186l-.44-.09v-1.345l.521.169.715-.2.923-1.084-.228-.527,1.08-.378c.038.208.074.4.116.634l.357.124c.234.634-.145,1.168-.233,1.742-.159,0-.271,0-.393.012,0,0,.019-.017.034-.032l-.156-.184-.071.071a1.26,1.26,0,0,0,.194.145c.059.422.457.064.69.4l.319.93.525-.494.5.5a1.907,1.907,0,0,1,.022-.761c.1-.194.241-.35.191-.6a.4.4,0,0,0,.032.034l.184-.157-.071-.071a1.239,1.239,0,0,0-.145.194c-.408.114-.707-.219-1.168-.27l.321-1.481h.563l.135.413h.61l-.244.783.486.2v.9c.222-.11.339-.171.458-.225.094-.042.192-.076.407-.16-.049.264-.082.439-.127.687l.859.128-.332.783c-.349.181-.6.019-.919-.6h-.553c-.008.124-.06.28-.014.318.407.334.83.647,1.218.942l.446-.187c.314.533-.093.764-.461,1.192l1.022-.268.225.225c-.294.5-.767.91-.694,1.59.016.145-.223.317-.372.513l-.4-.285-.286.262-.375-.957c.284,0,.42,0,.567-.012a.384.384,0,0,0-.034.032l.157.184.071-.071A1.245,1.245,0,0,0,469.263,1496.275Zm-4.317-4.225-.9.3.9.4c0-.3,0-.519.015-.755l.044.044.183-.157-.071-.071A1.52,1.52,0,0,0,464.946,1492.05Zm-1.548,2.782.759.361.542-1.1-.158-.158.411-.433-.294-.579-.939.276Zm4.245-.807.406.723.411-.665Zm-3.332-2.625v.112h.449v-.112Zm3.444,2.19h.075v-.225h-.075Zm-4.268-.9h.075v-.224h-.075Zm2.172-1.872v-.075h-.225v.075Z",
    transform: "translate(-462.058 -1489.294)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389",
    transform: "translate(4.577 19.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55732",
    "data-name": "Path 55732",
    d: "M450.442,1490.575l.6.154.32-.961-.426-.136v-.748c.492-.151.549-.838,1.117-1.032l.308.24.231-.2.321.321c-.2.132-.5.222-.591.41a.724.724,0,0,1-.545.463c.043.2.1.392.125.592a5.274,5.274,0,0,1,0,.588l.9-.783h.514a.994.994,0,0,1-.407,1.094l-.074-.186-.151.186-.186.074.186.151.074.186.151-.186a2.055,2.055,0,0,1,.393.074c0,.354.335.373.593.5l-.3.483.627.438-.821.113v.576h-.925c-.088-.562.429-.507.659-.729,0-.11,0-.221-.012-.341a.442.442,0,0,0,.032.034l.183-.157-.071-.071a1.293,1.293,0,0,0-.145.194c-.139-.069-.29-.149-.469-.243l-.331.253-.949-.309-.108-.725-.246.6-1.042-.145-.541-.889.552-.1.224.225.076.427.148-.016Zm2.246.824v-.075h-.225v.075Z",
    transform: "translate(-449.441 -1487.852)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390",
    transform: "translate(5.803 15.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55733",
    "data-name": "Path 55733",
    d: "M454.749,1478.317c-.161-.159-.313-.33-.567-.618l-.179.832c-.369.061-.466-.057-.612-.7a2.667,2.667,0,0,1,2.426-.812v-.652l.976-.081a1.589,1.589,0,0,0-.177.286c-.038.134-.054.274-.08.412h-.461l.285.5-1.049.8,1.028.39-.359,1.342-.778-.738-.051-.452c-.069.021-.144.02-.167.054-.173.265-.335.536-.521.839l-.323-.3.229-1.09c.093,0,.232,0,.38-.012,0,0-.019.018-.034.032l.157.183.071-.071A1.276,1.276,0,0,0,454.749,1478.317Z",
    transform: "translate(-453.391 -1476.284)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(16.555 20.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55734",
    "data-name": "Path 55734",
    d: "M488.518,1495.979c.012-.281-.09-.594.214-.794l-.694-.4.694-.847c.006-.1.02-.351.034-.625l.561-.052.465-.97-.572.32c-.375-.066-.4-.254-.325-.616.052-.238-.135-.529-.2-.741.236-.388.495-.536.866-.409.253.437-.047.812-.233,1.342l.861-.251.336.316-.227.278.281.625-.49.229v.347a.6.6,0,0,0-.675.416c-.131.282-.27.56-.433.9l.429.346c.041.543-.137.835-.669.81Z",
    transform: "translate(-488.039 -1490.802)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392",
    transform: "translate(3.779 16.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55735",
    "data-name": "Path 55735",
    d: "M447.321,1478.6l.561-.294.178.546-.548.347,1.036.352.471.958c-.042.209-.093.461-.147.73l.7.111-1.507,1.509h-.644l-.3-.588c.1-.267.61.165.65-.3h.364l.261-1.511-.581-.443-.943-.293C446.834,1479.276,447.209,1478.991,447.321,1478.6Z",
    transform: "translate(-446.869 -1478.308)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393",
    transform: "translate(4.611 12.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55736",
    "data-name": "Path 55736",
    d: "M452.09,1468.2l-.546-.383-.686.219-.262-.487-1.045-.05.288-.913,1.129-.858.225-.225,1.348.449-.225.674h-.583l-.142-.418-.586.274.265.556.508-.256C451.824,1467.3,452.177,1467.683,452.09,1468.2Z",
    transform: "translate(-449.55 -1465.502)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(14.788 20.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55737",
    "data-name": "Path 55737",
    d: "M483.93,1491.391c.151.109.314.229.538.393l-.368.437c-.043.015-.088.037-.093.031a3.318,3.318,0,0,0-1.505-.941l.686-.5c0-.008-.035-.1-.069-.1-.258-.011-.515-.006-.773-.006v-.592c.509-.341.93.416,1.422.131l.78-.574.056.72-.687.437c0,.178,0,.365.012.562a.461.461,0,0,0-.032-.034l-.184.156.071.071A1.253,1.253,0,0,0,483.93,1491.391Z",
    transform: "translate(-482.346 -1489.672)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(2.97 14.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55738",
    "data-name": "Path 55738",
    d: "M445.523,1473.075h-.8l-.208-.445-.256.218c.012-.543.012-.543.855-.822-.155-.032-.256-.057-.357-.074s-.209-.025-.4-.047l.186-.5-.2-.7,1.04-.416.383.53-.419.567c.172.2.323.441-.042.659C445.678,1472.331,445.466,1472.731,445.523,1473.075Zm-.525-2.021h-.075v.224H445Z",
    transform: "translate(-444.262 -1470.294)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(1.795 11.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55739",
    "data-name": "Path 55739",
    d: "M441.579,1462.377l.574.22.372-.265.395.737a4.3,4.3,0,0,1-1.563,1.913l.294.493-.442.1-.175-.433-.56-.061v-.583l1.143-.424.682-1.008-.794-.576Z",
    transform: "translate(-440.475 -1462.332)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397",
    transform: "translate(4.351 15.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55740",
    "data-name": "Path 55740",
    d: "M448.711,1474.673l.371-.887.889.069.807.65-.128.165.237.408-.568.461Z",
    transform: "translate(-448.711 -1473.786)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(8.971 19.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55741",
    "data-name": "Path 55741",
    d: "M464.044,1488.2l1.053.218c.4.24.247.607.285,1l-.926.1.289.368-.542.7-.428-.62.176-.374c-.029-.067-.084-.2-.15-.337s-.134-.24-.2-.357Zm.432.651v.112h.449v-.112Z",
    transform: "translate(-463.601 -1488.196)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399",
    transform: "translate(7.816 14.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55742",
    "data-name": "Path 55742",
    d: "M460.111,1470.484c.328-.149.6.192.959.085.256-.076.58.11.877.133.357.028.718.006,1.1.006-.05.566-.367.593-.735.715-.245.081-.57-.137-.739.178l-.474-.452-.748.256c-.343-.156-.52-.356-.467-.7Z",
    transform: "translate(-459.877 -1470.445)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(17.37 26.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55743",
    "data-name": "Path 55743",
    d: "M491.9,1509.85l.419-.314.375.844,1.534.58c-.113.113-.141.164-.165.162a4.639,4.639,0,0,0-1.64-.1c-.562.181-1.063.027-1.751.171l.4-.737.371.274.646-.628Z",
    transform: "translate(-490.667 -1509.536)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401",
    transform: "translate(21.323 24.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55744",
    "data-name": "Path 55744",
    d: "M505.59,1506.037l.162.428-.247.581-.446-.34-.227.227-.859-1.1-.568-.085v-1.036h.857l-.143.585,1.049.942Z",
    transform: "translate(-503.405 -1504.713)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402",
    transform: "translate(10.402 17.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55745",
    "data-name": "Path 55745",
    d: "M470.575,1483.362l-.323.151c-.456-.041-.329-.469-.349-.718h-.648v.5H468.21l.916-1.345.443.256.3-.211c.495.122.428.775.928.821a3.044,3.044,0,0,1,0,.319Z",
    transform: "translate(-468.21 -1481.953)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3403",
    "data-name": "Group 3403",
    transform: "translate(0.595 9.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55746",
    "data-name": "Path 55746",
    d: "M438.5,1457.038l-.761-.374.226-.466-.211-.226a3.721,3.721,0,0,1-.738.122c-.111,0-.219-.178-.407-.345l.405-.164-.088-.118h1.948q.013.27.028.6l-.588.062C438.371,1456.418,438.43,1456.707,438.5,1457.038Z",
    transform: "translate(-436.607 -1455.466)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404",
    transform: "translate(24.688 26.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55747",
    "data-name": "Path 55747",
    d: "M516.253,1510.38v.9l-.361.431c-.589.121-1.085-.139-1.644-.782l1.07-.151.1-.4Z",
    transform: "translate(-514.248 -1510.38)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405",
    transform: "translate(15.14 18.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55748",
    "data-name": "Path 55748",
    d: "M483.945,1484.874l1.369.641.407-.165a.658.658,0,0,1-.269.946l-.114-.427H484l-.514-.428Z",
    transform: "translate(-483.481 -1484.874)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406",
    transform: "translate(23.959 23.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55749",
    "data-name": "Path 55749",
    d: "M513.671,1499.642l.288.322c0,.387-.268.509-.894.443l.267-.3-.6-.058-.472.472-.358-.453.306-.425Z",
    transform: "translate(-511.899 -1499.642)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(13.67 26.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55750",
    "data-name": "Path 55750",
    d: "M479.38,1511.7l.286-.35c-.534-.055-1.072-.129-.888-.953.208.041.431.079.653.129.2.046.406.1.631.16v1.014Z",
    transform: "translate(-478.741 -1510.396)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408",
    transform: "translate(19.373 24.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55751",
    "data-name": "Path 55751",
    d: "M497.12,1505.188l.491-.562h.5l.6,1-.5.4Z",
    transform: "translate(-497.12 -1504.626)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3409",
    "data-name": "Group 3409",
    transform: "translate(12.686 18.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55752",
    "data-name": "Path 55752",
    d: "M475.878,1485.77h.406c.023.342.047.69.073,1.072.092.016.2.07.29.042s.164-.138.309-.271c.02.251.037.451.065.784l-.737-.295-.19.14-.519-.233.324-.555-.244-.46Z",
    transform: "translate(-475.573 -1485.77)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3410",
    "data-name": "Group 3410",
    transform: "translate(18.033 18.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55753",
    "data-name": "Path 55753",
    d: "M493.323,1486.118l-.521-.509c.462-.687,1.091-.6,1.669-.847v.7a2.23,2.23,0,0,0-.595.141A3.311,3.311,0,0,0,493.323,1486.118Z",
    transform: "translate(-492.802 -1484.763)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411",
    transform: "translate(3.575 19.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55754",
    "data-name": "Path 55754",
    d: "M447.37,1487.534l-.878-.416-.279-.885.641.27.741-.311C447.51,1486.7,447.449,1487.059,447.37,1487.534Z",
    transform: "translate(-446.213 -1486.192)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412",
    transform: "translate(0.606 3.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55755",
    "data-name": "Path 55755",
    d: "M437.178,1435.578a1.532,1.532,0,0,1,.349,1.387h-.772C436.532,1436.766,436.637,1436.331,437.178,1435.578Z",
    transform: "translate(-436.645 -1435.578)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413",
    transform: "translate(5.116 11.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55756",
    "data-name": "Path 55756",
    d: "M452.089,1463.028h-.569l-.344-1,.479-.437c.1.141.158.215.208.292.075.116.138.241.22.351.065.088.182.147.221.242a.927.927,0,0,1,.009.329Z",
    transform: "translate(-451.177 -1461.589)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414",
    transform: "translate(28.034 26.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55757",
    "data-name": "Path 55757",
    d: "M526.317,1510.957l-.44-.308-.3.528c-.357,0-.456-.153-.549-.888l.839.1.862-.151Z",
    transform: "translate(-525.031 -1510.233)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415",
    transform: "translate(7.207 9.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55758",
    "data-name": "Path 55758",
    d: "M459.224,1457.412l-.375.374-.677-.3-.257-.508.324-.411C458.572,1456.875,459.153,1456.822,459.224,1457.412Z",
    transform: "translate(-457.916 -1456.564)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(2.169 5.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55759",
    "data-name": "Path 55759",
    d: "M442.913,1443.614l-.637.323-.381-.356.244-.407-.457-.208.3-.529c.082.033.154.037.18.075C442.4,1442.851,442.629,1443.2,442.913,1443.614Z",
    transform: "translate(-441.681 -1442.437)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417",
    transform: "translate(5.521 23.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55760",
    "data-name": "Path 55760",
    d: "M452.932,1503.035l-.451-.156.368-.627.887,1.242-.475.56C452.948,1503.684,452.8,1503.451,452.932,1503.035Z",
    transform: "translate(-452.481 -1502.251)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418",
    transform: "translate(6.962 24.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55761",
    "data-name": "Path 55761",
    d: "M458.008,1505.5l-.329,1.044h-.554V1505.5Z",
    transform: "translate(-457.125 -1505.5)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419",
    transform: "translate(24.495 25.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55762",
    "data-name": "Path 55762",
    d: "M514.981,1505.868c-.212.808-.732.909-1.29.963-.119-.63-.117-.615.326-.691C514.283,1506.094,514.54,1505.995,514.981,1505.868Z",
    transform: "translate(-513.625 -1505.868)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3420",
    "data-name": "Group 3420",
    transform: "translate(8.914 17.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55763",
    "data-name": "Path 55763",
    d: "M464.8,1482.979l-1.387-.359,1.013-.715Z",
    transform: "translate(-463.417 -1481.905)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421",
    transform: "translate(6.886 15.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55764",
    "data-name": "Path 55764",
    d: "M457.769,1473.333v.889h-.889A1.081,1.081,0,0,1,457.769,1473.333Z",
    transform: "translate(-456.88 -1473.333)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422",
    transform: "translate(3.974 4.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55765",
    "data-name": "Path 55765",
    d: "M448.8,1440.019l-.9.431-.4-.894c.13-.053.214-.12.254-.1C448.063,1439.612,448.367,1439.784,448.8,1440.019Z",
    transform: "translate(-447.496 -1439.453)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423",
    transform: "translate(10.584 12.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55766",
    "data-name": "Path 55766",
    d: "M469.691,1464.894l-.894-.481.895-.521.368.633Z",
    transform: "translate(-468.797 -1463.892)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424",
    transform: "translate(8.948 16.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55767",
    "data-name": "Path 55767",
    d: "M463.526,1478.516c.38.033.82-.151,1.115.356l-.576.409C463.978,1479.429,463.662,1479,463.526,1478.516Z",
    transform: "translate(-463.526 -1478.51)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425",
    transform: "translate(20.216 22.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55768",
    "data-name": "Path 55768",
    d: "M499.836,1497.561l.631.568v.462l-.631.034Z",
    transform: "translate(-499.836 -1497.561)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(0.867 1.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55769",
    "data-name": "Path 55769",
    d: "M438.043,1430.754l.315.635-.718.344c-.088-.139-.161-.2-.155-.253C437.539,1431.019,437.543,1431.02,438.043,1430.754Z",
    transform: "translate(-437.485 -1430.754)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427",
    transform: "translate(2.879 10.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55770",
    "data-name": "Path 55770",
    d: "M444.966,1458.542l-.482.577c-.472-.25-.662-.52-.388-1.01Z",
    transform: "translate(-443.969 -1458.11)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428",
    transform: "translate(26.331 24.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55771",
    "data-name": "Path 55771",
    d: "M520.443,1502.468l-.349.979-.551-.781C519.623,1502.42,519.917,1502.384,520.443,1502.468Z",
    transform: "translate(-519.543 -1502.427)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429",
    transform: "translate(0.182 5.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55772",
    "data-name": "Path 55772",
    d: "M436.414,1443.021l-.331.331-.8-.887.132-.267C435.87,1442.352,436.077,1442.764,436.414,1443.021Z",
    transform: "translate(-435.279 -1442.198)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    transform: "translate(8.936 26.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55773",
    "data-name": "Path 55773",
    d: "M464.33,1512.647h-.744c-.213-.359-.063-.614.293-.907Z",
    transform: "translate(-463.489 -1511.74)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(21.195 18.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55774",
    "data-name": "Path 55774",
    d: "M503.583,1484.788l.264.3-.472.524-.383-.284Z",
    transform: "translate(-502.993 -1484.788)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432",
    transform: "translate(27.591 24.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55775",
    "data-name": "Path 55775",
    d: "M524.466,1503.116h-.545l-.317-.317.317-.317h.545Z",
    transform: "translate(-523.604 -1502.482)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433",
    transform: "translate(23.535 26.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55776",
    "data-name": "Path 55776",
    d: "M510.532,1511.6l.667-.6c.109.045.165.053.169.072.037.173.065.349.092.505l-.32.32Z",
    transform: "translate(-510.532 -1511.001)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(3.109 17.772)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55777",
    "data-name": "Path 55777",
    d: "M445.778,1483.254l-.492.07-.575-1.1C445.475,1482.173,445.335,1482.882,445.778,1483.254Z",
    transform: "translate(-444.711 -1482.217)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435",
    transform: "translate(21.065 27.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55778",
    "data-name": "Path 55778",
    d: "M504.112,1513.646h-1.485c-.016-.078-.037-.178-.055-.265.335-.426.732.231,1.077-.08A3.333,3.333,0,0,1,504.112,1513.646Z",
    transform: "translate(-502.573 -1513.233)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436",
    transform: "translate(13.197 18.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55779",
    "data-name": "Path 55779",
    d: "M477.3,1483.438l.526.228.213-.184.3.393-.389.192-.73-.23Z",
    transform: "translate(-477.218 -1483.438)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437",
    transform: "translate(28.031 24.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55780",
    "data-name": "Path 55780",
    d: "M525.02,1505.65l.352-.352.686.054-.518.713Z",
    transform: "translate(-525.02 -1505.298)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438",
    transform: "translate(7.6 12.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55781",
    "data-name": "Path 55781",
    d: "M459.183,1465.257l.29-.761.609.312C459.956,1465.305,459.566,1465.276,459.183,1465.257Z",
    transform: "translate(-459.183 -1464.496)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439",
    transform: "translate(3.145 0.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55782",
    "data-name": "Path 55782",
    d: "M445.735,1426.691l-.909-.074.753-.8Z",
    transform: "translate(-444.826 -1425.812)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440",
    transform: "translate(16.173 14.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55783",
    "data-name": "Path 55783",
    d: "M487.689,1472.587l-.074.909-.8-.753Z",
    transform: "translate(-486.81 -1472.587)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441",
    transform: "translate(17.225 26.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55784",
    "data-name": "Path 55784",
    d: "M490.2,1509.61l.472-.166.36.22-.487.571Z",
    transform: "translate(-490.199 -1509.444)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(7.791 20.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55785",
    "data-name": "Path 55785",
    d: "M459.8,1489.721l.766.44-.642.492Z",
    transform: "translate(-459.796 -1489.721)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443",
    transform: "translate(23.348 25.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55786",
    "data-name": "Path 55786",
    d: "M510.174,1507.144l-.244-.369.587-.445.077.776Z",
    transform: "translate(-509.93 -1506.33)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444",
    transform: "translate(7.376 13.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55787",
    "data-name": "Path 55787",
    d: "M458.459,1469.108a.553.553,0,0,1,.674.449l-.224.225h-.449Z",
    transform: "translate(-458.459 -1469.102)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445",
    transform: "translate(13.632 19.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55788",
    "data-name": "Path 55788",
    d: "M478.62,1486.554h.66l.075.388-.65.052Z",
    transform: "translate(-478.62 -1486.554)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(12.13 15.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55789",
    "data-name": "Path 55789",
    d: "M474.155,1477.057h-.375v-.636h.375Z",
    transform: "translate(-473.78 -1476.42)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(10.778 27.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55790",
    "data-name": "Path 55790",
    d: "M469.423,1513.141l.524-.66.32.66Z",
    transform: "translate(-469.423 -1512.481)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(28.205 22.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55791",
    "data-name": "Path 55791",
    d: "M526.209,1497.395l-.626-.335.427-.34.361.483Z",
    transform: "translate(-525.583 -1496.719)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    transform: "translate(18.159 25.826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55792",
    "data-name": "Path 55792",
    d: "M493.763,1508.856h-.5l-.053-.64.15-.046Z",
    transform: "translate(-493.207 -1508.17)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(26.474 25.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55793",
    "data-name": "Path 55793",
    d: "M520,1508.556l.324-.324.3.278C520.3,1508.9,520.3,1508.9,520,1508.556Z",
    transform: "translate(-520.004 -1508.232)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(7.535 26.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55794",
    "data-name": "Path 55794",
    d: "M458.973,1511.255l.206-.5.622.5Z",
    transform: "translate(-458.973 -1510.753)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(20.739 20.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55795",
    "data-name": "Path 55795",
    d: "M502.229,1492.2l-.706-.519h.806Z",
    transform: "translate(-501.523 -1491.682)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(16.787 17.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55796",
    "data-name": "Path 55796",
    d: "M488.9,1482.8l-.112-.516h.8Z",
    transform: "translate(-488.786 -1482.28)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454",
    transform: "translate(0 3.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55797",
    "data-name": "Path 55797",
    d: "M435.21,1437.609l-.519.1v-.807Z",
    transform: "translate(-434.691 -1436.898)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(8.832 10.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55798",
    "data-name": "Path 55798",
    d: "M463.862,1460.09l.1.519h-.807Z",
    transform: "translate(-463.151 -1460.09)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456",
    transform: "translate(2.188 8.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55799",
    "data-name": "Path 55799",
    d: "M442.489,1451.187l-.632.334-.115-.426C442.032,1450.976,442.275,1450.9,442.489,1451.187Z",
    transform: "translate(-441.741 -1450.987)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457",
    transform: "translate(2.866 8.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55800",
    "data-name": "Path 55800",
    d: "M443.927,1451.838h.809l-.692.544Z",
    transform: "translate(-443.927 -1451.838)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(5.151 9.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55801",
    "data-name": "Path 55801",
    d: "M451.606,1456.816l.33.33-.358.381-.287-.4Z",
    transform: "translate(-451.291 -1456.816)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(5.13 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55802",
    "data-name": "Path 55802",
    d: "M451.221,1494.748l.342-.52.218.55-.111.195h-.225Z",
    transform: "translate(-451.221 -1494.228)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460",
    transform: "translate(1.104 11.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55803",
    "data-name": "Path 55803",
    d: "M438.248,1461.362v-.677c.256.046.449.136.428.5Z",
    transform: "translate(-438.248 -1460.685)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    transform: "translate(18.598 23.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55804",
    "data-name": "Path 55804",
    d: "M494.622,1500.217l.427.033c.011.135.02.232.032.382l-.423.046Z",
    transform: "translate(-494.622 -1500.217)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(6.484 23.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55805",
    "data-name": "Path 55805",
    d: "M456.012,1501.758v.546l-.425.09.313-.72Z",
    transform: "translate(-455.587 -1501.673)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    transform: "translate(19.3 17.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55806",
    "data-name": "Path 55806",
    d: "M496.885,1480.387v-.4l.331-.063C497.39,1480.221,497.386,1480.406,496.885,1480.387Z",
    transform: "translate(-496.885 -1479.923)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464",
    transform: "translate(8.49 12.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55807",
    "data-name": "Path 55807",
    d: "M462.049,1464.511l.033-.427.382-.032c.015.136.029.259.047.423Z",
    transform: "translate(-462.049 -1464.052)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465",
    transform: "translate(19.477 26.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55808",
    "data-name": "Path 55808",
    d: "M497.934,1509.846v.326l-.394.082-.083-.408Z",
    transform: "translate(-497.457 -1509.846)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466",
    transform: "translate(19.505 22.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55809",
    "data-name": "Path 55809",
    d: "M497.546,1497.7v-.326l.394-.082.083.408Z",
    transform: "translate(-497.546 -1497.295)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3467",
    "data-name": "Group 3467",
    transform: "translate(4.006 2.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55810",
    "data-name": "Path 55810",
    d: "M447.6,1433.281v-.325l.394-.082.083.408Z",
    transform: "translate(-447.601 -1432.873)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468",
    transform: "translate(26.684 27.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55811",
    "data-name": "Path 55811",
    d: "M520.68,1513.246l.427.034c.011.135.02.232.032.382l-.423.046C520.7,1513.524,520.691,1513.39,520.68,1513.246Z",
    transform: "translate(-520.68 -1513.246)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3469",
    "data-name": "Group 3469",
    transform: "translate(0.469 7.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55812",
    "data-name": "Path 55812",
    d: "M436.313,1448.854v.674H436.2v-.674Z",
    transform: "translate(-436.201 -1448.854)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3470",
    "data-name": "Group 3470",
    transform: "translate(1.78 6.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55813",
    "data-name": "Path 55813",
    d: "M440.527,1447.135l.25.5C440.561,1447.671,440.269,1447.784,440.527,1447.135Z",
    transform: "translate(-440.426 -1447.135)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471",
    transform: "translate(14.183 17.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55814",
    "data-name": "Path 55814",
    d: "M480.464,1480.62l.168.468C480.417,1481.181,480.322,1481.043,480.464,1480.62Z",
    transform: "translate(-480.397 -1480.62)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472",
    transform: "translate(0.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55815",
    "data-name": "Path 55815",
    d: "M437.995,1425.425l-.219-.448C438.05,1424.877,438.143,1425.013,437.995,1425.425Z",
    transform: "translate(-437.776 -1424.946)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473",
    transform: "translate(22.909 27.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55816",
    "data-name": "Path 55816",
    d: "M508.516,1514.124h.6l.012.114-.589.085C508.529,1514.257,508.523,1514.19,508.516,1514.124Z",
    transform: "translate(-508.516 -1514.124)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474",
    transform: "translate(27.402 27.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55817",
    "data-name": "Path 55817",
    d: "M522.993,1514.124h.6c0,.038.008.076.012.114l-.588.085C523.006,1514.257,523,1514.19,522.993,1514.124Z",
    transform: "translate(-522.993 -1514.124)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475",
    transform: "translate(13.16 22.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55818",
    "data-name": "Path 55818",
    d: "M477.1,1498.083l.436-.083.134.638Z",
    transform: "translate(-477.098 -1498)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476",
    transform: "translate(26.636 21.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55819",
    "data-name": "Path 55819",
    d: "M520.724,1495.184l-.2-.553C520.761,1494.575,520.761,1494.575,520.724,1495.184Z",
    transform: "translate(-520.526 -1494.608)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    transform: "translate(5.261 21.154)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 0.318,
    cy: 0.079,
    rx: 0.318,
    ry: 0.079,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478",
    transform: "translate(2.233 11.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55820",
    "data-name": "Path 55820",
    d: "M442.278,1463.5h-.372c-.006-.036-.012-.071-.018-.107l.365-.087C442.261,1463.371,442.27,1463.435,442.278,1463.5Z",
    transform: "translate(-441.888 -1463.306)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3479",
    "data-name": "Group 3479",
    transform: "translate(12.78 24.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55821",
    "data-name": "Path 55821",
    d: "M475.911,1504.335l-.037-.431.145-.018.086.439Z",
    transform: "translate(-475.874 -1503.886)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3480",
    "data-name": "Group 3480",
    transform: "translate(30.792 25.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55822",
    "data-name": "Path 55822",
    d: "M533.919,1507.21v-.449h.112v.449Z",
    transform: "translate(-533.919 -1506.761)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481",
    transform: "translate(30.587 26.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55823",
    "data-name": "Path 55823",
    d: "M533.331,1509.656v.225h-.075v-.225Z",
    transform: "translate(-533.256 -1509.656)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3482",
    "data-name": "Group 3482",
    transform: "translate(20.928 26.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55824",
    "data-name": "Path 55824",
    d: "M502.205,1511.1v.225h-.075v-.225Z",
    transform: "translate(-502.13 -1511.104)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3483",
    "data-name": "Group 3483",
    transform: "translate(7.825 22.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55825",
    "data-name": "Path 55825",
    d: "M460.131,1496.627v.225h-.224v-.225Z",
    transform: "translate(-459.907 -1496.627)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    "data-name": "Group 3484",
    transform: "translate(17.109 27.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55826",
    "data-name": "Path 55826",
    d: "M489.9,1514v.225h-.075V1514Z",
    transform: "translate(-489.825 -1513.999)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485",
    transform: "translate(23.502 22.753)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_220",
    "data-name": "Ellipse 220",
    cx: 0.159,
    cy: 0.053,
    rx: 0.159,
    ry: 0.053,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3486",
    "data-name": "Group 3486",
    transform: "translate(13.515 15.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55827",
    "data-name": "Path 55827",
    d: "M478.319,1474.188v.225h-.075v-.225Z",
    transform: "translate(-478.244 -1474.188)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3487",
    "data-name": "Group 3487",
    transform: "translate(2.679 11.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55828",
    "data-name": "Path 55828",
    d: "M443.509,1462.177l-.184-.157.071-.071.157.183Z",
    transform: "translate(-443.325 -1461.95)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    transform: "translate(2.411 10.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55829",
    "data-name": "Path 55829",
    d: "M442.5,1460.36l.184.156-.071.071-.156-.183Z",
    transform: "translate(-442.459 -1460.36)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3489",
    "data-name": "Group 3489",
    transform: "translate(19.131 21.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55830",
    "data-name": "Path 55830",
    d: "M496.34,1493.957v-.225h.075v.225Z",
    transform: "translate(-496.34 -1493.732)",
    fill: "#ccc"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplied);
export default __webpack_public_path__ + "static/media/jobApplied.038cf6b95c42144a7d16525a4fe86932.svg";
export { ForwardRef as ReactComponent };